import * as reactRouter from 'react-router-dom';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import React__default from 'react';
import classNames from 'classnames';
import * as heroIcons from '@heroicons/react/outline';
import * as genericUtils from '@tolk-ai/generic-utils';
import * as Highcharts from 'highcharts';
import highchartMore from 'highcharts/highcharts-more';
import exporting from 'highcharts/modules/exporting';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import * as highchartsReact from 'highcharts-react-official';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { LicenseInfo } from '@mui/x-license-pro';
import moment from 'moment';

const onAccordionClick = (state, setState) => () => {
  if (state.isOpen === true) {
    setState({
      isOpen: false
    });
  }

  if (state.isOpen === false) {
    setState({
      isOpen: true
    });
  }
};

var styles$18 = {"accordion":"index-module_accordion__XI1mY","accordion--open":"index-module_accordion--open__8DJ0n","accordion__header":"index-module_accordion__header__Cz0zu","accordion__collapse-button":"index-module_accordion__collapse-button__LQUu3","accordion__delete-button":"index-module_accordion__delete-button__90nhO","accordion__collapse-button--open":"index-module_accordion__collapse-button--open__NrJEd","accordion__delete-button--open":"index-module_accordion__delete-button--open__pDEHE","accordion__icon":"index-module_accordion__icon__RT4L5","accordion__icon--collapse":"index-module_accordion__icon--collapse__WVjzw","accordion__icon--delete":"index-module_accordion__icon--delete__W7BVd","accordion__title":"index-module_accordion__title__gEFG7","accordion__content":"index-module_accordion__content__aDQIZ"};

const component$G = Icon => ({
  title,
  children,
  isOpen: _isOpen = false,
  deleteButton
}) => {
  const [state, setState] = React__default.useState({
    isOpen: _isOpen
  });
  return jsxs("div", Object.assign({
    className: classNames(styles$18.accordion, {
      [styles$18['accordion--open']]: state.isOpen === true
    })
  }, {
    children: [jsxs("h3", Object.assign({
      className: styles$18.accordion__header
    }, {
      children: [jsxs("button", Object.assign({
        className: classNames(styles$18['accordion__collapse-button'], {
          [styles$18['accordion__collapse-button--open']]: state.isOpen === true
        }),
        onClick: onAccordionClick(state, setState),
        type: "button"
      }, {
        children: [jsx(Icon, {
          className: classNames(styles$18.accordion__icon, styles$18['accordion__icon--collapse']),
          icon: state.isOpen === true ? 'ChevronUpIcon' : 'ChevronDownIcon'
        }, void 0), jsx("span", Object.assign({
          className: styles$18.accordion__title
        }, {
          children: title
        }), void 0)]
      }), void 0), typeof deleteButton !== 'undefined' && jsxs("button", Object.assign({
        className: classNames(styles$18['accordion__delete-button'], {
          [styles$18['accordion__delete-button--open']]: state.isOpen === true
        }),
        name: deleteButton.name,
        // eslint-disable-next-line react/jsx-handler-names
        onClick: deleteButton.onDeleteButtonClick,
        type: "button"
      }, {
        children: [jsx("span", Object.assign({
          className: "sr-only"
        }, {
          children: "Delete accordion button"
        }), void 0), jsx(Icon, {
          className: classNames(styles$18.accordion__icon, styles$18['accordion__icon--delete']),
          icon: "XIcon"
        }, void 0)]
      }), void 0)]
    }), void 0), state.isOpen === true && jsx("div", Object.assign({
      className: styles$18.accordion__content
    }, {
      children: children
    }), void 0)]
  }), void 0);
};

var index$1g = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$G
});

var styles$17 = {"banner":"index-module_banner__DU4b9","banner__label":"index-module_banner__label__evCgm","banner__external-link":"index-module_banner__external-link__6rzJ-","banner__internal-link":"index-module_banner__internal-link__Ds-2b"};

const component$F = (ExternalLinkComponent, InternalLinkComponent) => ({
  children,
  link
}) => jsxs("section", Object.assign({
  className: styles$17.banner
}, {
  children: [jsx("p", Object.assign({
    className: classNames('text-medium-base-light', styles$17.banner__label)
  }, {
    children: children
  }), void 0), (link === null || link === void 0 ? void 0 : link.type) === 'internal' && jsx(InternalLinkComponent, Object.assign({
    className: styles$17['banner__external-link'],
    path: link.path
  }, {
    children: link.label
  }), void 0), (link === null || link === void 0 ? void 0 : link.type) === 'external' && jsx(ExternalLinkComponent, Object.assign({
    className: styles$17['banner__external-link'],
    url: link.url
  }, {
    children: link.label
  }), void 0)]
}), void 0);

var index$1f = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$F
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var styles$16 = {"icon":"index-module_icon__uafFn"};

const Component$P = ({
  className
}) => jsx("svg", Object.assign({
  className: className,
  height: "24px",
  version: "1.1",
  viewBox: "0 0 24 24",
  width: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: jsx("g", Object.assign({
    fill: "none",
    fillRule: "evenodd",
    id: "Icon/Outline/instagram",
    stroke: "none",
    strokeWidth: "1"
  }, {
    children: jsx("path", {
      className: styles$16.icon,
      d: "M12,3.8025 C14.67,3.8025 14.9866667,3.8125 16.0416667,3.86083333 C18.7516667,3.98416667 20.0175,5.27 20.1408333,7.96 C20.1891667,9.01416667 20.1983333,9.33083333 20.1983333,12.0008333 C20.1983333,14.6716667 20.1883333,14.9875 20.1408333,16.0416667 C20.0166667,18.7291667 18.7541667,20.0175 16.0416667,20.1408333 C14.9866667,20.1891667 14.6716667,20.1991667 12,20.1991667 C9.33,20.1991667 9.01333333,20.1891667 7.95916667,20.1408333 C5.2425,20.0166667 3.98333333,18.725 3.86,16.0408333 C3.81166667,14.9866667 3.80166667,14.6708333 3.80166667,12 C3.80166667,9.33 3.8125,9.01416667 3.86,7.95916667 C3.98416667,5.27 5.24666667,3.98333333 7.95916667,3.86 C9.01416667,3.8125 9.33,3.8025 12,3.8025 L12,3.8025 Z M12,2 C9.28416667,2 8.94416667,2.01166667 7.8775,2.06 C4.24583333,2.22666667 2.2275,4.24166667 2.06083333,7.87666667 C2.01166667,8.94416667 2,9.28416667 2,12 C2,14.7158333 2.01166667,15.0566667 2.06,16.1233333 C2.22666667,19.755 4.24166667,21.7733333 7.87666667,21.94 C8.94416667,21.9883333 9.28416667,22 12,22 C14.7158333,22 15.0566667,21.9883333 16.1233333,21.94 C19.7516667,21.7733333 21.775,19.7583333 21.9391667,16.1233333 C21.9883333,15.0566667 22,14.7158333 22,12 C22,9.28416667 21.9883333,8.94416667 21.94,7.8775 C21.7766667,4.24916667 19.7591667,2.2275 16.1241667,2.06083333 C15.0566667,2.01166667 14.7158333,2 12,2 Z M12,6.865 C9.16416667,6.865 6.865,9.16416667 6.865,12 C6.865,14.8358333 9.16416667,17.1358333 12,17.1358333 C14.8358333,17.1358333 17.135,14.8366667 17.135,12 C17.135,9.16416667 14.8358333,6.865 12,6.865 Z M12,15.3333333 C10.1591667,15.3333333 8.66666667,13.8416667 8.66666667,12 C8.66666667,10.1591667 10.1591667,8.66666667 12,8.66666667 C13.8408333,8.66666667 15.3333333,10.1591667 15.3333333,12 C15.3333333,13.8416667 13.8408333,15.3333333 12,15.3333333 Z M17.3383333,5.4625 C16.675,5.4625 16.1375,6 16.1375,6.6625 C16.1375,7.325 16.675,7.8625 17.3383333,7.8625 C18.0008333,7.8625 18.5375,7.325 18.5375,6.6625 C18.5375,6 18.0008333,5.4625 17.3383333,5.4625 Z",
      fill: "#000000",
      fillRule: "nonzero",
      id: "Icon"
    }, void 0)
  }), void 0)
}), void 0);

const Component$O = ({
  className
}) => jsxs("svg", Object.assign({
  className: className,
  height: 24,
  id: "Calque_2",
  viewBox: "0 0 283.43 225.09",
  width: 24,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsxs("defs", {
    children: [jsx("style", {
      children: `.cls-agent{fill:url(#dégradé_agent);}`
    }, void 0), jsxs("linearGradient", Object.assign({
      gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
      gradientUnits: "userSpaceOnUse",
      id: "d\u00E9grad\u00E9_agent",
      x1: "36.64",
      x2: "272.16",
      y1: "57.7",
      y2: "261.37"
    }, {
      children: [jsx("stop", {
        offset: "0",
        stopColor: "#22b573"
      }, void 0), jsx("stop", {
        offset: ".19",
        stopColor: "#26b776"
      }, void 0), jsx("stop", {
        offset: ".35",
        stopColor: "#2fbb7e"
      }, void 0), jsx("stop", {
        offset: ".47",
        stopColor: "#37be85"
      }, void 0), jsx("stop", {
        offset: ".67",
        stopColor: "#4fc998"
      }, void 0), jsx("stop", {
        offset: ".91",
        stopColor: "#75dbb8"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#84e2c5"
      }, void 0)]
    }), void 0)]
  }, void 0), jsx("g", Object.assign({
    "data-name": "Layer 1",
    id: "Layer_1"
  }, {
    children: jsx("path", {
      className: "cls-agent",
      d: "M283.43,43.43V181.76c0,23.97-19.46,43.34-43.43,43.34h-60.45v-84.68c15.65-1.93,31.07-6.27,45.71-13.19,9.09-4.28,12.98-15.12,8.7-24.21-4.31-9.09-15.15-12.98-24.24-8.7-30.74,14.53-66.06,14.55-96.83,.06-9.12-4.28-19.93-.39-24.21,8.7-4.31,9.12-.39,19.96,8.7,24.24,14.67,6.89,30.12,11.23,45.77,13.13v84.65h-59.7c-23.97,0-43.43-19.37-43.43-43.34V50.35c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.31,.69,0,6.75,0H240.01c23.97,0,43.43,19.34,43.43,43.43Z"
    }, void 0)
  }), void 0)]
}), void 0);

const Component$N = ({
  className
}) => jsxs("svg", Object.assign({
  className: className,
  "data-name": "Calque 2",
  height: "24",
  id: "Calque_2",
  viewBox: "0 0 283.43 225.09",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsxs("defs", {
    children: [jsx("style", {
      children: `.cls-analytics{fill:url(#dégradé_analytics);}`
    }, void 0), jsxs("linearGradient", Object.assign({
      gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
      gradientUnits: "userSpaceOnUse",
      id: "d\u00E9grad\u00E9_analytics",
      x1: "34.64",
      x2: "270.16",
      y1: "57.7",
      y2: "261.37"
    }, {
      children: [jsx("stop", {
        offset: "0",
        stopColor: "#3d8fbc"
      }, void 0), jsx("stop", {
        offset: ".35",
        stopColor: "#2cadd1"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#08f0ff"
      }, void 0)]
    }), void 0)]
  }, void 0), jsx("g", Object.assign({
    "data-name": "Layer 1",
    id: "Layer_1"
  }, {
    children: jsx("path", {
      className: "cls-analytics",
      d: "M283.43,43.43V181.76c0,23.97-19.46,43.34-43.43,43.34h-60.45v-84.68c15.65-1.93,31.07-6.27,45.71-13.19,9.09-4.28,12.98-15.12,8.7-24.21-4.31-9.09-15.15-12.98-24.24-8.7-30.74,14.53-66.06,14.55-96.83,.06-9.12-4.28-19.93-.39-24.21,8.7-4.31,9.12-.39,19.96,8.7,24.24,14.67,6.89,30.12,11.23,45.77,13.13v84.65h-59.7c-23.97,0-43.43-19.37-43.43-43.34V50.35c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.31,.69,0,6.75,0H240.01c23.97,0,43.43,19.34,43.43,43.43Z"
    }, void 0)
  }), void 0), jsx("g", Object.assign({
    "data-name": "Layer 1",
    id: "Layer_1"
  }, {
    children: jsx("path", {
      className: "cls-analytics",
      d: "M283.43,43.43V181.76c0,23.97-19.46,43.34-43.43,43.34h-60.45v-84.68c15.65-1.93,31.07-6.27,45.71-13.19,9.09-4.28,12.98-15.12,8.7-24.21-4.31-9.09-15.15-12.98-24.24-8.7-30.74,14.53-66.06,14.55-96.83,.06-9.12-4.28-19.93-.39-24.21,8.7-4.31,9.12-.39,19.96,8.7,24.24,14.67,6.89,30.12,11.23,45.77,13.13v84.65h-59.7c-23.97,0-43.43-19.37-43.43-43.34V50.35c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.31,.69,0,6.75,0H240.01c23.97,0,43.43,19.34,43.43,43.43Z"
    }, void 0)
  }), void 0)]
}), void 0);

const Component$M = ({
  className
}) => jsxs("svg", Object.assign({
  className: className,
  height: 24,
  id: "Calque_2",
  viewBox: "0 0 283.43 225.09",
  width: 24,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsxs("defs", {
    children: [jsx("style", {
      children: `.cls-bot{fill:url(#dégradé_bot);}`
    }, void 0), jsxs("linearGradient", Object.assign({
      gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
      gradientUnits: "userSpaceOnUse",
      id: "d\u00E9grad\u00E9_bot",
      x1: "54.64",
      x2: "305.57",
      y1: "63.7",
      y2: "280.7"
    }, {
      children: [jsx("stop", {
        offset: "0",
        stopColor: "#d53b84"
      }, void 0), jsx("stop", {
        offset: ".61",
        stopColor: "#ed5c7a"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#ff7374"
      }, void 0)]
    }), void 0)]
  }, void 0), jsx("g", Object.assign({
    "data-name": "Layer 1",
    id: "Layer_1"
  }, {
    children: jsx("path", {
      className: "cls-bot",
      d: "M283.43,43.43V181.76c0,23.97-19.46,43.34-43.43,43.34h-60.45v-84.68c15.65-1.93,31.07-6.27,45.71-13.19,9.09-4.28,12.98-15.12,8.7-24.21-4.31-9.09-15.15-12.98-24.24-8.7-30.74,14.53-66.06,14.55-96.83,.06-9.12-4.28-19.93-.39-24.21,8.7-4.31,9.12-.39,19.96,8.7,24.24,14.67,6.89,30.12,11.23,45.77,13.13v84.65h-59.7c-23.97,0-43.43-19.37-43.43-43.34V50.35c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.31,.69,0,6.75,0H240.01c23.97,0,43.43,19.34,43.43,43.43Z"
    }, void 0)
  }), void 0)]
}), void 0);

const Component$L = ({
  className
}) => jsxs("svg", Object.assign({
  className: className,
  height: 24,
  id: "Calque_2",
  viewBox: "0 0 283.43 225.09",
  width: 24,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsxs("defs", {
    children: [jsx("style", {
      children: `.cls-tolk-ai{fill:url(#linear-gradient);}`
    }, void 0), jsxs("linearGradient", Object.assign({
      gradientTransform: "translate(-1.57 -.4) rotate(.03)",
      gradientUnits: "userSpaceOnUse",
      id: "linear-gradient",
      x1: "13.62",
      x2: "249.14",
      y1: "-16.51",
      y2: "187.16"
    }, {
      children: [jsx("stop", {
        offset: "0",
        stopColor: "#5c00ff"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#ff3dad"
      }, void 0)]
    }), void 0)]
  }, void 0), jsx("path", {
    className: "cls-tolk-ai",
    d: "M283.41,43.59l-.08,138.33c-.01,23.97-19.48,43.33-43.45,43.31l-60.45-.03,.05-84.68c15.65-1.92,31.07-6.25,45.72-13.16,9.09-4.27,12.99-15.11,8.72-24.2-4.3-9.09-15.14-12.99-24.23-8.72-30.75,14.51-66.07,14.52-96.83,0-9.12-4.28-19.93-.4-24.21,8.69-4.31,9.12-.4,19.96,8.69,24.24,14.67,6.9,30.11,11.25,45.77,13.16l-.05,84.65-59.7-.03c-23.97-.01-43.41-19.39-43.4-43.36l.08-131.41c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.3,.69,0,6.75,0L240.01,.13c23.97,.01,43.42,19.36,43.4,43.45Z"
  }, void 0), jsx("path", {
    className: "cls-tolk-ai",
    d: "M283.41,43.59l-.08,138.33c-.01,23.97-19.48,43.33-43.45,43.31l-60.45-.03,.05-84.68c15.65-1.92,31.07-6.25,45.72-13.16,9.09-4.27,12.99-15.11,8.72-24.2-4.3-9.09-15.14-12.99-24.23-8.72-30.75,14.51-66.07,14.52-96.83,0-9.12-4.28-19.93-.4-24.21,8.69-4.31,9.12-.4,19.96,8.69,24.24,14.67,6.9,30.11,11.25,45.77,13.16l-.05,84.65-59.7-.03c-23.97-.01-43.41-19.39-43.4-43.36l.08-131.41c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.3,.69,0,6.75,0L240.01,.13c23.97,.01,43.42,19.36,43.4,43.45Z"
  }, void 0)]
}), void 0);

var styles$15 = {"icon":"index-module_icon__jJWAX"};

const Component$K = ({
  className
}) => jsx("svg", Object.assign({
  "aria-hidden": "true",
  className: className,
  "data-icon": "shopify",
  "data-prefix": "fab",
  focusable: "false",
  height: "24",
  role: "img",
  viewBox: "0 0 448 512",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: jsx("path", {
    className: styles$15.icon,
    d: "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z",
    fill: "currentColor"
  }, void 0)
}), void 0);

var styles$14 = {"spinner":"styles-module_spinner__E0H50"};

const Component$J = ({
  className
}) => jsx("svg", Object.assign({
  className: classNames(styles$14.spinner, className),
  viewBox: "0 0 24 24",
  x: "0",
  y: "0"
}, {
  children: jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }, void 0)
}), void 0);

var styles$13 = {"default":"index-module_default__k4aNt"};

const Component$I = ({
  className,
  icon
}) => {
  switch (icon) {
    case 'logo:agent':
      return jsx(Component$O, {
        className: className
      }, void 0);

    case 'logo:bot':
      return jsx(Component$M, {
        className: className
      }, void 0);

    case 'logo:tolk':
      return jsx(Component$L, {
        className: className
      }, void 0);

    case 'logo:analytics':
      return jsx(Component$N, {
        className: className
      }, void 0);

    case 'spinner':
      return jsx(Component$J, {
        className: className
      }, void 0);

    case 'shopify':
      return jsx(Component$K, {
        className: className
      }, void 0);

    case 'instagram':
      return jsx(Component$P, {
        className: className
      }, void 0);

    default:
      {
        const icons = __rest(heroIcons, []);

        const Tag = icons[icon];
        return jsx(Tag, {
          className: classNames(styles$13.default, className)
        }, void 0);
      }
  }
};

var index$1e = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$I
});

var styles$12 = {"button":"index-module_button__MhULV","button--outline":"index-module_button--outline__bVRuV","button--rounded":"index-module_button--rounded__UcUH7","button--block":"index-module_button--block__fHqQb","button--rounded-block":"index-module_button--rounded-block__V7Zgl","button--anchor":"index-module_button--anchor__YauQ7","button--disabled":"index-module_button--disabled__LZR5O","button--disabled-outline":"index-module_button--disabled-outline__7cyGf","button--icon-only":"index-module_button--icon-only__P-gZY","button--icon-only-outline-no-border":"index-module_button--icon-only-outline-no-border__SpL0r","button__content":"index-module_button__content__6asm8","button__content--block":"index-module_button__content--block__32J6N","button__left-icon":"index-module_button__left-icon__E7KsL","button__right-icon":"index-module_button__right-icon__5DHW8","button__loading-icon":"index-module_button__loading-icon__dfFpk","button__left-icon--outline":"index-module_button__left-icon--outline__6evFz","button__right-icon--outline":"index-module_button__right-icon--outline__vx4g8","button__loading-icon--outline":"index-module_button__loading-icon--outline__2-hQi","button__icon-only":"index-module_button__icon-only__NP-GF","button__icon--outline-disabled":"index-module_button__icon--outline-disabled__oizB2","button__icon-only--outline":"index-module_button__icon-only--outline__MZwHo","button__label":"index-module_button__label__qXXPd","button__label--right-icon":"index-module_button__label--right-icon__pdruj","button__label--outline":"index-module_button__label--outline__9XDX0","button__label--outline-disabled":"index-module_button__label--outline-disabled__OfKGf"};

const component$E = () => ({
  className,
  children,
  icon,
  isBlock,
  isDisabled: _isDisabled = false,
  isLoading: _isLoading = false,
  isOutlined: _isOutlined = false,
  isRounded: _isRounded = false,
  onClick,
  name,
  type,
  url,
  value
}) => {
  const Tag = typeof url === 'undefined' ? 'button' : 'a';
  return jsx(Tag, Object.assign({
    className: classNames(className, styles$12.button, {
      [styles$12['button--icon-only']]: icon && typeof children === 'undefined',
      [styles$12['button--icon-only-outline-no-border']]: icon && typeof children === 'undefined' && icon.border === 'none' && _isOutlined,
      [styles$12['button--rounded']]: _isRounded,
      [styles$12['button--rounded-block']]: _isRounded && isBlock,
      [styles$12['button--outline']]: _isOutlined,
      [styles$12['button--anchor']]: typeof url !== 'undefined',
      [styles$12['button--disabled']]: _isDisabled,
      [styles$12['button--disabled-outline']]: _isDisabled && _isOutlined,
      [styles$12['button--block']]: isBlock === true && typeof children !== 'undefined'
    }),
    disabled: _isDisabled,
    href: url === null || url === void 0 ? void 0 : url.linkTo,
    name: name,
    onClick: onClick,
    target: url === null || url === void 0 ? void 0 : url.target,
    type: type,
    value: value
  }, {
    children: jsxs("span", Object.assign({
      className: classNames(styles$12.button__content, {
        [styles$12['button__content--block']]: isBlock
      })
    }, {
      children: [icon && icon.position === 'left-icon' && jsx(Component$I, {
        className: classNames(styles$12['button__left-icon'], {
          [styles$12['button__icon--outline-disabled']]: _isDisabled && _isOutlined,
          [styles$12['button__left-icon--outline']]: _isOutlined
        }, icon.className),
        icon: icon.name
      }, void 0), !_isLoading && children !== 'undefined' && jsxs("span", Object.assign({
        className: classNames(styles$12.button__label, {
          [styles$12['button__label--right-icon']]: icon && icon.position === 'right-icon',
          [styles$12['button__label--outline']]: _isOutlined,
          [styles$12['button__label--outline-disabled']]: _isOutlined && _isDisabled
        })
      }, {
        children: [children, ' ', _isDisabled && jsx("span", Object.assign({
          className: "sr-only"
        }, {
          children: "Disabled"
        }), void 0)]
      }), void 0), _isLoading && jsxs(Fragment, {
        children: [jsx(Component$I, {
          className: classNames(styles$12['button__loading-icon'], {
            [styles$12['button__loading-icon--outline']]: _isOutlined
          }),
          icon: "spinner"
        }, void 0), jsx("span", Object.assign({
          className: "sr-only"
        }, {
          children: "Loading"
        }), void 0)]
      }, void 0), icon && typeof children === 'undefined' && jsxs(Fragment, {
        children: [jsx(Component$I, {
          className: classNames(styles$12['button__icon-only'], {
            [styles$12['button__icon-only--outline']]: _isOutlined
          }, icon.className),
          icon: icon.name
        }, void 0), jsx("span", Object.assign({
          className: "sr-only"
        }, {
          children: icon.screenReaderDescribe
        }), void 0)]
      }, void 0), icon && icon.position === 'right-icon' && jsx(Component$I, {
        className: classNames(styles$12['button__right-icon'], {
          [styles$12['button__right-icon--outline']]: _isOutlined
        }, icon.className),
        icon: icon.name
      }, void 0)]
    }), void 0)
  }), void 0);
};

var index$1d = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$E
});

var styles$11 = {"button-groupe-button":"index-module_button-groupe-button__zcTIi","button-groupe-button--disabled":"index-module_button-groupe-button--disabled__a5CCE","button-groupe-button__content":"index-module_button-groupe-button__content__044dg","button-groupe-button__icon-container":"index-module_button-groupe-button__icon-container__o6kFL","button-groupe-button__icon":"index-module_button-groupe-button__icon__Yu9Va","button-groupe-button__icon--disabled":"index-module_button-groupe-button__icon--disabled__oiFPM","button-groupe-button__label":"index-module_button-groupe-button__label__J6UUB","button-groupe-button__label--disabled":"index-module_button-groupe-button__label--disabled__3Nw-N"};

const component$D = () => ({
  className,
  children,
  icon,
  isDisabled: _isDisabled = false,
  name,
  onClick,
  type: _type = 'button',
  value
}) => {
  return jsx("button", Object.assign({
    className: classNames(className, styles$11['button-groupe-button'], {
      [styles$11['button-groupe-button--disabled']]: _isDisabled
    }),
    disabled: _isDisabled,
    name: name,
    onClick: onClick,
    type: _type,
    value: value
  }, {
    children: jsxs("span", Object.assign({
      className: styles$11['button-groupe-button__content']
    }, {
      children: [jsx("span", Object.assign({
        className: styles$11['button-groupe-button__icon-container']
      }, {
        children: jsx(Component$I, {
          className: classNames(icon.className, styles$11['button-groupe-button__icon'], {
            [styles$11['button-groupe-button__icon--disabled']]: _isDisabled
          }),
          icon: icon.name
        }, void 0)
      }), void 0), jsxs("span", Object.assign({
        className: classNames(styles$11['button-groupe-button__label'], {
          [styles$11['button-groupe-button__label--disabled']]: _isDisabled
        })
      }, {
        children: [children, " ", _isDisabled && jsx("span", Object.assign({
          className: "sr-only"
        }, {
          children: "Disabled"
        }), void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
};

var index$1c = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$D
});

var styles$10 = {"button-group":"index-module_button-group__980pL"};

const component$C = () => ({
  children,
  className
}) => jsx("div", Object.assign({
  className: classNames(styles$10['button-group'], className)
}, {
  children: children
}), void 0);

var index$1b = /*#__PURE__*/Object.freeze({
  __proto__: null,
  button: index$1c,
  component: component$C
});

var styles$$ = {"heatmap-chart":"index-module_heatmap-chart__ueaBA"};

const component$B = (echarts, GridComponent, TooltipComponent, VisualMapComponent, CanvasRenderer, HeatmapChart) => ({
  className,
  description,
  options,
  rootChartOptions,
  colors,
  title
}) => {
  echarts.use([// @ts-expect-error type
  TooltipComponent, // @ts-expect-error type
  GridComponent, // @ts-expect-error type
  VisualMapComponent, // @ts-expect-error type
  HeatmapChart, // @ts-expect-error type
  CanvasRenderer]);
  const reference = React__default.useRef(null);
  React__default.useEffect(() => {
    const chart = echarts.init(reference.current);
    const chartOptions = Object.assign(Object.assign({}, rootChartOptions), {
      grid: {
        height: '50%',
        top: '10%'
      },
      series: [{
        data: options.heatmapDatas.map(heatmapData => {
          return [heatmapData.xAxisPosition, heatmapData.yAxisPosition, heatmapData.value || '-'];
        }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        label: {
          show: true
        },
        name: options.name,
        type: 'heatmap'
      }],
      tooltip: {
        formatter: parameter => // @ts-expect-error Wrong type
        `${parameter.marker} ${parameter.seriesName}: ${parameter.value[2]}`,
        position: 'top'
      },
      visualMap: {
        bottom: '20%',
        calculable: true,
        inRange: {
          color: colors
        },
        left: 'center',
        orient: 'horizontal'
      },
      xAxis: {
        data: options.heatmapXaxis.values,
        splitArea: {
          show: true
        },
        type: 'category'
      },
      yAxis: {
        data: options.heatmapYaxis.values,
        splitArea: {
          show: true
        },
        type: 'category'
      }
    });
    chart.setOption(chartOptions);
    window.addEventListener('resize', () => {
      chart.resize();
    });
  }, [rootChartOptions, options, title, description, colors]);
  return jsxs("section", {
    children: [jsx("h1", Object.assign({
      className: "sr-only"
    }, {
      children: description
    }), void 0), jsx("div", {
      className: classNames(styles$$['heatmap-chart'], className),
      ref: reference
    }, void 0)]
  }, void 0);
};

var index$1a = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$B
});

var styles$_ = {"line-chart":"index-module_line-chart__w1NeX"};

const component$A = (echarts, GridComponent, TooltipComponent, ToolboxComponent, TitleComponent, LegendComponent, CanvasRenderer, LineChart, UniversalTransition) => ({
  className,
  colors,
  description,
  options,
  rootChartOptions,
  areAllYaxisValuesNotEqualZero
}) => {
  echarts.use([// @ts-expect-error type
  GridComponent, // @ts-expect-error type
  TooltipComponent, // @ts-expect-error type
  ToolboxComponent, // @ts-expect-error type
  TitleComponent, // @ts-expect-error type
  LegendComponent, // @ts-expect-error type
  LineChart, // @ts-expect-error type
  CanvasRenderer, // @ts-expect-error type
  UniversalTransition]);
  const reference = React__default.useRef(null);
  React__default.useEffect(() => {
    // blue-300
    const chart = echarts.init(reference.current);
    const chartOptions = Object.assign(Object.assign({}, rootChartOptions), {
      color: colors,
      grid: {
        bottom: '16',
        containLabel: true,
        left: '16',
        right: '16',
        top: '16'
      },
      series: [{
        cursor: 'default',
        data: options.yAxis.values,
        name: options.yAxis.description,
        smooth: true,
        type: 'line'
      }],
      tooltip: {
        axisPointer: {
          show: false,
          type: 'none'
        },
        formatter: parameters => {
          /* @ts-expect-error type are wrong */
          const date = new Date(Number(parameters[0].name));
          const formattedDate = genericUtils.formatDate(date, 'text-with-year');
          return `${formattedDate} <br> ${parameters
          /* @ts-expect-error type are wrong */
          .map(
          /* @ts-expect-error type are wrong */
          parameter => `${parameter.marker} ${parameter.seriesName}: ${parameter.value} ${options.type === 'percentage-evolution' ? '%' : ''}<br>`).join(' ')}`;
        },
        trigger: 'axis'
      },
      xAxis: [{
        axisLabel: {
          formatter: value => {
            const date = new Date(Number(value));
            return genericUtils.formatDate(date, 'text');
          }
        },
        boundaryGap: false,
        data: options.xAxis.values.map(date => date.getTime()),
        type: 'category'
      }],
      yAxis: {
        max: options.type === 'percentage-evolution' ? 100 : areAllYaxisValuesNotEqualZero ? undefined : 5,
        type: 'value'
      }
    });
    chart.setOption(chartOptions);
    window.addEventListener('resize', () => {
      chart.resize();
    });
  }, [rootChartOptions, options, areAllYaxisValuesNotEqualZero, description, colors]);
  return jsxs("section", {
    children: [jsx("h1", Object.assign({
      className: "sr-only"
    }, {
      children: description
    }), void 0), jsx("div", {
      className: classNames(styles$_['line-chart'], className),
      ref: reference
    }, void 0)]
  }, void 0);
};

var index$19 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$A
});

var styles$Z = {"pie-chart":"index-module_pie-chart__ib9f2"};

const component$z = (echarts, LegendComponent, TooltipComponent, TitleComponent, ToolboxComponent, CanvasRenderer, PieChart, LabelLayout) => ({
  className,
  description,
  arePieChartValuesNotOnlyZero,
  options,
  rootChartOptions,
  colors
}) => {
  echarts.use([// @ts-expect-error type
  TooltipComponent, // @ts-expect-error type
  LegendComponent, // @ts-expect-error type
  TitleComponent, // @ts-expect-error type
  ToolboxComponent, // @ts-expect-error type
  PieChart, // @ts-expect-error type
  CanvasRenderer, // @ts-expect-error type
  LabelLayout]);
  const reference = React__default.useRef(null);
  React__default.useEffect(() => {
    const emptyCircleGray500 = '#c0c6d3';
    const chart = echarts.init(reference.current);
    const legendOnSide = {
      bottom: 20,
      orient: 'vertical',
      right: 10,
      selectedMode: !options.interactions.isDisabled,
      top: 20,
      type: 'scroll'
    };
    const chartOptions = Object.assign(Object.assign({}, rootChartOptions), {
      color: colors,
      legend: options.datas.values.length > 20 ? legendOnSide : {
        bottom: 20,
        icon: 'circle',
        left: 'center',
        orient: typeof options.legend === 'undefined' ? 'vertical' : options.legend.orientation,
        selectedMode: !options.interactions.isDisabled
      },
      series: [{
        animation: false,
        bottom: 50,
        cursor: 'default',
        data: arePieChartValuesNotOnlyZero ? options.datas.values.map(data => {
          return {
            name: data.name,
            value: data.value
          };
        }) : undefined,
        emphasis: {
          disabled: options.interactions.isDisabled,
          label: {
            fontSize: '40',
            show: !options.interactions.isDisabled
          }
        },
        emptyCircleStyle: {
          color: emptyCircleGray500
        },
        label: {
          position: 'center',
          show: false
        },
        radius: ['55%', '70%'],
        roseType: 'radius',
        showEmptyCircle: true,
        type: 'pie'
      }],
      title: typeof options.interactions.valueInsideDonut === 'undefined' && options.interactions.isDisabled ? Object.assign(Object.assign({}, rootChartOptions.title), {
        textVerticalAlign: 'bottom'
      }) : {
        left: 'center',
        text: options.interactions.valueInsideDonut,
        textStyle: {
          fontSize: 32,
          fontWeight: 'normal'
        },
        textVerticalAlign: 'middle',
        top: 'center'
      },
      tooltip: options.interactions.isDisabled === false ? {
        formatter: parameter => {
          // @ts-expect-error Wrong type
          return `${parameter.marker} ${parameter.name}: ${// @ts-expect-error Wrong type
          parameter.value} ${typeof options.unit === 'undefined' ? '' : options.unit}`;
        },
        trigger: 'item'
      } : undefined
    });
    chart.setOption(chartOptions);
    window.addEventListener('resize', () => {
      chart.resize();
    });
  }, [rootChartOptions, options, description, colors, arePieChartValuesNotOnlyZero]);
  return jsxs("section", {
    children: [jsx("h1", Object.assign({
      className: "sr-only"
    }, {
      children: description
    }), void 0), jsx("div", {
      className: classNames(styles$Z['pie-chart'], className),
      ref: reference
    }, void 0)]
  }, void 0);
};

var index$18 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$z
});

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var styles$Y = {"sankey-chart":"index-module_sankey-chart__xxzsU"};

const isEchartsFormatterStepParameters = data => {
  return isObject(data) && typeof data.name === 'string' && typeof data.value === 'number';
};

const isObject = data => {
  return data instanceof Object;
};

const isEchartsFormatterBetweenStepsParameters = data => {
  if (isObject(data) && isObject(data.data) && typeof data.data.source === 'string' && typeof data.data.target === 'string' && typeof data.data.value === 'number') {
    return true;
  }

  return false;
};

const formatEchartName = name => {
  return name.replace( /*#__PURE__*/_wrapRegExp(/^\([0-9]+\)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]_[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)$/, {
    identifier: 1
  }), '$1');
};

const component$y = (echarts, GridComponent, TooltipComponent, TitleComponent, ToolboxComponent, LegendComponent, CanvasRenderer, SankeyChart) => ({
  className,
  description,
  rootChartOptions,
  title,
  options,
  colors
}) => {
  echarts.use([// @ts-expect-error type
  GridComponent, // @ts-expect-error type
  TooltipComponent, // @ts-expect-error type
  TitleComponent, // @ts-expect-error type
  ToolboxComponent, // @ts-expect-error type
  LegendComponent, // @ts-expect-error type
  CanvasRenderer, // @ts-expect-error type
  SankeyChart]);
  const reference = React__default.useRef(null);
  React__default.useEffect(() => {
    const chart = echarts.init(reference.current);
    const chartOptions = Object.assign(Object.assign({}, rootChartOptions), {
      emphasis: {
        focus: 'adjacency'
      },
      lineStyle: {
        curveness: 0.5
      },
      series: [{
        bottom: '16',
        data: options.steps.map(step => {
          return {
            name: step.name
          };
        }),
        label: {
          color: '#2e384d',
          formatter: parameters => {
            return formatEchartName(parameters.name);
          },
          overflow: 'break',
          position: 'insideRight',
          width: 250
        },
        left: '16',
        levels: colors.map((color, index) => {
          return {
            depth: index,
            itemStyle: {
              color,
              opacity: 0.7
            },
            label: index === genericUtils.NUMBER.ZERO ? {
              position: 'insideLeft',
              width: 200
            } : {},
            lineStyle: {
              color: 'source',
              opacity: 0.3
            }
          };
        }),
        links: options.datas.map(data => {
          return {
            source: data.previousStep,
            target: data.name,
            value: data.value
          };
        }),
        nodeAlign: 'left',
        right: '16',
        top: '16',
        type: 'sankey'
      }],
      tooltip: {
        formatter: parameters => {
          if (isEchartsFormatterBetweenStepsParameters(parameters)) {
            const formattedTarget = formatEchartName(parameters.data.target);
            const formattedSource = formatEchartName(parameters.data.source);
            return `${formattedSource} > ${formattedTarget}: ${parameters.data.value.toString()}`;
          }

          if (isEchartsFormatterStepParameters(parameters)) {
            return `${formatEchartName(parameters.name)}: ${parameters.value.toString()}`;
          }

          return 'Unable to display informations';
        },
        trigger: 'item',
        triggerOn: 'mousemove'
      }
    });
    chart.setOption(chartOptions);
    window.addEventListener('resize', () => {
      chart.resize();
    });
  }, [rootChartOptions, title, description, options, colors]);
  return jsxs("section", {
    children: [jsx("h1", Object.assign({
      className: "sr-only"
    }, {
      children: description
    }), void 0), jsx("div", {
      className: classNames(styles$Y['sankey-chart'], className),
      ref: reference
    }, void 0)]
  }, void 0);
};

var index$17 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$y
});

var styles$X = {"stacked-line-chart":"index-module_stacked-line-chart__bqRj6"};

const component$x = (echarts, GridComponent, LegendComponent, TitleComponent, ToolboxComponent, TooltipComponent, CanvasRenderer, LineChart, UniversalTransition) => ({
  className,
  description,
  options,
  rootChartOptions,
  colors
}) => {
  echarts.use([// @ts-expect-error type
  TitleComponent, // @ts-expect-error type
  GridComponent, // @ts-expect-error type
  ToolboxComponent, // @ts-expect-error type
  TooltipComponent, // @ts-expect-error type
  LegendComponent, // @ts-expect-error type
  LineChart, // @ts-expect-error type
  CanvasRenderer, // @ts-expect-error type
  UniversalTransition]);
  const reference = React__default.useRef(null);
  React__default.useEffect(() => {
    const chart = echarts.init(reference.current);
    const chartOptions = Object.assign(Object.assign({}, rootChartOptions), {
      grid: {
        containLabel: true,
        left: '1%',
        right: '3%'
      },
      legend: {
        bottom: 0,
        data: options.yAxis.values.map(value => value.description)
      },
      series: options.yAxis.values.map((value, index) => {
        return {
          areaStyle: options.stackedWithArea === true ? {
            color: colors[index]
          } : undefined,
          data: value.data,
          emphasis: {
            focus: 'series'
          },
          itemStyle: {
            color: colors[index]
          },
          name: value.description,
          smooth: true,
          // stack: 'Total',
          type: 'line' // z: options.yAxis.values.length - index

        };
      }),
      tooltip: {
        axisPointer: {
          show: false,
          type: 'none'
        },
        formatter: parameters => {
          /* @ts-expect-error type are wrong */
          const date = new Date(Number(parameters[0].name));
          const formattedDate = genericUtils.formatDate(date, 'text');
          return `${formattedDate} <br> ${parameters
          /* @ts-expect-error type are wrong */
          .map(
          /* @ts-expect-error type are wrong */
          parameter => `${parameter.marker} ${parameter.seriesName}: ${parameter.value}<br>`).join(' ')}`;
        },
        trigger: 'axis'
      },
      xAxis: [{
        axisLabel: {
          formatter: value => {
            const date = new Date(Number(value));
            return genericUtils.formatDate(date, 'text');
          }
        },
        boundaryGap: false,
        data: options.xAxis.values.map(date => date.getTime()),
        type: 'category'
      }],
      yAxis: [{
        type: 'value'
      }]
    });
    chart.setOption(chartOptions);
    window.addEventListener('resize', () => {
      chart.resize();
    });
  }, [rootChartOptions, options, description, colors]);
  return jsxs("section", {
    children: [jsx("h1", Object.assign({
      className: "sr-only"
    }, {
      children: description
    }), void 0), jsx("div", {
      className: classNames(styles$X['stacked-line-chart'], className),
      ref: reference
    }, void 0)]
  }, void 0);
};

var index$16 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$x
});

const areAllYaxisValuesNotEqualZero = yaxisValues => {
  return yaxisValues.some(value => value !== genericUtils.NUMBER.ZERO);
};

const arePieChartValuesNotOnlyZero = pieChartDatas => {
  return pieChartDatas.values.some(value => value.value !== genericUtils.NUMBER.ZERO);
};

const noLineData = lineChartDatas => {
  return genericUtils.isEmpty(lineChartDatas.xAxis.values) && genericUtils.isEmpty(lineChartDatas.yAxis.values);
};

const noSankeyData = sankeyChartDatas => {
  return genericUtils.isEmpty(sankeyChartDatas.datas) && genericUtils.isEmpty(sankeyChartDatas.steps);
};

const noStackedLineData = stackedLineChartDatas => {
  return genericUtils.isEmpty(stackedLineChartDatas.yAxis.values) && genericUtils.isEmpty(stackedLineChartDatas.xAxis.values);
};

const component$w = (highcharts, highchartsReact, Line, Pie, StackedLine, Sankey, Heatmap) => ({
  className,
  description,
  options,
  allowExport: _allowExport = false,
  noDataMessage: _noDataMessage = 'No data to display',
  colors
}) => {
  const chartComponentReference = React.useRef(null);
  const chart1Color = '#5493bc';
  const chart2Color = '#2f454a';
  const chart3Color = '#80b583';
  const chart4Color = '#ece41b';
  const chart5Color = '#e28540';
  const chart6Color = '#e46da7';
  const chart7Color = '#a100bb';
  const defaultColors = [chart1Color, chart2Color, chart3Color, chart4Color, chart5Color, chart6Color, chart7Color];
  const rootHighchartOptions = {
    chart: {
      style: {
        fontFamily: 'Rubik, sans-serif'
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: _allowExport
    },
    lang: {
      noData: _noDataMessage
    },
    legend: {
      enabled: false
    },
    noData: {
      position: {
        align: 'center',
        verticalAlign: 'middle',
        x: 0,
        y: 0
      },
      style: {
        color: '#2e384d',
        fontSize: '16px',
        fontWeight: 'normal'
      }
    },
    series: [{
      data: [],
      name: 'Default chart',
      type: 'line'
    }],
    title: {
      text: undefined
    }
  };
  const rootEchartsOptions = {
    animation: false,
    legend: {
      show: false
    },
    media: [{
      query: {
        minwidth: '100%'
      }
    }],
    textStyle: {
      fontFamily: 'Rubik, sans-serif'
    },
    title: {
      left: 'center',
      show: options.type === 'stacked-line' && noStackedLineData(options) || (options.type === 'percentage-evolution' || options.type === 'number-evolution') && noLineData(options) || options.type === 'pie' && arePieChartValuesNotOnlyZero(options.datas) === false || options.type === 'sankey' && noSankeyData(options),
      text: _noDataMessage,
      textStyle: {
        color: '#2e384d',
        fontSize: 16,
        fontWeight: 'normal'
      },
      top: 'center'
    },
    toolbox: {
      show: false
    }
  };

  switch (options.type) {
    case 'number-evolution':
    case 'percentage-evolution':
      return jsx(Line, {
        areAllYaxisValuesNotEqualZero: areAllYaxisValuesNotEqualZero(options.yAxis.values),
        className: className,
        colors: typeof colors === 'undefined' ? defaultColors : colors,
        description: description,
        options: options,
        rootChartOptions: rootEchartsOptions
      }, void 0);

    case 'stacked-line':
      return jsx(StackedLine, {
        className: className,
        colors: typeof colors === 'undefined' ? defaultColors : colors,
        description: description,
        options: options,
        rootChartOptions: rootEchartsOptions
      }, void 0);

    case 'pie':
      return jsx(Pie, {
        arePieChartValuesNotOnlyZero: arePieChartValuesNotOnlyZero(options.datas),
        className: className,
        colors: typeof colors === 'undefined' ? defaultColors : colors,
        description: description,
        options: options,
        rootChartOptions: rootEchartsOptions
      }, void 0);

    case 'sankey':
      return jsx(Sankey, {
        colors: typeof colors === 'undefined' ? defaultColors : colors,
        description: description,
        options: options,
        rootChartOptions: rootEchartsOptions
      }, void 0);

    case 'heatmap':
      return jsx(Heatmap, {
        colors: typeof colors === 'undefined' ? defaultColors : colors,
        description: description,
        options: options,
        rootChartOptions: rootEchartsOptions
      }, void 0);

    default:
      return jsx(highchartsReact.default, {
        highcharts: highcharts,
        options: rootHighchartOptions,
        ref: chartComponentReference
      }, void 0);
  }
};

var index$15 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$w,
  heatmap: index$1a,
  line: index$19,
  pie: index$18,
  sankey: index$17,
  stackedLine: index$16
});

var styles$W = {"data-grid-cell":"index-module_data-grid-cell__5foiq","data-grid-cell__content":"index-module_data-grid-cell__content__Z5ECL","data-grid-cell__label--describe":"index-module_data-grid-cell__label--describe__9dSSE","data-grid-cell__label":"index-module_data-grid-cell__label__5tGqt","data-grid-cell__description":"index-module_data-grid-cell__description__wlmKs"};

const component$v = () => ({
  children,
  description
}) => jsx("td", Object.assign({
  className: styles$W['data-grid-cell']
}, {
  children: jsxs("div", Object.assign({
    className: styles$W['data-grid-cell__content']
  }, {
    children: [jsx("span", Object.assign({
      className: classNames('text-regular-sm-dark', styles$W['data-grid-cell__label'], {
        [styles$W['data-grid-cell__label--describe']]: typeof description === 'string'
      })
    }, {
      children: children
    }), void 0), typeof description === 'string' && jsxs(Fragment, {
      children: [jsx("br", {}, void 0), jsx("span", Object.assign({
        className: classNames('text-regular-sm-gray-700', styles$W['data-grid-cell__description'])
      }, {
        children: description
      }), void 0)]
    }, void 0)]
  }), void 0)
}), void 0);

var index$14 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$v
});

var styles$V = {"data-grid-cell-collapse":"index-module_data-grid-cell-collapse__I3F38","data-grid-cell-collapse__container":"index-module_data-grid-cell-collapse__container__hQyof","data-grid-cell-collapse__icon":"index-module_data-grid-cell-collapse__icon__1gkjR","data-grid-cell-collapse__button":"index-module_data-grid-cell-collapse__button__El6RR"};

const component$u = () => ({
  isOpen,
  onClick
}) => jsx("td", Object.assign({
  className: styles$V['data-grid-cell-collapse']
}, {
  children: jsx("div", Object.assign({
    className: styles$V['data-grid-cell-collapse__container']
  }, {
    children: jsx("button", Object.assign({
      className: styles$V['data-grid-cell-collapse__button'],
      onClick: onClick,
      type: "button"
    }, {
      children: jsx(Component$I, {
        className: styles$V['data-grid-cell-collapse__icon'],
        icon: isOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'
      }, void 0)
    }), void 0)
  }), void 0)
}), void 0);

var index$13 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$u
});

var styles$U = {"data-grid-row":"index-module_data-grid-row__UmVkB"};

const component$t = () => ({
  children,
  className
}) => jsx("tr", Object.assign({
  className: classNames(styles$U['data-grid-row'], className)
}, {
  children: children
}), void 0);

var index$12 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cell: index$14,
  cellCollapse: index$13,
  component: component$t
});

const onCollapseButtonClick = (isOpen, setShowDataGrid) => () => {
  setShowDataGrid({
    isOpen: !isOpen
  });
};

const component$s = (Row, Cell, CellCollapse, SubDataGrid) => ({
  dataGridRow,
  dataGridColumn,
  showCollapseButtonInEmptyColumn
}) => {
  const [collapseState, setCollapseState] = React__default.useState({
    isOpen: false
  });
  return jsxs(Fragment, {
    children: [jsx(Row, {
      children: jsxs(Fragment, {
        children: [typeof dataGridRow.sudData !== 'undefined' && !genericUtils.isEmpty(dataGridRow.sudData) && jsx(CellCollapse, {
          isOpen: collapseState.isOpen,
          onClick: onCollapseButtonClick(collapseState.isOpen, setCollapseState)
        }, void 0), showCollapseButtonInEmptyColumn && typeof dataGridRow.sudData === 'undefined' && jsx("td", {}, void 0), dataGridColumn.map(column => {
          const columnProperty = column.value;
          const currentCellProperty = dataGridRow.cells[columnProperty];
          return jsx(Cell, Object.assign({
            description: currentCellProperty.description
          }, {
            children: currentCellProperty.content
          }), genericUtils.generateRandomString());
        })]
      }, void 0)
    }, genericUtils.generateRandomString()), collapseState.isOpen === true && typeof dataGridRow.sudData !== 'undefined' && jsxs(Row, {
      children: [jsx(Cell, {}, void 0), jsx("td", Object.assign({
        colSpan: 3
      }, {
        children: jsx(SubDataGrid, {
          subGridData: dataGridRow.sudData
        }, void 0)
      }), void 0)]
    }, void 0)]
  }, void 0);
};

var index$11 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$s,
  row: index$12
});

var styles$T = {"data-grid-empty-content":"index-module_data-grid-empty-content__ZmEcz","data-grid-empty-content__cell":"index-module_data-grid-empty-content__cell__oDtyI","data-grid-empty-content__icon":"index-module_data-grid-empty-content__icon__pBcOj"};

const component$r = () => ({
  message: _message = 'No data to display'
}) => {
  return jsx("tr", Object.assign({
    className: styles$T['data-grid-empty-content']
  }, {
    children: jsxs("td", Object.assign({
      className: classNames(styles$T['data-grid-empty-content__cell'], 'text-regular-base-dark--center'),
      colSpan: 999
    }, {
      children: [jsx(Component$I, {
        className: styles$T['data-grid-empty-content__icon'],
        icon: "DocumentSearchIcon"
      }, void 0), jsx("br", {}, void 0), _message]
    }), void 0)
  }), void 0);
};

var index$10 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$r
});

const component$q = () => ({
  children
}) => jsx("tbody", {
  children: children
}, void 0);

var index$$ = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$q,
  content: index$11,
  emptyContent: index$10
});

var styles$S = {"data-grid-title":"index-module_data-grid-title__PDHXP","data-grid-title__button":"index-module_data-grid-title__button__cszCR","data-grid-title__sorting-icon":"index-module_data-grid-title__sorting-icon__Ps5vZ","data-grid-title__content":"index-module_data-grid-title__content__uEKvj","data-grid-title__sorting-icon--active":"index-module_data-grid-title__sorting-icon--active__0wZyR"};

const component$p = () => ({
  children,
  className,
  description,
  isSortingActive: _isSortingActive = false,
  sorting: _sorting = 'asc',
  onClick,
  value
}) => jsx("th", Object.assign({
  abbr: description,
  className: classNames(styles$S['data-grid-title'], className)
}, {
  children: jsxs("button", Object.assign({
    className: styles$S['data-grid-title__button'],
    "data-sorting": _sorting,
    onClick: onClick,
    type: "button",
    value: value
  }, {
    children: [jsx("span", Object.assign({
      className: classNames('label-regular-sm-gray-700', styles$S['data-grid-title__content'])
    }, {
      children: children
    }), void 0), jsx(Component$I, {
      className: classNames(styles$S['data-grid-title__sorting-icon'], {
        [styles$S['data-grid-title__sorting-icon--active']]: _isSortingActive
      }),
      icon: _isSortingActive && _sorting === 'desc' ? 'ArrowDownIcon' : 'ArrowUpIcon'
    }, void 0)]
  }), void 0)
}), void 0);

var index$_ = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$p
});

var styles$R = {"data-grid-header__line":"index-module_data-grid-header__line__KEr32"};

const component$o = () => ({
  children
}) => jsx("thead", {
  children: jsx("tr", Object.assign({
    className: styles$R['data-grid-header__line']
  }, {
    children: children
  }), void 0)
}, void 0);

var index$Z = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cell: index$_,
  component: component$o
});

const onHeaderCellButtonClick$1 = (subGridData, subGridDataState, sortingState, setSortingState, setGridDataState) => event => {
  const currentButtonSorting = event.currentTarget.getAttribute('data-sorting');
  const sortedColumnValue = event.currentTarget.value;

  if (genericUtils.isEmpty(sortingState.columnValue) || sortingState.columnValue !== event.currentTarget.value) {
    const _sortedDataGrid = [...subGridDataState.data.content.rows].sort((valueA, valueB) => {
      return valueA.cells[sortedColumnValue].value.localeCompare(valueB.cells[sortedColumnValue].value, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });

    setSortingState({
      columnValue: event.currentTarget.value,
      sort: 'asc'
    });
    setGridDataState({
      data: {
        content: {
          rows: _sortedDataGrid
        },
        titles: subGridDataState.data.titles
      }
    });
    return;
  }

  if (currentButtonSorting === 'desc') {
    setSortingState({
      columnValue: '',
      sort: 'asc'
    });
    setGridDataState({
      data: subGridData
    });
    return;
  }

  const sortedDataGrid = [...subGridDataState.data.content.rows].sort((valueA, valueB) => {
    return valueB.cells[sortedColumnValue].value.localeCompare(valueA.cells[sortedColumnValue].value, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  });
  setSortingState({
    columnValue: event.currentTarget.value,
    sort: 'desc'
  });
  setGridDataState({
    data: {
      content: {
        rows: sortedDataGrid
      },
      titles: subGridDataState.data.titles
    }
  });
};

const getDefaultSortedColumn$1 = (subGridData, setSortingState, setGridDataState) => {
  if (typeof subGridData.titles === 'undefined') {
    return;
  }

  const defaultSortedColumn = subGridData.titles.find(column => typeof column.isSortingActive !== 'undefined');

  if (typeof defaultSortedColumn === 'undefined') {
    setSortingState({
      columnValue: '',
      sort: undefined
    });
    return;
  }

  if (defaultSortedColumn.sorting === 'asc') {
    const sortedDataGrid = [...subGridData.content.rows].sort((valueA, valueB) => {
      return valueA.cells[defaultSortedColumn.value].value.localeCompare(valueB.cells[defaultSortedColumn.value].value, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
    setGridDataState({
      data: {
        content: {
          rows: sortedDataGrid
        },
        titles: subGridData.titles
      }
    });
  }

  if (defaultSortedColumn.sorting === 'desc') {
    const sortedDataGrid = [...subGridData.content.rows].sort((valueA, valueB) => {
      return valueB.cells[defaultSortedColumn.value].value.localeCompare(valueA.cells[defaultSortedColumn.value].value, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
    setGridDataState({
      data: {
        content: {
          rows: sortedDataGrid
        },
        titles: subGridData.titles
      }
    });
  }

  setSortingState({
    columnValue: defaultSortedColumn.value,
    sort: typeof defaultSortedColumn.sorting === 'undefined' ? undefined : defaultSortedColumn.sorting
  });
};

var styles$Q = {"sub-data-grid":"index-module_sub-data-grid__3hOQC","sub-data-grid__header-cell":"index-module_sub-data-grid__header-cell__afJwX","sub-data-grid__row":"index-module_sub-data-grid__row__V2gxy"};

const component$n = (Header, HeaderCell, Body, Row, Cell) => ({
  subGridData
}) => {
  const [sortingState, setSortingState] = React__default.useState({
    columnValue: '',
    sort: undefined
  });
  const [subGridDataState, setSubGridDataState] = React__default.useState({
    data: subGridData
  });
  React__default.useEffect(() => {
    getDefaultSortedColumn$1(subGridData, setSortingState, setSubGridDataState);
  }, [subGridData]);
  return jsxs("table", Object.assign({
    className: styles$Q['sub-data-grid']
  }, {
    children: [typeof subGridData.titles !== 'undefined' && jsx(Header, {
      children: jsx(Fragment, {
        children: subGridData.titles.map(column => {
          return jsx(HeaderCell, Object.assign({
            className: styles$Q['sub-data-grid__header-cell'],
            description: column.description,
            isSortingActive: column.value === sortingState.columnValue,
            onClick: onHeaderCellButtonClick$1(subGridData, subGridDataState, sortingState, setSortingState, setSubGridDataState),
            sorting: sortingState.sort,
            value: column.value
          }, {
            children: column.headerName
          }), genericUtils.generateRandomString());
        })
      }, void 0)
    }, void 0), jsx(Body, {
      children: subGridDataState.data.content.rows.map(row => {
        return jsx(Row, Object.assign({
          className: styles$Q['sub-data-grid__row']
        }, {
          children: jsxs(Fragment, {
            children: [typeof subGridDataState.data.titles === 'undefined' && jsx(Fragment, {
              children: Object.values(row.cells).map(cell => {
                return jsx(Cell, Object.assign({
                  description: cell.description
                }, {
                  children: cell.content
                }), genericUtils.generateRandomString());
              })
            }, void 0), typeof subGridDataState.data.titles !== 'undefined' && jsx(Fragment, {
              children: subGridDataState.data.titles.map(column => {
                const columnProperty = column.value;
                const currentCellProperty = row.cells[columnProperty];
                return jsx(Cell, Object.assign({
                  description: currentCellProperty.description
                }, {
                  children: currentCellProperty.value
                }), genericUtils.generateRandomString());
              })
            }, void 0)]
          }, void 0)
        }), genericUtils.generateRandomString());
      })
    }, void 0)]
  }), void 0);
};

var index$Y = /*#__PURE__*/Object.freeze({
  __proto__: null,
  body: index$$,
  component: component$n,
  header: index$Z
});

var styles$P = {"data-grid":"index-module_data-grid__-KetV","data-grid--empty":"index-module_data-grid--empty__RemPr","data-grid__sub-data-content-cell":"index-module_data-grid__sub-data-content-cell__JnBtN","data-grid__sub-data-grid":"index-module_data-grid__sub-data-grid__ciApW"};

const component$m = (Header, HeaderCell, Body, Content, EmptyContent) => ({
  className,
  displayCollapseColumn,
  gridData,
  onHeaderCellButtonClick,
  sortingState
}) => {
  return jsxs("table", Object.assign({
    className: classNames(styles$P['data-grid'], {
      [styles$P['data-grid--empty']]: genericUtils.isEmpty(gridData.content.rows)
    }, className)
  }, {
    children: [jsx(Header, {
      children: jsxs(Fragment, {
        children: [displayCollapseColumn === true && jsx("th", {
          abbr: "Empty column to display collapse button"
        }, void 0), gridData.titles.map(column => {
          return jsx(HeaderCell, Object.assign({
            description: column.description,
            isSortingActive: column.value === sortingState.columnValue,
            onClick: onHeaderCellButtonClick,
            sorting: sortingState.sort,
            value: column.value
          }, {
            children: column.headerName
          }), column.headerName);
        })]
      }, void 0)
    }, void 0), jsx(Body, {
      children: jsxs(Fragment, {
        children: [genericUtils.isEmpty(gridData.content.rows) && jsx(EmptyContent, {}, void 0), !genericUtils.isEmpty(gridData.content.rows) && gridData.content.rows.map(row => {
          return jsx(Content, {
            dataGridColumn: gridData.titles,
            dataGridRow: row,
            showCollapseButtonInEmptyColumn: displayCollapseColumn
          }, genericUtils.generateRandomString());
        })]
      }, void 0)
    }, void 0)]
  }), void 0);
};

var index$X = /*#__PURE__*/Object.freeze({
  __proto__: null,
  body: index$$,
  component: component$m,
  header: index$Z,
  subDataGrid: index$Y
});

const hasToDisplayCollapseColumn = content => {
  return content.rows.some(row => typeof row.sudData !== 'undefined' && !genericUtils.isEmpty(row.sudData));
};

const onHeaderCellButtonClick = (gridData, gridDataState, sortingState, setSortingState, setGridDataState) => event => {
  const currentButtonSorting = event.currentTarget.getAttribute('data-sorting');
  const sortedColumnValue = event.currentTarget.value;

  if (genericUtils.isEmpty(sortingState.columnValue) || sortingState.columnValue !== event.currentTarget.value) {
    const _sortedDataGrid = [...gridDataState.data.content.rows].sort((valueA, valueB) => {
      return valueA.cells[sortedColumnValue].value.localeCompare(valueB.cells[sortedColumnValue].value, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });

    setSortingState({
      columnValue: event.currentTarget.value,
      sort: 'asc'
    });
    setGridDataState({
      data: {
        content: {
          rows: _sortedDataGrid
        },
        titles: gridDataState.data.titles
      }
    });
    return;
  }

  if (currentButtonSorting === 'desc') {
    setSortingState({
      columnValue: '',
      sort: 'asc'
    });
    setGridDataState({
      data: gridData
    });
    return;
  }

  const sortedDataGrid = [...gridDataState.data.content.rows].sort((valueA, valueB) => {
    return valueB.cells[sortedColumnValue].value.localeCompare(valueA.cells[sortedColumnValue].value, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  });
  setSortingState({
    columnValue: event.currentTarget.value,
    sort: 'desc'
  });
  setGridDataState({
    data: {
      content: {
        rows: sortedDataGrid
      },
      titles: gridDataState.data.titles
    }
  });
};

const getDefaultSortedColumn = (gridData, setGridDataState, setSortingState) => {
  const defaultSortedColumn = gridData.titles.find(title => typeof title.isSortingActive !== 'undefined');

  if (typeof defaultSortedColumn === 'undefined') {
    setSortingState({
      columnValue: '',
      sort: undefined
    });
    return;
  }

  if (defaultSortedColumn.sorting === 'asc') {
    const sortedDataGrid = [...gridData.content.rows].sort((valueA, valueB) => {
      return valueA.cells[defaultSortedColumn.value].value.localeCompare(valueB.cells[defaultSortedColumn.value].value, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
    setGridDataState({
      data: {
        content: {
          rows: sortedDataGrid
        },
        titles: gridData.titles
      }
    });
  }

  if (defaultSortedColumn.sorting === 'desc') {
    const sortedDataGrid = [...gridData.content.rows].sort((valueA, valueB) => {
      return valueB.cells[defaultSortedColumn.value].value.localeCompare(valueA.cells[defaultSortedColumn.value].value, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
    setGridDataState({
      data: {
        content: {
          rows: sortedDataGrid
        },
        titles: gridData.titles
      }
    });
  }

  setSortingState({
    columnValue: defaultSortedColumn.value,
    sort: typeof defaultSortedColumn.sorting === 'undefined' ? undefined : defaultSortedColumn.sorting
  });
};

const component$l = Layout => ({
  gridData
}) => {
  const [sortingState, setSortingState] = React__default.useState({
    columnValue: '',
    sort: undefined
  });
  const [gridDataState, setGridDataState] = React__default.useState({
    data: gridData
  });
  React__default.useEffect(() => {
    if (!genericUtils.isEmpty(gridData.content.rows)) {
      getDefaultSortedColumn(gridData, setGridDataState, setSortingState);
    }
  }, [gridData]);
  return jsx(Layout, {
    displayCollapseColumn: hasToDisplayCollapseColumn(gridData.content),
    gridData: gridDataState.data,
    onHeaderCellButtonClick: onHeaderCellButtonClick(gridData, gridDataState, sortingState, setSortingState, setGridDataState),
    sortingState: sortingState
  }, void 0);
};

var index$W = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$l,
  layout: index$X
});

var styles$O = {"divider":"index-module_divider__Qo-Ea","divider__left-line":"index-module_divider__left-line__59PQ-","divider__label":"index-module_divider__label__cjSP5","divider__right-line":"index-module_divider__right-line__txBn1","divider__anchor":"index-module_divider__anchor__ocNUj"};

const component$k = InternalLink => ({
  children,
  className,
  internalUrl
}) => jsxs("div", Object.assign({
  className: classNames(styles$O.divider, className)
}, {
  children: [jsx("div", {
    className: styles$O['divider__left-line']
  }, void 0), typeof internalUrl === 'undefined' ? jsx("span", Object.assign({
    className: styles$O.divider__label
  }, {
    children: children
  }), void 0) : jsx(InternalLink, Object.assign({
    className: classNames(internalUrl.className, styles$O.divider__anchor),
    path: internalUrl.path
  }, {
    children: children
  }), void 0), jsx("div", {
    className: styles$O['divider__right-line']
  }, void 0)]
}), void 0);

var index$V = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$k
});

var styles$N = {"drag-and-drop-item":"index-module_drag-and-drop-item__acE5H","drag-and-drop-item--drag-to-top-is-on-current-element":"index-module_drag-and-drop-item--drag-to-top-is-on-current-element__OcVpE","drag-and-drop-item--drag-to-bottom-is-on-current-element":"index-module_drag-and-drop-item--drag-to-bottom-is-on-current-element__NVdpl","drag-and-drop-item__new-position":"index-module_drag-and-drop-item__new-position__eTs4w","drag-and-drop-item__new-position--visible":"index-module_drag-and-drop-item__new-position--visible__fd74c","drag-and-drop-item__container":"index-module_drag-and-drop-item__container__hH-Co","drag-and-drop-item__container--dragged":"index-module_drag-and-drop-item__container--dragged__cDV6U","drag-and-drop-item__container--drag-is-on-current-element":"index-module_drag-and-drop-item__container--drag-is-on-current-element__fTHi4","drag-and-drop-item__container--drag-is-on-current-element-inline":"index-module_drag-and-drop-item__container--drag-is-on-current-element-inline__Lwqzn","drag-and-drop-item__container--inline":"index-module_drag-and-drop-item__container--inline__coR2Y","drag-and-drop-item__container--dragged-inline":"index-module_drag-and-drop-item__container--dragged-inline__ZgZHt","drag-and-drop-item__header":"index-module_drag-and-drop-item__header__-KdQ2","drag-and-drop-item__left-header":"index-module_drag-and-drop-item__left-header__-NOSO","drag-and-drop-item__left-header--dragged-inline":"index-module_drag-and-drop-item__left-header--dragged-inline__2NSvd","drag-and-drop-item__left-header--inline":"index-module_drag-and-drop-item__left-header--inline__PoktW","drag-and-drop-item__icon":"index-module_drag-and-drop-item__icon__9uT7F","drag-and-drop-item__icon--drag":"index-module_drag-and-drop-item__icon--drag__MDegP","drag-and-drop-item__icon--inline":"index-module_drag-and-drop-item__icon--inline__YlQEB","drag-and-drop-item__title":"index-module_drag-and-drop-item__title__pkvXZ","drag-and-drop-item__close-button":"index-module_drag-and-drop-item__close-button__tW9Pa","drag-and-drop-item__icon--delete":"index-module_drag-and-drop-item__icon--delete__1y2V-","drag-and-drop-item__content":"index-module_drag-and-drop-item__content__fWR6i","drag-and-drop-item__content--inline":"index-module_drag-and-drop-item__content--inline__oSCir","drag-and-drop-item__content--dragged":"index-module_drag-and-drop-item__content--dragged__i-RZX"};

const component$j = Icon => ({
  title,
  children,
  isInline,
  onDragOver,
  onDragEnd,
  onMouseEnter,
  onMouseLeave,
  onDragStart,
  onDragLeave,
  onDrop,
  internalState,
  deleteButton
}) => jsx("li", Object.assign({
  className: classNames(styles$N['drag-and-drop-item']),
  draggable: internalState.draggable,
  onDragEnd: internalState.draggable ? onDragEnd : undefined,
  onDragLeave: internalState.draggable ? onDragLeave : undefined,
  onDragOver: internalState.draggable ? onDragOver : undefined,
  onDragStart: internalState.draggable ? onDragStart : undefined,
  onDrop: onDrop,
  role: "presentation"
}, {
  children: jsxs("div", Object.assign({
    className: classNames(styles$N['drag-and-drop-item__container'], {
      [styles$N['drag-and-drop-item__container--dragged']]: internalState.isActiveDragAndDrop,
      [styles$N['drag-and-drop-item__container--drag-is-on-current-element']]: internalState.isActiveDragAndDrop === false && internalState.isOnCurrentElement,
      [styles$N['drag-and-drop-item__container--inline']]: isInline,
      [styles$N['drag-and-drop-item__container--dragged-inline']]: isInline && internalState.isActiveDragAndDrop
    })
  }, {
    children: [jsxs("div", Object.assign({
      className: styles$N['drag-and-drop-item__header']
    }, {
      children: [jsxs("div", Object.assign({
        className: classNames(styles$N['drag-and-drop-item__left-header'], {
          [styles$N['drag-and-drop-item__left-header--inline']]: isInline,
          [styles$N['drag-and-drop-item__left-header--dragged-inline']]: isInline && internalState.isActiveDragAndDrop,
          [styles$N['drag-and-drop-item__container--drag-is-on-current-element-inline']]: internalState.isActiveDragAndDrop === false && internalState.isOnCurrentElement && isInline
        })
      }, {
        children: [jsx(Icon, {
          className: classNames(styles$N['drag-and-drop-item__icon'], styles$N['drag-and-drop-item__icon--drag'], {
            [styles$N['drag-and-drop-item__icon--inline']]: isInline
          }),
          icon: "ViewListIcon"
        }, void 0), !isInline && jsx("h1", Object.assign({
          className: styles$N['drag-and-drop-item__title'],
          title: title
        }, {
          children: title
        }), void 0)]
      }), void 0), typeof deleteButton !== 'undefined' && !isInline && jsxs("button", Object.assign({
        className: classNames(styles$N['drag-and-drop-item__close-button']),
        draggable: true,
        name: deleteButton.name,
        // eslint-disable-next-line react/jsx-handler-names
        onClick: deleteButton.onDeleteButtonClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        type: "button"
      }, {
        children: [jsx("span", Object.assign({
          className: "sr-only"
        }, {
          children: "Delete list element button"
        }), void 0), jsx(Icon, {
          className: classNames(styles$N['drag-and-drop-item__icon'], styles$N['drag-and-drop-item__icon--delete']),
          icon: "XIcon"
        }, void 0)]
      }), void 0)]
    }), void 0), jsx("div", Object.assign({
      className: classNames(styles$N['drag-and-drop-item__content'], {
        [styles$N['drag-and-drop-item__content--dragged']]: internalState.isActiveDragAndDrop,
        [styles$N['drag-and-drop-item__content--inline']]: isInline
      }),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      role: "presentation"
    }, {
      children: children
    }), void 0)]
  }), void 0)
}), void 0);

var index$U = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$j
});

// eslint-disable-next-line functional/no-let
let currentParentElementIdOfDraggedElement = '';

const onDragStart$1 = (internalState, setInternalState, onDragStart) => event => {
  const {
    parentElement
  } = event.currentTarget;

  if (parentElement === null) {
    return;
  }

  setInternalState(Object.assign(Object.assign({}, internalState), {
    isActiveDragAndDrop: true
  }));

  if (typeof onDragStart !== 'undefined') {
    onDragStart();
  }

  currentParentElementIdOfDraggedElement = parentElement.id;
  event.dataTransfer.setData('text/plain', currentParentElementIdOfDraggedElement);
};

const onDragEnd = (internalState, setInternalState, onDragEnd) => event => {
  event.preventDefault();
  event.stopPropagation();
  setInternalState(Object.assign(Object.assign({}, internalState), {
    isActiveDragAndDrop: false
  }));

  if (typeof onDragEnd !== 'undefined') {
    onDragEnd();
  }
};

const onDragLeave = (internalState, setInternalState, onDragLeave) => event => {
  event.preventDefault();
  event.stopPropagation();
  setInternalState(Object.assign(Object.assign({}, internalState), {
    isOnCurrentElement: false
  }));

  if (typeof onDragLeave !== 'undefined') {
    onDragLeave();
  }
};

const onDragOver$1 = (internalState, setInternalState, onDragOver) => event => {
  event.preventDefault();
  event.stopPropagation();
  const {
    parentElement
  } = event.currentTarget;

  if (parentElement === null) {
    return;
  }

  if (currentParentElementIdOfDraggedElement !== parentElement.id) {
    return;
  }

  setInternalState(Object.assign(Object.assign({}, internalState), {
    isOnCurrentElement: true
  }));

  if (typeof onDragOver !== 'undefined') {
    onDragOver();
  }
};

const onDrop$1 = (internalState, setInternalState, onDrop) => event => {
  setInternalState(Object.assign(Object.assign({}, internalState), {
    isOnCurrentElement: false
  }));
  event.preventDefault();
  event.stopPropagation();
  const {
    parentElement
  } = event.currentTarget;

  if (parentElement === null) {
    return;
  }

  const groupIdOfDraggedElement = event.dataTransfer.getData('text/plain');
  const currentGroupIdOfOverredElement = parentElement.id;

  if (currentGroupIdOfOverredElement !== groupIdOfDraggedElement) {
    return;
  }

  if (typeof onDrop !== 'undefined') {
    onDrop();
  }
};

const onContentMouseEnter = (internalState, setInternalState) => () => {
  setInternalState(Object.assign(Object.assign({}, internalState), {
    draggable: false
  }));
};

const onContentMouseLeave = (internalState, setInternalState) => () => {
  setInternalState(Object.assign(Object.assign({}, internalState), {
    draggable: true
  }));
};

const component$i = Layout => ({
  title: _title = 'Default title',
  children,
  isInline: _isInline = false,
  onDragOver,
  onDragEnd: onDragEnd$1,
  onDragStart,
  onDrop,
  onDragLeave: onDragLeave$1,
  deleteButton
}) => {
  const [internalState, setInternalState] = React__default.useState({
    draggable: true,
    isActiveDragAndDrop: false,
    isOnCurrentElement: false
  });
  return jsx(Layout, Object.assign({
    deleteButton: deleteButton,
    internalState: internalState,
    isInline: _isInline,
    onDragEnd: onDragEnd(internalState, setInternalState, onDragEnd$1),
    onDragLeave: onDragLeave(internalState, setInternalState, onDragLeave$1),
    onDragOver: onDragOver$1(internalState, setInternalState, onDragOver),
    onDragStart: onDragStart$1(internalState, setInternalState, onDragStart),
    onDrop: onDrop$1(internalState, setInternalState, onDrop),
    onMouseEnter: onContentMouseEnter(internalState, setInternalState),
    onMouseLeave: onContentMouseLeave(internalState, setInternalState),
    title: _title
  }, {
    children: children
  }), void 0);
};

var index$T = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$i,
  layout: index$U
});

var entities = /*#__PURE__*/Object.freeze({
  __proto__: null
});

const onDragStart = (position, dragAndDropSetup, setDragAndDropSetup) => {
  setDragAndDropSetup(Object.assign(Object.assign({}, dragAndDropSetup), {
    draggedFrom: position
  }));
};

const onDragOver = (currentPosition, dragAndDropSetup, setDragAndDropSetup) => {
  setDragAndDropSetup(Object.assign(Object.assign({}, dragAndDropSetup), {
    draggedTo: currentPosition
  }));
};

const onDrop = (dragAndDropSetup, setDragAndDropSetup) => {
  if (dragAndDropSetup.draggedFrom === null) {
    return dragAndDropSetup;
  }

  const draggedItem = dragAndDropSetup.updatedOrder[dragAndDropSetup.draggedFrom];
  const updatedList = dragAndDropSetup.updatedOrder.reduce((accumulator, current, index) => {
    if (dragAndDropSetup.draggedFrom === null) {
      return [...accumulator];
    }

    if (draggedItem === current) {
      if (dragAndDropSetup.draggedTo === index) {
        return [...accumulator, draggedItem];
      }

      return [...accumulator];
    }

    if (index === dragAndDropSetup.draggedTo) {
      if (dragAndDropSetup.draggedTo < dragAndDropSetup.draggedFrom) {
        return [...accumulator, draggedItem, current];
      }

      return [...accumulator, current, draggedItem];
    }

    return [...accumulator, current];
  }, []);
  setDragAndDropSetup(Object.assign(Object.assign({}, dragAndDropSetup), {
    updatedOrder: updatedList
  }));
  return {
    draggedFrom: null,
    draggedTo: null,
    updatedOrder: updatedList
  };
};

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onDrop: onDrop
});

var styles$M = {"drag-and-drop__list":"index-module_drag-and-drop__list__ojlsf"};

const component$h = () => ({
  children,
  className,
  dragAndDropGroupIdentifier
}) => {
  return jsx("section", Object.assign({
    className: className
  }, {
    children: jsx("ul", Object.assign({
      className: styles$M['drag-and-drop__list'],
      id: dragAndDropGroupIdentifier
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var index$S = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$h,
  Entities: entities,
  listItem: index$T,
  utils: utils
});

var styles$L = {"error-message":"index-module_error-message__12k4k","error-message--hidden":"index-module_error-message--hidden__JosWj","error-message-group":"index-module_error-message-group__9D9m0","error-message-group--hidden":"index-module_error-message-group--hidden__-huBd","error-message--group":"index-module_error-message--group__XiAzU","error-message--undefined":"index-module_error-message--undefined__tAp8t"};

const ErrorMessage = ({
  children,
  isHidden
}) => jsxs(Fragment, {
  children: [typeof children === 'string' && jsx("strong", Object.assign({
    className: classNames(styles$L['error-message'], {
      [styles$L['error-message--hidden']]: isHidden
    })
  }, {
    children: children
  }), void 0), typeof children === 'object' && jsx("span", Object.assign({
    className: classNames(styles$L['error-message-group'], {
      [styles$L['error-message-group--hidden']]: isHidden
    })
  }, {
    children: children.map(message => jsx("strong", Object.assign({
      className: classNames(styles$L['error-message'], styles$L['error-message--group'])
    }, {
      children: message
    }), message))
  }), void 0), typeof children === 'undefined' && jsx("span", Object.assign({
    className: styles$L['error-message--undefined']
  }, {
    children: children
  }), void 0)]
}, void 0);

var index$R = {"external-link":"index-module_external-link__6uHce","external-link__label":"index-module_external-link__label__8rOJA","external-link__icon":"index-module_external-link__icon__30VJp"};

const component$g = () => ({
  children,
  className,
  url,
  onClick,
  target: _target = '_blank'
}) => jsxs("a", Object.assign({
  className: classNames(className, index$R['external-link']),
  href: url,
  onClick: onClick,
  target: _target
}, {
  children: [jsx("span", Object.assign({
    className: index$R['external-link__label']
  }, {
    children: children
  }), void 0), jsx("span", {
    children: jsx(Component$I, {
      className: index$R['external-link__icon'],
      icon: "ExternalLinkIcon"
    }, void 0)
  }, void 0)]
}), void 0);

var index$Q = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$g
});

var zeplin$8 = {"input-error":"zeplin-module_input-error__VohQP","background":"zeplin-module_background__HkXRq","label":"zeplin-module_label__pv-Jt"};

var custom$b = {"input-error":"custom-module_input-error__CFfRh","background":"custom-module_background__WlrHX","label":"custom-module_label__haNmm","group-label":"custom-module_group-label__e7SsZ"};

const Component$H = ({
  children
}) => jsxs("span", Object.assign({
  className: classNames(zeplin$8['input-error'], custom$b['input-error'])
}, {
  children: [typeof children === 'string' && jsx("strong", Object.assign({
    className: classNames(zeplin$8.background, zeplin$8.label, custom$b.background, custom$b.label)
  }, {
    children: children
  }), void 0), typeof children === 'object' && children.map(message => jsx("strong", Object.assign({
    className: classNames(zeplin$8.background, zeplin$8.label, custom$b.background, custom$b.label, custom$b['group-label'])
  }, {
    children: message
  }), message))]
}), void 0);

var index$P = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$H
});

var zeplin$7 = {"input-label":"zeplin-module_input-label__3wAzM","background":"zeplin-module_background__l3lis","label":"zeplin-module_label__1-cPP","input":"zeplin-module_input__GI8PG","input-side-infos":"zeplin-module_input-side-infos__wm5K0","danger":"zeplin-module_danger__fSCwe"};

var custom$a = {"input-label":"custom-module_input-label__P6iOF","input":"custom-module_input__ZIh8C","background":"custom-module_background__8jw79","label":"custom-module_label__4FbPN","danger":"custom-module_danger__AmuEG","success":"custom-module_success__n11Y-","password":"custom-module_password__SvBxj","icon":"custom-module_icon__d1AUe","icon-success":"custom-module_icon-success__WmiM3","icon-danger":"custom-module_icon-danger__ulPSt","button-icon-password":"custom-module_button-icon-password__kH4pa","input-container":"custom-module_input-container__fgeDT","input-container--error":"custom-module_input-container--error__4TyHL","input-container--block":"custom-module_input-container--block__Bc-z4"};

const Component$G = ({
  identifier,
  state,
  name,
  type,
  onInputBlur,
  onInputChange,
  onInputFocus,
  placeholder,
  sideInfos,
  value
}) => jsx("div", Object.assign({
  className: classNames(custom$a['input-container'], {
    [custom$a['input-container--error']]: typeof sideInfos === 'string' && (state === null || state === void 0 ? void 0 : state.type) === 'error'
  }, {
    [custom$a['input-container--block']]: typeof sideInfos === 'undefined'
  })
}, {
  children: jsxs("span", Object.assign({
    className: classNames(zeplin$7.input, custom$a.input, {
      [zeplin$7.danger]: (state === null || state === void 0 ? void 0 : state.type) === 'error'
    }, {
      [custom$a.danger]: (state === null || state === void 0 ? void 0 : state.type) === 'error'
    }, {
      [custom$a.success]: (state === null || state === void 0 ? void 0 : state.type) === 'success'
    })
  }, {
    children: [jsx("input", {
      className: classNames(zeplin$7.label, zeplin$7.background, custom$a.label, custom$a.background),
      defaultValue: typeof onInputChange === 'undefined' ? value : undefined,
      id: identifier,
      name: name,
      onBlur: onInputBlur,
      onChange: onInputChange,
      onFocus: onInputFocus,
      placeholder: placeholder,
      type: type,
      value: typeof onInputChange === 'undefined' ? undefined : value
    }, void 0), (state === null || state === void 0 ? void 0 : state.type) === 'success' && jsx(Component$I, {
      className: classNames(custom$a.icon, custom$a['icon-success']),
      icon: "CheckIcon"
    }, void 0), (state === null || state === void 0 ? void 0 : state.type) === 'error' && jsx(Component$I, {
      className: classNames(custom$a.icon, custom$a['icon-danger']),
      icon: "ExclamationCircleIcon"
    }, void 0)]
  }), void 0)
}), void 0);

var index$O = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$G
});

const Component$F = ({
  inputIdentifier,
  name,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  sideInfos,
  state,
  type: _type = 'text',
  value
}) => {
  return jsx(Component$G, {
    identifier: inputIdentifier,
    name: name,
    onInputBlur: onBlur,
    onInputChange: onChange,
    onInputFocus: onFocus,
    placeholder: placeholder,
    sideInfos: sideInfos,
    state: state,
    type: _type,
    value: value
  }, void 0);
};

var index$N = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$F,
  input: index$O
});

var zeplin$6 = {"input-select-button":"zeplin-module_input-select-button__SIpfp","background":"zeplin-module_background__ASZk5","danger":"zeplin-module_danger__Tm0fV","label":"zeplin-module_label__LuaWF"};

var custom$9 = {"input-select-button":"custom-module_input-select-button__PgsND","input-select-button--disabled":"custom-module_input-select-button--disabled__KaZC8","background":"custom-module_background__rBgj8","label":"custom-module_label__KooBo","label--disabled":"custom-module_label--disabled__ycFbl","icon-container":"custom-module_icon-container__jIpv-","icon":"custom-module_icon__NDDQU","icon--disabled":"custom-module_icon--disabled__ZPd3k","error-icon":"custom-module_error-icon__3Lm5L","success-icon":"custom-module_success-icon__fvP-A","danger":"custom-module_danger__Vvfqw"};

const Component$E = ({
  inputIdentifier,
  errorMessageIdentifier,
  defaultText,
  onChange,
  children,
  value,
  title,
  isDisabled,
  state
}) => {
  return jsxs("div", Object.assign({
    className: classNames(zeplin$6['input-select-button'], custom$9['input-select-button'], {
      [zeplin$6.danger]: (state === null || state === void 0 ? void 0 : state.type) === 'error',
      [custom$9.danger]: (state === null || state === void 0 ? void 0 : state.type) === 'error',
      [custom$9['input-select-button--disabled']]: isDisabled
    })
  }, {
    children: [jsxs("select", Object.assign({
      "aria-describedby": (state === null || state === void 0 ? void 0 : state.type) === 'error' ? errorMessageIdentifier : undefined,
      "aria-errormessage": (state === null || state === void 0 ? void 0 : state.type) === 'error' ? errorMessageIdentifier : undefined,
      "aria-invalid": (state === null || state === void 0 ? void 0 : state.type) === 'error' ? true : undefined,
      className: classNames(zeplin$6.background, custom$9.background, custom$9.label, {
        [custom$9['label--disabled']]: isDisabled
      }),
      disabled: isDisabled,
      id: inputIdentifier,
      onChange: onChange,
      title: title,
      value: value
    }, {
      children: [typeof defaultText !== 'undefined' && jsx("option", Object.assign({
        value: ""
      }, {
        children: defaultText
      }), void 0), children]
    }), void 0), jsxs("div", Object.assign({
      className: custom$9['icon-container']
    }, {
      children: [(state === null || state === void 0 ? void 0 : state.type) === 'error' && jsx(Component$I, {
        className: classNames(custom$9.icon, custom$9['error-icon']),
        icon: "ExclamationCircleIcon"
      }, void 0), (state === null || state === void 0 ? void 0 : state.type) === 'success' && jsx(Component$I, {
        className: classNames(custom$9.icon, custom$9['success-icon']),
        icon: "CheckIcon"
      }, void 0), jsx(Component$I, {
        className: classNames(custom$9.icon, {
          [custom$9['icon--disabled']]: isDisabled
        }),
        icon: "ChevronDownIcon"
      }, void 0)]
    }), void 0)]
  }), void 0);
};

const Component$D = ({
  value,
  children,
  isDisabled: _isDisabled = false
}) => {
  return jsx("option", Object.assign({
    disabled: _isDisabled,
    value: value
  }, {
    children: children
  }), value);
};

var index$M = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$D
});

const configureState$1 = (defaultText, value, state) => {
  switch (state === null || state === void 0 ? void 0 : state.type) {
    case 'success':
      return {
        defaultText,
        isOpened: false,
        type: 'success',
        value: value !== null && value !== void 0 ? value : ''
      };

    case 'error':
      return {
        defaultText,
        isOpened: false,
        type: 'error',
        value: value !== null && value !== void 0 ? value : ''
      };

    default:
      return {
        defaultText,
        isOpened: false,
        type: 'default',
        value: value !== null && value !== void 0 ? value : ''
      };
  }
};

const onInit$2 = setState => (defaultText, value, state) => {
  setState(configureState$1(defaultText, value, state));
};

const onChange$2 = (state, setState, onChange) => event => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  onChange(event.target.value);
  setState(Object.assign(Object.assign({}, state), {
    value: event.target.value
  }));
};

const configureLayoutState$1 = state => {
  switch (state.type) {
    case 'success':
      return {
        type: 'success'
      };

    case 'error':
      return {
        type: 'error'
      };
  }
};

const component$f = () => ({
  children,
  defaultText,
  state,
  value,
  onChange,
  isDisabled: _isDisabled = false,
  title: _title = value,
  inputIdentifier
}) => {
  const [internalState, setInternalState] = React.useState(configureState$1(defaultText, value, state));
  const errorMessageIdentifier = genericUtils.generateUniqueId();
  React.useEffect(() => {
    onInit$2(setInternalState)(defaultText, value, state);
  }, [defaultText, value, state]);
  return jsx(Component$E, Object.assign({
    defaultText: internalState.defaultText,
    errorMessageIdentifier: errorMessageIdentifier,
    inputIdentifier: inputIdentifier,
    isDisabled: _isDisabled,
    onChange: onChange$2(internalState, setInternalState, onChange),
    state: configureLayoutState$1(internalState),
    title: _title,
    value: internalState.value
  }, {
    children: children
  }), void 0);
};

var index$L = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$f,
  option: index$M
});

var styles$K = {"label":"index-module_label__TdN4d"};

const component$e = () => ({
  children,
  screenReaderOnly: _screenReaderOnly = false,
  inputIdentifier
}) => jsx("label", Object.assign({
  className: classNames(styles$K.label, {
    'sr-only': _screenReaderOnly
  }),
  htmlFor: inputIdentifier
}, {
  children: children
}), void 0);

var index$K = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$e
});

var styles$J = {"fieldset":"index-module_fieldset__2r9KT","fieldset--error":"index-module_fieldset--error__sOwIK"};

const component$d = () => ({
  children,
  legend,
  hasError: _hasError = false,
  className
}) => {
  return jsxs("fieldset", Object.assign({
    className: classNames(styles$J.fieldset, {
      [styles$J['fieldset--error']]: _hasError
    }, className)
  }, {
    children: [jsx("legend", Object.assign({
      hidden: true
    }, {
      children: legend
    }), void 0), children]
  }), void 0);
};

var index$J = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$d,
  errorMessage: index$P,
  input: index$N,
  inputSelect: index$L,
  label: index$K
});

const Component$C = ({
  allowChartUpdate,
  callback,
  containerProps,
  constructorType,
  immutable,
  options,
  updateArgs
}) => {
  var _a, _b;

  const chartComponentReference = React.useRef(null);
  highchartMore(Highcharts);
  exporting(Highcharts);
  noDataToDisplay(Highcharts);
  const rootOptions = Object.assign(Object.assign({}, options), {
    chart: Object.assign(Object.assign({}, options.chart), {
      style: Object.assign(Object.assign({}, (_a = options.chart) === null || _a === void 0 ? void 0 : _a.style), {
        fontFamily: 'Rubik, sans-serif'
      })
    }),
    exporting: Object.assign(Object.assign({}, options.exporting), {
      enabled: ((_b = options.exporting) === null || _b === void 0 ? void 0 : _b.enabled) === true
    })
  });
  return jsx(highchartsReact.default, {
    allowChartUpdate: allowChartUpdate,
    callback: callback,
    constructorType: constructorType,
    containerProps: containerProps,
    highcharts: Highcharts,
    immutable: immutable,
    options: rootOptions,
    ref: chartComponentReference,
    updateArgs: updateArgs
  }, void 0);
};

var index$I = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$C
});

var styles$I = {"icon-rounded-container":"index-module_icon-rounded-container__Bj5ca","icon":"index-module_icon__jS7yW"};

const component$c = () => ({
  icon,
  className
}) => jsx("div", Object.assign({
  className: classNames(styles$I['icon-rounded-container'], className)
}, {
  children: jsx(Component$I, {
    className: classNames(styles$I.icon, icon.className),
    icon: icon.name
  }, void 0)
}), void 0);

var index$H = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$c
});

const Component$B = ({
  className
}) => {
  return jsx("img", {
    alt: "astronaut",
    className: className,
    src: "./images/astronaut.png"
  }, void 0);
};

const Component$A = ({
  className
}) => {
  return jsx("img", {
    alt: "chat",
    className: className,
    src: "./images/chat.png"
  }, void 0);
};

const Component$z = ({
  className
}) => {
  return jsx("img", {
    alt: "technical-support",
    className: className,
    src: "./images/technical-support.png"
  }, void 0);
};

const component$b = () => ({
  className,
  image
}) => {
  switch (image) {
    case 'astronaut':
      return jsx(Component$B, {
        className: className
      }, void 0);

    case 'technical-support':
      return jsx(Component$z, {
        className: className
      }, void 0);

    case 'chat':
      return jsx(Component$A, {
        className: className
      }, void 0);

    default:
      return jsx(Component$z, {
        className: className
      }, void 0);
  }
};

var index$G = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$b
});

var styles$H = {"label":"index-module_label__zkSVk"};

const Label = ({
  children,
  screenReaderOnly: _screenReaderOnly = false,
  htmlFor
}) => jsx("label", Object.assign({
  className: classNames(styles$H.label, {
    'sr-only': _screenReaderOnly
  }),
  htmlFor: htmlFor
}, {
  children: children
}), void 0);

var styles$G = {"li-element":"index-module_li-element__0sWuD","li-element__label":"index-module_li-element__label__FtJ-C"};

const Component$y = ({
  children,
  className
}) => jsx("li", Object.assign({
  className: classNames(styles$G['li-element'], className)
}, {
  children: jsx("span", Object.assign({
    className: styles$G['li-element__label']
  }, {
    children: children
  }), void 0)
}), void 0);

var index$F = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$y
});

var styles$F = {"li-element-icon":"index-module_li-element-icon__9dSUB","li-element-icon__icon":"index-module_li-element-icon__icon__HpZ4D","li-element-icon__label":"index-module_li-element-icon__label__525jb"};

const Component$x = ({
  children,
  className,
  icon
}) => jsxs("li", Object.assign({
  className: classNames(styles$F['li-element-icon'], className)
}, {
  children: [jsx(Component$I, {
    className: classNames(styles$F['li-element-icon__icon'], icon.className),
    icon: icon.name
  }, void 0), jsx("span", Object.assign({
    className: styles$F['li-element-icon__label']
  }, {
    children: children
  }), void 0)]
}), void 0);

var index$E = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$x
});

var styles$E = {"li-element-no-margin":"index-module_li-element-no-margin__WZ-N5","li-element-no-margin__label":"index-module_li-element-no-margin__label__foP-b"};

const Component$w = ({
  children,
  className
}) => jsx("li", Object.assign({
  className: classNames(styles$E['li-element-no-margin'], className),
  title: "li title"
}, {
  children: jsx("span", Object.assign({
    className: styles$E['li-element-no-margin__label']
  }, {
    children: children
  }), void 0)
}), void 0);

var index$D = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$w
});

var styles$D = {"li-element-none":"index-module_li-element-none__EARJc","li-element-none__label":"index-module_li-element-none__label__IqMgy"};

const Component$v = ({
  children,
  className
}) => jsx("li", Object.assign({
  className: classNames(styles$D['li-element-none'], className)
}, {
  children: jsx("span", Object.assign({
    className: styles$D['li-element-none__label']
  }, {
    children: children
  }), void 0)
}), void 0);

var index$C = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$v
});

var styles$C = {"li-element-text":"index-module_li-element-text__VClKU","li-element-text__bullet":"index-module_li-element-text__bullet__RdC-X","li-element-text__label":"index-module_li-element-text__label__AsWd9"};

const Component$u = ({
  children,
  listStyleText
}) => jsxs("li", Object.assign({
  className: styles$C['li-element-text']
}, {
  children: [jsx("span", Object.assign({
    className: classNames(styles$C['li-element-text__bullet'], listStyleText.className)
  }, {
    children: listStyleText.value
  }), void 0), jsx("span", Object.assign({
    className: styles$C['li-element-text__label']
  }, {
    children: children
  }), void 0)]
}), void 0);

var index$B = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$u
});

var styles$B = {"section-list":"index-module_section-list__UdPds","list__title":"index-module_list__title__ARh4a","list":"index-module_list__S-OX4","list--inline":"index-module_list--inline__BPxWA"};

const Component$t = ({
  children,
  className,
  isInline: _isInline = false,
  title
}) => {
  if (typeof title === 'string') {
    return jsxs("section", Object.assign({
      className: classNames(styles$B['section-list'], className)
    }, {
      children: [jsx("h1", Object.assign({
        className: styles$B.list__title
      }, {
        children: title
      }), void 0), jsx("ul", Object.assign({
        className: classNames(styles$B.list, {
          [styles$B['list--inline']]: _isInline
        })
      }, {
        children: children
      }), void 0)]
    }), void 0);
  }

  return jsx("ul", Object.assign({
    className: classNames(styles$B.list, {
      [styles$B['list--inline']]: _isInline
    }, className)
  }, {
    children: children
  }), void 0);
};

var index$A = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$t,
  item: index$F,
  itemWithEmptyBullet: index$C,
  itemWithIconBullet: index$E,
  itemWithNoMargin: index$D,
  itemWithTextBullet: index$B
});

var styles$A = {"logo-agent":"index-module_logo-agent__EUYSC"};

const Component$s = ({
  className
}) => jsxs("svg", Object.assign({
  className: classNames(styles$A['logo-agent'], className),
  id: "Calque_2",
  viewBox: "0 0 955 225",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsxs("defs", {
    children: [jsx("style", {
      children: `.agent-cls-1{fill:url(#dégradé_agent);}.agent-cls-2{fill:#260156;}`
    }, void 0), jsxs("linearGradient", Object.assign({
      gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
      gradientUnits: "userSpaceOnUse",
      id: "d\u00E9grad\u00E9_agent",
      x1: "12.05",
      x2: "263.61",
      y1: "-16.9",
      y2: "200.64"
    }, {
      children: [jsx("stop", {
        offset: "0",
        stopColor: "#22b573"
      }, void 0), jsx("stop", {
        offset: ".19",
        stopColor: "#26b776"
      }, void 0), jsx("stop", {
        offset: ".35",
        stopColor: "#2fbb7e"
      }, void 0), jsx("stop", {
        offset: ".47",
        stopColor: "#37be85"
      }, void 0), jsx("stop", {
        offset: ".67",
        stopColor: "#4fc998"
      }, void 0), jsx("stop", {
        offset: ".91",
        stopColor: "#75dbb8"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#84e2c5"
      }, void 0)]
    }), void 0)]
  }, void 0), jsxs("g", {
    children: [jsx("path", {
      className: "agent-cls-2",
      d: "M954.61,164.56c-.11,.02-.25,0-.33,.05-4.82,3.79-10.61,5.1-16.43,6.08-6.83,1.15-13.73,1.23-20.43-.77-14-4.18-22.15-13.84-25.44-27.83-.72-3.04-.93-6.15-.93-9.27,0-32.44,0-64.88-.02-97.31,0-1.04,.18-1.41,1.34-1.4,7.8,.06,15.6,.05,23.4,0,1.04,0,1.41,.18,1.4,1.34-.06,6.67,0,13.34-.06,20.01-.01,1.11,.33,1.27,1.32,1.27,9.92-.04,19.84-.01,29.76-.04,.86,0,1.22,.11,1.21,1.13-.05,8.03-.05,16.06,0,24.09,0,1-.33,1.15-1.22,1.15-9.96-.03-19.92,0-29.88-.04-.91,0-1.19,.19-1.19,1.16,.03,15.5,.02,31,.03,46.5,0,8.11,5.14,13.4,13.29,13.77,4.2,.19,8.29-.35,12.21-1.9,.41-.16,.89-.27,1.18-.56,1.02-1.02,1.28-.33,1.65,.57,2.91,7.07,5.85,14.12,8.79,21.18,.09,.21,.23,.4,.35,.6v.24Z"
    }, void 0), jsx("path", {
      className: "agent-cls-2",
      d: "M587.69,155.13c-3.14,5.05-7.37,8.43-12.2,11.14-7.3,4.1-15.16,5.47-23.44,4.97-11.98-.72-22.8-4.54-32.21-12.04-11.91-9.49-19.55-21.59-21.79-36.76-2.25-15.25-.29-29.83,8.41-42.9,8.94-13.43,21.26-22.23,37.27-25.37,7.55-1.48,15.18-1.88,22.69,.25,8.74,2.47,16.16,6.96,21.29,14.73,.34-.23,.15-.57,.16-.84,.02-3.48,.05-6.95-.01-10.43-.02-.96,.18-1.27,1.21-1.26,8.08,.05,16.16,.05,24.24,0,1.01,0,1.24,.27,1.23,1.26-.03,32-.02,64-.03,96,0,5.44-.47,10.84-1.62,16.17-2.34,10.88-7,20.59-14.68,28.71-5.83,6.17-13.08,10.13-21.08,12.76-6.42,2.11-13.04,2.99-19.79,3.2-12.54,.38-24.4-2.27-35.66-7.74-3.74-1.82-7.31-3.93-10.77-6.22-.54-.36-.65-.62-.3-1.22,4.38-7.37,8.74-14.75,13.07-22.15,.53-.9,.86-.43,1.34-.07,6.25,4.66,13.06,8.18,20.77,9.63,8.94,1.68,17.74,1.36,26.09-2.73,4.12-2.02,7.31-5.04,9.71-8.97,3.69-6.07,6.2-13.94,6.1-20.11Zm-62.89-43.05c.05,.99,.08,2.17,.21,3.36,.48,4.67,1.75,9.1,4.17,13.12,6.86,11.4,16.56,17.71,30.31,16.62,8.75-.69,15.86-4.54,21.4-11.27,5.37-6.53,6.98-14.28,6.93-22.46-.01-2.28-.22-4.58-.59-6.86-3.25-19.87-23.14-30.45-41.22-24.01-11.22,4-21.23,16.64-21.22,31.49Z"
    }, void 0), jsx("path", {
      className: "agent-cls-2",
      d: "M661.46,125.49c1.21,3,2.81,5.6,4.83,7.93,6.47,7.45,14.72,11.27,24.53,11.83,10.24,.59,19.57-2.26,28.19-7.62,1.01-.63,1.52-.56,2.31,.29,5.16,5.51,10.37,10.98,15.6,16.41,.63,.65,.39,.91-.12,1.36-6.1,5.34-13.13,9.04-20.75,11.65-15.88,5.44-31.79,5.75-47.37-.9-19.77-8.44-31.95-23.39-35.47-44.57-3.27-19.67,2.13-37.04,16.31-51.42,8.17-8.28,17.75-14.15,29.27-16.22,20.09-3.6,38.03,.69,52.75,15.46,8.23,8.26,14,17.97,16.29,29.53,1.66,8.36,1.58,16.73-.32,25.07-.21,.94-.58,1.23-1.58,1.23-27.64-.03-55.28-.03-82.92-.03h-1.57Zm59.92-25.69c-.54-1.63-1.21-3.02-1.94-4.38-7.91-14.52-23.76-19.83-37.4-15.65-9.61,2.95-16.11,9.55-20.08,18.71-.57,1.31-.56,1.31,.86,1.31,19.11,0,38.22,0,57.32,0h1.23Z"
    }, void 0), jsx("path", {
      className: "agent-cls-2",
      d: "M452.52,69.47c0-4.14,.03-7.92-.02-11.7-.01-.85,.14-1.15,1.09-1.14,8.16,.04,16.32,.04,24.47,0,.9,0,1.12,.23,1.12,1.12-.02,36.15-.03,72.29,0,108.44,0,1.03-.32,1.23-1.28,1.22-8.08-.04-16.16-.04-24.23,0-.96,0-1.19-.26-1.18-1.19,.05-3.66,.02-7.32,.02-11.09-.19,.14-.3,.18-.36,.27-5.64,8.48-13.81,13.39-23.56,15.02-18.27,3.06-34.37-2.06-48.02-14.6-8.76-8.05-14.72-17.83-17.12-29.53-3.38-16.46-1.91-32.33,7.49-46.68,9.2-14.05,22.16-22.86,38.87-25.72,7.79-1.33,15.59-1.43,23.23,1.09,6.93,2.29,13.02,5.83,17.59,11.66,.32,.41,.61,.84,.9,1.27,.28,.41,.53,.84,.98,1.55Zm-30.18,9.27c-4.3-.03-7.48,.42-10.59,1.43-13.55,4.4-23.89,19.78-22.12,35.07,.61,5.29,2.04,10.32,4.98,14.74,7.55,11.35,17.91,17.05,31.79,14.91,10.45-1.61,18.08-7.34,22.73-16.77,3.67-7.43,3.98-15.4,2.71-23.43-2.45-15.41-14.94-25.95-29.51-25.95Z"
    }, void 0), jsx("path", {
      className: "agent-cls-2",
      d: "M793.86,69.29c3.4-4.42,7.24-7.81,11.66-10.55,4.98-3.09,10.31-5.1,16.21-5.69,6.15-.61,12.13,.03,18.02,1.74,4.87,1.42,9.32,3.74,13.32,6.82,4.31,3.32,7.79,7.38,10.5,12.12,2.83,4.95,4.58,10.28,5.56,15.85,.3,1.69,.48,3.42,.54,5.15,.69,21.39,.36,42.78,.51,64.17,.02,2.56,.03,5.11,.09,7.67,.02,.69-.2,.86-.87,.86-8.4-.02-16.8-.03-25.2,.01-1.05,0-.9-.56-.9-1.19,0-19.93,.04-39.87-.02-59.8-.02-5.14-.74-10.23-3.02-14.91-3.1-6.36-7.96-10.46-15.15-11.63-6.02-.98-11.84-.54-17.31,2.22-6.32,3.18-10.88,8.06-13.12,14.86-.52,1.57-.82,3.22-.82,4.93,.02,21.49,.01,42.99,.04,64.48,0,.84-.21,1.05-1.05,1.05-8.2-.03-16.4-.03-24.6,0-.88,0-1.03-.28-1.03-1.08,.02-36.19,.02-72.39,0-108.58,0-.9,.21-1.12,1.12-1.12,8.16,.04,16.32,.04,24.48,0,.95,0,1.1,.28,1.09,1.14-.05,3.7-.02,7.41-.02,11.49Z"
    }, void 0)]
  }, void 0), jsx("path", {
    className: "agent-cls-1",
    d: "M283.43,43.43V181.76c0,23.97-19.46,43.34-43.43,43.34h-60.45v-84.68c15.65-1.93,31.07-6.27,45.71-13.19,9.09-4.28,12.98-15.12,8.7-24.21-4.31-9.09-15.15-12.98-24.24-8.7-30.74,14.53-66.06,14.55-96.83,.06-9.12-4.28-19.93-.39-24.21,8.7-4.31,9.12-.39,19.96,8.7,24.24,14.67,6.89,30.12,11.23,45.77,13.13v84.65h-59.7c-23.97,0-43.43-19.37-43.43-43.34V50.35c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.31,.69,0,6.75,0H240.01c23.97,0,43.43,19.34,43.43,43.43Z"
  }, void 0)]
}), void 0);

var styles$z = {"logo-analytics":"index-module_logo-analytics__t1krE"};

const Component$r = ({
  className
}) => jsxs("svg", Object.assign({
  className: classNames(styles$z['logo-analytics'], className),
  id: "Calque_2",
  viewBox: "0 0 1274 225",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsxs("defs", {
    children: [jsx("style", {
      children: `.analytics-cls-1{fill:url(#dégradé_analytics);}.analytics-cls-2{fill:#270157;}`
    }, void 0), jsxs("linearGradient", Object.assign({
      gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
      gradientUnits: "userSpaceOnUse",
      id: "d\u00E9grad\u00E9_analytics",
      x1: "12.05",
      x2: "247.57",
      y1: "-16.9",
      y2: "186.77"
    }, {
      children: [jsx("stop", {
        offset: "0",
        stopColor: "#3d8fbc"
      }, void 0), jsx("stop", {
        offset: ".35",
        stopColor: "#2cadd1"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#08f0ff"
      }, void 0)]
    }), void 0)]
  }, void 0), jsxs("g", {
    children: [jsx("path", {
      className: "analytics-cls-2",
      d: "M831.24,213.65c-.18-.96,.43-1.68,.77-2.47,5.94-13.62,11.86-27.24,17.87-40.83,.74-1.68,.7-3.03-.04-4.7-15.27-34.56-30.49-69.14-45.71-103.72-.38-.86-.9-1.68-1.03-2.71,.75-.39,1.54-.21,2.3-.21,8-.01,15.99,.05,23.99-.05,1.85-.02,2.76,.47,3.53,2.25,10.29,23.57,20.67,47.1,31.05,70.64,.38,.86,.62,1.8,1.45,2.75,.42-.84,.81-1.56,1.13-2.3,10.32-23.65,20.63-47.3,30.94-70.94,.22-.51,.48-1.01,.68-1.53,.23-.62,.66-.84,1.29-.81,.4,.02,.8,0,1.2,0,8.16,0,16.31,0,24.47,.01,.68,0,1.42-.21,2.08,.23,.09,.95-.48,1.67-.82,2.46-22.08,50.5-44.17,100.99-66.25,151.49-.06,.14-.09,.3-.14,.46h-28.79Z"
    }, void 0), jsx("path", {
      className: "analytics-cls-2",
      d: "M452.53,158.05c-5.02,7.28-12.06,11.58-20.29,14.11-6.47,1.99-13.09,1.92-19.72,1.07-21.16-2.72-40.03-17.81-46.74-38.18-5.96-18.09-5.04-35.94,5.19-52.39,9.46-15.21,23.36-24.24,41.22-26.81,9.46-1.36,18.66-.55,27.33,3.86,4.99,2.54,9.34,5.85,12.5,10.56,.17,.25,.29,.57,.96,.57,0-1.86,0-3.73,0-5.61,0-1.76,.01-3.52,0-5.28,0-.69,.26-1.04,.98-1.01,.4,.02,.8,0,1.2,0,7.44,0,14.87,0,22.31,0,2.27,0,2.09-.06,2.09,2.07,0,13.84,0,27.68,0,41.52,0,21.36,0,42.72,0,64.07,0,.48,0,.96,0,1.44-.04,1.74-.04,1.78-1.68,1.78-7.76,.02-15.51-.02-23.27,.03-1.26,0-1.68-.38-1.65-1.64,.07-3.04,.03-6.08,.01-9.12,0-.29,.14-.64-.43-1.04Zm.44-43.78c-.17-3.45-.39-7.04-1.35-10.54-6.33-23.19-33.64-28.86-48.75-16.09-10.58,8.94-14.87,20.32-12.09,34.05,2.59,12.81,15.13,28.06,34.66,25.83,11.83-1.35,22.19-9.58,25.77-21.06,1.22-3.93,1.6-7.97,1.77-12.2Z"
    }, void 0), jsx("path", {
      className: "analytics-cls-2",
      d: "M712.09,70.8c0-3.25,0-6.5,0-9.75,0-2.22-.16-2.1,2.06-2.1,7.6,0,15.19,0,22.79,0,1.69,0,1.69,.04,1.73,1.7,0,.4,0,.8,0,1.2,0,35.04,0,70.07,0,105.11,0,3.2,.37,2.86-2.75,2.87-7.28,.01-14.55,.01-21.83,0-1.96,0-1.97-.02-1.99-1.97-.02-2.72,0-5.44,0-8.16,0-.52,.11-1.08-.14-1.53-.54,0-.65,.32-.83,.56-6.36,8.59-15.09,13.35-25.49,14.57-33.56,3.94-59.35-21.44-63.24-47.84-2.04-13.89-1.06-27.41,5.94-39.8,9.93-17.58,24.98-27.82,45.25-30.03,5.95-.65,11.83-.49,17.59,1.19,8.35,2.44,15.52,6.68,20.93,13.97Zm-.02,42.82c-.1-1.32-.18-3.32-.43-5.3-.19-1.5-.5-3-.89-4.46-6.19-23.17-33.47-29.02-48.67-16.27-10.69,8.96-15.01,20.42-12.16,34.24,2.48,12,13.35,25.05,28.78,25.83,10.58,.54,19.45-3.02,26.27-11.22,5.33-6.4,6.99-14.04,7.1-22.81Z"
    }, void 0), jsx("path", {
      className: "analytics-cls-2",
      d: "M527.46,70.8c.89-.37,1.28-1.2,1.85-1.82,6.79-7.33,14.9-12.47,24.94-13.57,22.34-2.45,40.67,9.86,46.72,30.16,1.49,5.02,2.25,10.14,2.29,15.36,.08,12.16,.08,24.31,.14,36.47,.04,9.84,.11,19.67,.17,29.51,0,.48-.04,.96,0,1.44,.14,1.31-.49,1.58-1.69,1.58-7.92-.05-15.83-.04-23.75,0-1.09,0-1.69-.25-1.56-1.46,.06-.55,0-1.12,0-1.68,0-18.96,0-37.91,0-56.87,0-3.53-.26-7.02-1.08-10.47-2.78-11.67-10.79-17.96-22.82-17.73-8.22,.16-15.02,3.46-20.32,9.72-3.48,4.11-5.21,8.92-5.21,14.34,0,20.24,0,40.47,0,60.71,0,.48,0,.96,0,1.44-.03,1.96-.03,1.98-1.96,1.98-6.24,.01-12.47,0-18.71,0-1.52,0-3.04-.05-4.56,.02-1.06,.05-1.45-.39-1.36-1.4,.04-.48,0-.96,0-1.44,0-35.11,0-70.22,0-105.33,0-3.07-.44-2.71,2.61-2.72,7.2-.02,14.39-.01,21.59,0,2.69,0,2.35-.3,2.37,2.48,.02,2.56,0,5.12,.01,7.68,0,.53-.15,1.11,.29,1.63Z"
    }, void 0), jsx("path", {
      className: "analytics-cls-2",
      d: "M1073.7,115.08c.34-33.13,23.38-53.54,47.77-58.39,14.16-2.81,27.99-1.67,41.26,4.32,6.1,2.76,11.51,6.57,16.35,11.18,1.3,1.24,1.31,1.27,.2,2.67-4.31,5.46-8.64,10.9-12.97,16.35-1.03,1.29-1.07,1.3-2.42,.29-5.77-4.29-12.02-7.63-19.1-9.11-10.86-2.27-21.23-1.22-30.37,5.58-7.38,5.49-12.36,12.68-13.72,21.98-1.03,7.04,.15,13.75,3.82,19.85,7.72,12.86,19.14,18.79,34.13,17.77,9.33-.64,17.39-4.42,24.77-9.93q1.85-1.38,3.24,.35c4.23,5.32,8.45,10.64,12.67,15.98,1.06,1.34,1.06,1.38-.1,2.5-9.24,8.92-20.15,14.51-32.89,16.44-11.25,1.7-22.31,.99-33.12-2.65-20.31-6.84-36.23-26.97-38.81-46.76-.39-3.02-.61-6.04-.7-8.42Z"
    }, void 0), jsx("path", {
      className: "analytics-cls-2",
      d: "M1203.34,138.85c1.1,.28,1.77,1.01,2.54,1.54,8.58,5.83,17.95,8.98,28.41,8.47,2.33-.11,4.6-.52,6.77-1.4,2.96-1.2,5.06-3.31,6.29-6.25,1.55-3.71,.78-6.86-2.25-9.49-1.46-1.27-3.12-2.22-4.86-3.04-3.12-1.47-6.4-2.47-9.73-3.34-6.21-1.62-12.18-3.83-17.66-7.24-7.25-4.51-12.55-10.6-14.95-18.92-5.08-17.6,3.65-34.64,21.19-40.99,11.72-4.24,23.53-3.72,35.26,.16,3.95,1.31,7.71,3.08,11.33,5.14,1.52,.86,1.53,.9,.77,2.33-3.19,5.99-6.4,11.98-9.62,17.96-.79,1.47-.84,1.49-2.3,.67-5.84-3.26-12.06-5.02-18.79-4.85-3.81,.1-7.21,1.35-10.19,3.68-4.25,3.32-4.48,8.54-.6,12.26,1.75,1.69,3.86,2.83,6.06,3.81,3.36,1.51,6.91,2.46,10.47,3.39,5.19,1.37,10.21,3.21,14.89,5.87,7.41,4.22,12.99,10.01,15.66,18.31,1.25,3.88,1.36,7.86,1.23,11.86-.48,14.42-7.8,24.48-20.27,31.02-5.09,2.67-10.75,3.62-16.45,3.87-15.23,.69-29.32-2.84-41.88-11.73-.39-.28-.76-.6-1.17-.83-1.04-.59-1.17-1.25-.57-2.33,1.62-2.93,3.11-5.94,4.66-8.92,1.91-3.67,3.84-7.34,5.75-11.01Z"
    }, void 0), jsx("path", {
      className: "analytics-cls-2",
      d: "M999.51,143.84c1.33,3.18,2.66,6.34,3.97,9.51,1.65,3.98,3.24,8,4.98,11.94,.54,1.22,.37,1.91-.74,2.53-.9,.5-1.7,1.24-2.65,1.62-10.87,4.49-22.13,6.11-33.51,2.74-14.01-4.15-22.02-14.11-25.13-28.19-.69-3.13-.85-6.33-.85-9.54,0-31.6,0-63.2,0-94.8,0-.56,.06-1.13-.01-1.68-.17-1.33,.46-1.61,1.67-1.61,7.6,.04,15.19,.01,22.79,.03,1.62,0,1.65,.05,1.65,1.82,.02,6.08,0,12.16,0,18.24,0,.56,0,1.12,.02,1.68,.02,.56,.3,.88,.89,.87,.56,0,1.12,0,1.68,0,9.2,0,18.39,0,27.59,0,2.34,0,2.07,.05,2.07,2.09,0,7.36,0,14.72,0,22.08,0,2.16-.02,2.17-2.26,2.17-9.12,0-18.23,0-27.35,0-.56,0-1.12,.02-1.68,0-.73-.02-.98,.36-.96,1.03,.02,.48,0,.96,0,1.44,0,14.8,0,29.6,.01,44.4,0,1.36,.03,2.74,.28,4.06,1,5.36,4.76,9.11,10.21,10.14,6.02,1.15,11.74,.13,17.32-2.6Z"
    }, void 0), jsx("path", {
      className: "analytics-cls-2",
      d: "M786.28,91.48c0,25.19,0,50.37,0,75.56,0,3.29,.27,2.83-2.77,2.84-7.27,.02-14.55,.01-21.82,0-1.95,0-1.97-.02-1.98-1.95,0-8.56,0-17.11,0-25.67,0-41.98,0-83.96,0-125.93,0-3.37-.52-2.91,2.88-2.92,7.03-.03,14.07-.02,21.1,0,2.94,0,2.58-.38,2.58,2.51,0,25.19,0,50.37,0,75.56Z"
    }, void 0), jsx("path", {
      className: "analytics-cls-2",
      d: "M1053.97,114.54c0,17.58,0,35.17,0,52.75,0,2.98,.21,2.59-2.52,2.6-7.51,.01-15.02,.01-22.53,0-1.82,0-1.85-.03-1.85-1.84-.01-8.55,0-17.11,0-25.66V62.3c0-.32,0-.64,0-.96,.02-2.43-.33-2.33,2.31-2.33,7.51,0,15.02,0,22.53,0,2.24,0,2.07-.21,2.07,2.05,0,17.82,0,35.65,0,53.47Z"
    }, void 0)]
  }, void 0), jsx("path", {
    className: "analytics-cls-2",
    d: "M1040.31,50.97c-8.4-.06-15.07-6.76-15.06-15.1,0-8.57,7.08-15.5,15.67-15.36,8.31,.13,14.89,7.11,14.92,15.6,.03,8.45-7.69,15.37-15.53,14.86Z"
  }, void 0), jsx("path", {
    className: "analytics-cls-1",
    d: "M283.43,43.43V181.76c0,23.97-19.46,43.34-43.43,43.34h-60.45v-84.68c15.65-1.93,31.07-6.27,45.71-13.19,9.09-4.28,12.98-15.12,8.7-24.21-4.31-9.09-15.15-12.98-24.24-8.7-30.74,14.53-66.06,14.55-96.83,.06-9.12-4.28-19.93-.39-24.21,8.7-4.31,9.12-.39,19.96,8.7,24.24,14.67,6.89,30.12,11.23,45.77,13.13v84.65h-59.7c-23.97,0-43.43-19.37-43.43-43.34V50.35c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.31,.69,0,6.75,0H240.01c23.97,0,43.43,19.34,43.43,43.43Z"
  }, void 0)]
}), void 0);

var styles$y = {"logo-bot":"index-module_logo-bot__2wUE9"};

const Component$q = ({
  className
}) => jsxs("svg", Object.assign({
  className: classNames(styles$y['logo-bot'], className),
  id: "Calque_2",
  viewBox: "0 0 707 225",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsxs("defs", {
    children: [jsx("style", {
      children: `.bot-cls-1{fill:#260156;}.bot-cls-2{fill:url(#dégradé_bot);}`
    }, void 0), jsxs("linearGradient", Object.assign({
      gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
      gradientUnits: "userSpaceOnUse",
      id: "d\u00E9grad\u00E9_bot",
      x1: "12.05",
      x2: "262.98",
      y1: "-16.9",
      y2: "200.09"
    }, {
      children: [jsx("stop", {
        offset: "0",
        stopColor: "#d53b84"
      }, void 0), jsx("stop", {
        offset: ".61",
        stopColor: "#ed5c7a"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#ff7374"
      }, void 0)]
    }), void 0)]
  }, void 0), jsxs("g", {
    children: [jsxs("g", {
      children: [jsx("path", {
        className: "bot-cls-1",
        d: "M389.12,90.42c1.59-2.08,3.09-4.07,4.98-5.75,6.49-5.77,14.06-9.25,22.72-9.89,17.01-1.27,31.95,3.71,44.52,15.37,10.64,9.87,16.64,22.05,18.01,36.5,1.09,11.45-.03,22.64-5.16,33.03-8.49,17.2-22.02,28.37-40.97,32.38-8.4,1.78-16.89,1.99-25.17-.87-6.94-2.4-13.08-6.04-17.49-12.12-.42-.58-.79-1.18-1.21-1.82-.37,.3-.21,.68-.21,1-.01,3.37-.03,6.74,0,10.1,0,.71-.14,.96-.92,.96-8.43-.03-16.85-.03-25.28,0-.67,0-.98-.16-.88-.86,.03-.2,0-.4,0-.6,0-51.32,0-102.64-.03-153.96,0-1.22,.3-1.49,1.5-1.49,8.15,.06,16.29,.05,24.44,0,.97,0,1.17,.28,1.17,1.2-.03,18.48-.02,36.97-.02,55.45v1.37Zm-.02,43.7c.04,.85,.04,2.3,.19,3.73,.15,1.51,.37,3.02,.69,4.51,4.49,20.84,23.44,27.97,38.86,23.6,15.13-4.29,25.7-21.22,23.03-36.74-1.65-9.59-6-17.59-14.16-23.22-14.33-9.89-33.26-6.62-42.97,7.41-4.19,6.05-5.61,12.9-5.65,20.71Z"
      }, void 0), jsx("path", {
        className: "bot-cls-1",
        d: "M558.81,71.2c32.83-.68,61.79,27.77,61.38,61.69-.39,32.2-28.24,60.78-61.95,60.51-32.67-.26-61.13-28.5-60.48-62.58,.61-32.19,28.16-60.23,61.06-59.61Zm34.5,60.91c.38-18.47-15.09-33.85-33.43-34.27-19.74-.46-35.01,15.49-35.33,33.54-.35,19.47,15.73,34.83,34.17,34.94,19.09,.12,34.97-15.66,34.59-34.21Z"
      }, void 0), jsx("path", {
        className: "bot-cls-1",
        d: "M691.81,162.97c2.47,5.95,4.91,11.8,7.35,17.66,.66,1.59,1.27,3.19,1.99,4.75,.32,.7,.14,1.03-.41,1.46-3.54,2.78-7.79,3.89-12.02,4.9-8.72,2.07-17.52,2.44-26.1-.47-12.72-4.31-20.3-13.47-23.65-26.28-.94-3.58-1.19-7.26-1.19-10.96,0-32.39,.01-64.78-.03-97.17,0-1.2,.34-1.42,1.46-1.41,7.82,.05,15.65,.05,23.47,0,1.1,0,1.3,.31,1.29,1.33-.05,6.73,0,13.47-.05,20.2,0,.95,.24,1.17,1.18,1.17,9.99-.04,19.98,0,29.97-.05,.99,0,1.25,.22,1.25,1.23-.05,8.02-.04,16.03,0,24.05,0,.94-.23,1.19-1.18,1.19-9.99-.04-19.98,0-29.97-.05-1.01,0-1.24,.25-1.24,1.24,.03,15.51,.02,31.03,.03,46.54,0,8.21,5.14,13.5,13.4,13.88,3.97,.18,7.83-.3,11.58-1.67,1.02-.37,1.98-.81,2.88-1.57Z"
      }, void 0)]
    }, void 0), jsx("path", {
      className: "bot-cls-2",
      d: "M283.43,43.43V181.76c0,23.97-19.46,43.34-43.43,43.34h-60.45v-84.68c15.65-1.93,31.07-6.27,45.71-13.19,9.09-4.28,12.98-15.12,8.7-24.21-4.31-9.09-15.15-12.98-24.24-8.7-30.74,14.53-66.06,14.55-96.83,.06-9.12-4.28-19.93-.39-24.21,8.7-4.31,9.12-.39,19.96,8.7,24.24,14.67,6.89,30.12,11.23,45.77,13.13v84.65h-59.7c-23.97,0-43.43-19.37-43.43-43.34V50.35c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.31,.69,0,6.75,0H240.01c23.97,0,43.43,19.34,43.43,43.43Z"
    }, void 0)]
  }, void 0), jsxs("g", {
    children: [jsxs("g", {
      children: [jsx("path", {
        className: "bot-cls-1",
        d: "M389.12,90.42c1.59-2.08,3.09-4.07,4.98-5.75,6.49-5.77,14.06-9.25,22.72-9.89,17.01-1.27,31.95,3.71,44.52,15.37,10.64,9.87,16.64,22.05,18.01,36.5,1.09,11.45-.03,22.64-5.16,33.03-8.49,17.2-22.02,28.37-40.97,32.38-8.4,1.78-16.89,1.99-25.17-.87-6.94-2.4-13.08-6.04-17.49-12.12-.42-.58-.79-1.18-1.21-1.82-.37,.3-.21,.68-.21,1-.01,3.37-.03,6.74,0,10.1,0,.71-.14,.96-.92,.96-8.43-.03-16.85-.03-25.28,0-.67,0-.98-.16-.88-.86,.03-.2,0-.4,0-.6,0-51.32,0-102.64-.03-153.96,0-1.22,.3-1.49,1.5-1.49,8.15,.06,16.29,.05,24.44,0,.97,0,1.17,.28,1.17,1.2-.03,18.48-.02,36.97-.02,55.45v1.37Zm-.02,43.7c.04,.85,.04,2.3,.19,3.73,.15,1.51,.37,3.02,.69,4.51,4.49,20.84,23.44,27.97,38.86,23.6,15.13-4.29,25.7-21.22,23.03-36.74-1.65-9.59-6-17.59-14.16-23.22-14.33-9.89-33.26-6.62-42.97,7.41-4.19,6.05-5.61,12.9-5.65,20.71Z"
      }, void 0), jsx("path", {
        className: "bot-cls-1",
        d: "M558.81,71.2c32.83-.68,61.79,27.77,61.38,61.69-.39,32.2-28.24,60.78-61.95,60.51-32.67-.26-61.13-28.5-60.48-62.58,.61-32.19,28.16-60.23,61.06-59.61Zm34.5,60.91c.38-18.47-15.09-33.85-33.43-34.27-19.74-.46-35.01,15.49-35.33,33.54-.35,19.47,15.73,34.83,34.17,34.94,19.09,.12,34.97-15.66,34.59-34.21Z"
      }, void 0), jsx("path", {
        className: "bot-cls-1",
        d: "M691.81,162.97c2.47,5.95,4.91,11.8,7.35,17.66,.66,1.59,1.27,3.19,1.99,4.75,.32,.7,.14,1.03-.41,1.46-3.54,2.78-7.79,3.89-12.02,4.9-8.72,2.07-17.52,2.44-26.1-.47-12.72-4.31-20.3-13.47-23.65-26.28-.94-3.58-1.19-7.26-1.19-10.96,0-32.39,.01-64.78-.03-97.17,0-1.2,.34-1.42,1.46-1.41,7.82,.05,15.65,.05,23.47,0,1.1,0,1.3,.31,1.29,1.33-.05,6.73,0,13.47-.05,20.2,0,.95,.24,1.17,1.18,1.17,9.99-.04,19.98,0,29.97-.05,.99,0,1.25,.22,1.25,1.23-.05,8.02-.04,16.03,0,24.05,0,.94-.23,1.19-1.18,1.19-9.99-.04-19.98,0-29.97-.05-1.01,0-1.24,.25-1.24,1.24,.03,15.51,.02,31.03,.03,46.54,0,8.21,5.14,13.5,13.4,13.88,3.97,.18,7.83-.3,11.58-1.67,1.02-.37,1.98-.81,2.88-1.57Z"
      }, void 0)]
    }, void 0), jsx("path", {
      className: "bot-cls-2",
      d: "M283.43,43.43V181.76c0,23.97-19.46,43.34-43.43,43.34h-60.45v-84.68c15.65-1.93,31.07-6.27,45.71-13.19,9.09-4.28,12.98-15.12,8.7-24.21-4.31-9.09-15.15-12.98-24.24-8.7-30.74,14.53-66.06,14.55-96.83,.06-9.12-4.28-19.93-.39-24.21,8.7-4.31,9.12-.39,19.96,8.7,24.24,14.67,6.89,30.12,11.23,45.77,13.13v84.65h-59.7c-23.97,0-43.43-19.37-43.43-43.34V50.35c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.31,.69,0,6.75,0H240.01c23.97,0,43.43,19.34,43.43,43.43Z"
    }, void 0)]
  }, void 0)]
}), void 0);

var styles$x = {"logo-tolk":"index-module_logo-tolk__3wsgZ"};

const TolkChristmas = ({
  className
}) => jsxs("svg", Object.assign({
  className: classNames(styles$x['logo-tolk'], className),
  fill: "none",
  viewBox: "0 0 164 53",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsx("path", {
    d: "M71.883 43.0295V47.5072C71.883 47.5521 71.8468 47.5883 71.8019 47.5883H68.1427C67.4848 47.578 66.8701 47.4899 66.302 47.3276C66.1103 47.274 65.9255 47.2101 65.7459 47.1393C64.9361 46.8251 64.2229 46.3416 63.6099 45.6923C62.4132 44.4265 61.814 42.8378 61.814 40.928V23.9033H66.2916V27.8076H71.8364C71.8502 27.8076 71.8623 27.8197 71.8623 27.8336V32.3112C71.8623 32.325 71.8502 32.3371 71.8364 32.3371H66.2916V40.46C66.2916 41.2923 66.5247 41.9175 66.9927 42.3336C67.4037 42.698 67.9252 42.9017 68.5624 42.9484C68.6539 42.9553 68.7454 42.9587 68.8421 42.9587C68.963 42.9587 69.0787 42.9553 69.1944 42.9484H71.8019C71.8468 42.9484 71.883 42.9846 71.883 43.0295V43.0295Z",
    fill: "#260259"
  }, void 0), jsx("path", {
    d: "M92.6788 29.6829C90.6136 27.6332 88.1408 26.6127 85.2622 26.6127C82.3836 26.6127 79.9108 27.6349 77.8679 29.6829C75.8182 31.7327 74.7925 34.1951 74.7925 37.0772C74.7925 39.9592 75.8199 42.4338 77.8679 44.499C79.9108 46.5643 82.3801 47.5969 85.2622 47.5969C88.1442 47.5969 90.6136 46.5643 92.6788 44.499C94.7441 42.4338 95.7767 39.961 95.7767 37.0772C95.7767 34.1934 94.7441 31.731 92.6788 29.6829ZM89.4791 41.2388C88.3342 42.3837 86.9354 42.9604 85.2846 42.9604C83.6338 42.9604 82.2402 42.3854 81.0954 41.2388C79.9505 40.0939 79.3737 38.7056 79.3737 37.0772C79.3737 35.4488 79.9488 34.0552 81.0954 32.9086C82.2402 31.7638 83.6338 31.1939 85.2846 31.1939C86.9354 31.1939 88.3342 31.7638 89.4791 32.9086C90.6239 34.0535 91.1938 35.4471 91.1938 37.0772C91.1938 38.7073 90.6239 40.0939 89.4791 41.2388V41.2388Z",
    fill: "#260259"
  }, void 0), jsx("path", {
    d: "M103.765 19.9489H99.286C99.2583 19.9489 99.2324 19.9696 99.2324 19.9972V46.8647C99.2324 46.8923 99.2601 46.9182 99.286 46.9182H103.765C103.793 46.9182 103.814 46.8906 103.814 46.8647V19.9972C103.814 19.9696 103.793 19.9489 103.765 19.9489Z",
    fill: "#260259"
  }, void 0), jsx("path", {
    d: "M125.799 46.8319L119.206 39.5776L116.555 36.6575L118.842 34.1519L124.547 27.8922C124.58 27.8594 124.557 27.8059 124.514 27.8059H118.448C118.438 27.8059 118.42 27.8162 118.415 27.8214L112.387 34.4731V19.9972C112.387 19.9696 112.366 19.9489 112.339 19.9489H107.854C107.826 19.9489 107.806 19.9696 107.806 19.9972V46.8699C107.806 46.8975 107.826 46.9182 107.854 46.9182H112.339C112.366 46.9182 112.387 46.8975 112.387 46.8699V38.8471L113.478 40.0524L114.597 41.2888L119.664 46.9027C119.674 46.9131 119.684 46.9182 119.702 46.9182H125.763C125.806 46.9182 125.827 46.8647 125.801 46.8319H125.799Z",
    fill: "#260259"
  }, void 0), jsx("path", {
    d: "M132.962 43.6114C132.72 43.2143 132.392 42.8913 131.973 42.6496C131.558 42.4078 131.123 42.2835 130.671 42.2835C129.945 42.2835 129.315 42.5408 128.799 43.064C128.277 43.5855 128.013 44.2089 128.013 44.9411C128.013 45.6732 128.277 46.2966 128.799 46.8129C129.315 47.3344 129.944 47.5986 130.671 47.5986C131.398 47.5986 132.026 47.3344 132.548 46.8129C133.064 46.2966 133.328 45.6681 133.328 44.9411C133.328 44.4576 133.204 44.0103 132.962 43.6132V43.6114Z",
    fill: "#260259"
  }, void 0), jsx("path", {
    d: "M149.482 27.8057V30.0488C149.202 29.5273 148.783 29.0542 148.228 28.619C147.674 28.1838 147.023 27.8385 146.277 27.576C145.529 27.3187 144.761 27.184 143.96 27.184C141.147 27.184 138.765 28.1528 136.802 30.0764C134.839 32.0018 133.861 34.4211 133.861 37.336C133.861 40.2508 134.84 42.6925 136.802 44.6542C138.765 46.6176 141.147 47.595 143.96 47.595C145.137 47.595 146.239 47.3152 147.267 46.7609C148.289 46.2066 149.03 45.5297 149.482 44.7285V46.9163H154.063V27.8057H149.482ZM147.918 41.5511C146.875 42.5941 145.595 43.1156 144.067 43.1156C142.539 43.1156 141.297 42.5509 140.238 41.4216C139.18 40.2975 138.631 38.9315 138.598 37.3342C138.631 35.7749 139.178 34.4297 140.238 33.3004C141.299 32.1762 142.573 31.6064 144.067 31.6064C145.561 31.6064 146.875 32.1279 147.918 33.1709C148.961 34.2087 149.482 35.6126 149.482 37.3601C149.482 39.1077 148.961 40.5116 147.918 41.5494V41.5511Z",
    fill: "#260259"
  }, void 0), jsx("path", {
    d: "M162.235 20.0508C161.714 19.5293 161.09 19.2703 160.358 19.2703C159.626 19.3031 159.013 19.5776 158.509 20.0767C158.008 20.5826 157.756 21.1957 157.756 21.9209C157.756 22.6462 158.013 23.2713 158.536 23.7703C159.058 24.2763 159.676 24.5284 160.386 24.5284C161.096 24.5284 161.714 24.2763 162.235 23.7703C162.752 23.2696 163.016 22.6514 163.016 21.9209C163.016 21.1905 162.752 20.5706 162.235 20.0491V20.0508ZM162.622 27.8059H158.143C158.099 27.8059 158.067 27.8439 158.067 27.8871V46.8389C158.067 46.882 158.099 46.92 158.143 46.92H162.622C162.665 46.92 162.703 46.882 162.703 46.8389V27.8871C162.703 27.8439 162.665 27.8059 162.622 27.8059Z",
    fill: "#260259"
  }, void 0), jsx("path", {
    d: "M48.9475 21.4978V45.3849C48.9475 49.524 45.5871 52.8689 41.4479 52.8689H31.0093V38.2462C33.7118 37.9129 36.3746 37.1635 38.9026 35.9685C40.4723 35.2295 41.144 33.3576 40.4049 31.7879C39.6607 30.2182 37.7888 29.5465 36.2191 30.2856C30.9109 32.7947 24.8118 32.7981 19.4984 30.296C17.9235 29.5569 16.0569 30.2286 15.3178 31.7983C14.5735 33.3731 15.2504 35.245 16.8201 35.9841C19.3533 37.1739 22.0213 37.9233 24.7237 38.2514V52.8689H14.4147C10.2755 52.8689 6.9151 49.524 6.9151 45.3849V22.6928C6.9151 22.3751 6.78213 22.0625 6.56628 21.8466L0.365284 15.9945C-0.399695 15.2606 0.11835 14 1.1648 14H41.4445C45.5837 14 48.9441 17.3397 48.9441 21.4996L48.9475 21.4978Z",
    fill: "url(#paint0_linear_675_8021)"
  }, void 0), jsx("rect", {
    fill: "url(#pattern0)",
    height: "18.3808",
    transform: "rotate(23.2561 39.2573 0)",
    width: "25.8423",
    x: "39.2573"
  }, void 0), jsxs("defs", {
    children: [jsx("pattern", Object.assign({
      height: "1",
      id: "pattern0",
      patternContentUnits: "objectBoundingBox",
      width: "1"
    }, {
      children: jsx("use", {
        transform: "translate(0 -0.20297) scale(0.00195312 0.00274598)",
        xlinkHref: "#image0_675_8021"
      }, void 0)
    }), void 0), jsxs("linearGradient", Object.assign({
      gradientUnits: "userSpaceOnUse",
      id: "paint0_linear_675_8021",
      x1: "2.08519",
      x2: "42.7551",
      y1: "11.08",
      y2: "46.25"
    }, {
      children: [jsx("stop", {
        stopColor: "#5C00FF"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#FF3DAD"
      }, void 0)]
    }), void 0), jsx("image", {
      height: "512",
      id: "image0_675_8021",
      width: "512",
      xlinkHref: "data:image/png;base64,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"
    }, void 0)]
  }, void 0)]
}), void 0);

var styles$w = {"logo-tolk":"index-module_logo-tolk__ud-aU"};

const Component$p = ({
  className
}) => jsxs("svg", Object.assign({
  className: classNames(styles$w['logo-tolk'], className),
  id: "Calque_2",
  viewBox: "0 0 948 225",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, {
  children: [jsxs("defs", {
    children: [jsx("style", {
      children: `.tolk-cls-1{fill:url(#linear-gradient);}.tolk-cls-2{fill:#200052;}`
    }, void 0), jsxs("linearGradient", Object.assign({
      gradientTransform: "translate(-.46 -.4) rotate(.03)",
      gradientUnits: "userSpaceOnUse",
      id: "linear-gradient",
      x1: "12.51",
      x2: "248.03",
      y1: "-16.51",
      y2: "187.17"
    }, {
      children: [jsx("stop", {
        offset: "0",
        stopColor: "#5c00ff"
      }, void 0), jsx("stop", {
        offset: "1",
        stopColor: "#ff3dad"
      }, void 0)]
    }), void 0)]
  }, void 0), jsxs("g", {
    children: [jsx("path", {
      className: "tolk-cls-2",
      d: "M420.16,168.36v25.93c-.02,.26-.23,.47-.49,.47h-21.19c-3.81-.07-7.37-.58-10.66-1.53-1.11-.31-2.18-.68-3.22-1.09-4.69-1.82-8.81-4.62-12.37-8.39-6.93-7.34-10.39-16.54-10.38-27.6l.06-98.59h25.93v22.63l32.1,.02c.08,0,.15,.07,.15,.15v25.93c-.01,.08-.08,.15-.17,.15l-32.11-.02-.03,47.04c0,4.82,1.35,8.44,4.06,10.86,2.37,2.11,5.4,3.3,9.09,3.56,.53,.04,1.06,.06,1.62,.06,.7,0,1.37-.02,2.04-.06h15.1c.26,0,.47,.22,.47,.48Z"
    }, void 0), jsx("path", {
      className: "tolk-cls-2",
      d: "M540.63,91.13c-11.95-11.87-26.27-17.8-42.94-17.81-16.69,0-30.99,5.9-42.83,17.76-11.87,11.86-17.83,26.12-17.84,42.81s5.93,31.02,17.79,42.99c11.83,11.97,26.12,17.95,42.81,17.96,16.66,0,30.99-5.96,42.96-17.91,11.97-11.95,17.95-26.27,17.96-42.97s-5.96-30.96-17.91-42.83Zm-18.57,66.91c-6.64,6.63-14.74,9.96-24.3,9.95s-17.62-3.34-24.25-9.98c-6.63-6.64-9.96-14.67-9.95-24.11s3.34-17.5,9.98-24.13c6.64-6.63,14.7-9.93,24.27-9.92,9.56,0,17.66,3.31,24.29,9.95,6.63,6.64,9.93,14.7,9.92,24.14,0,9.44-3.31,17.47-9.95,24.1Z"
    }, void 0), jsx("path", {
      className: "tolk-cls-2",
      d: "M604.86,34.8h-25.94c-.16-.01-.31,.11-.31,.27l-.09,155.59c0,.16,.16,.31,.31,.31h25.94c.16,.01,.28-.14,.28-.3l.09-155.59c0-.16-.12-.28-.28-.28Z"
    }, void 0), jsx("path", {
      className: "tolk-cls-2",
      d: "M732.37,190.55l-38.16-42.03-15.34-16.92,13.24-14.5,33.06-36.23c.19-.19,.06-.5-.19-.5l-35.13-.02c-.06,0-.16,.06-.19,.09l-34.93,38.5,.05-83.84c0-.16-.12-.28-.28-.28h-25.97c-.16-.01-.28,.11-.28,.27l-.09,155.62c0,.16,.12,.28,.28,.28h25.97c.16,.01,.28-.11,.28-.27l.03-46.46,6.32,6.98,6.47,7.17,29.32,32.53c.06,.06,.12,.09,.22,.09l35.1,.02c.25,0,.37-.31,.22-.5Z"
    }, void 0), jsx("path", {
      className: "tolk-cls-2",
      d: "M773.87,171.92c-1.4-2.31-3.3-4.18-5.73-5.58-2.4-1.4-4.92-2.12-7.54-2.12-4.2,0-7.85,1.49-10.84,4.51-3.02,3.02-4.55,6.63-4.55,10.87,0,4.2,1.52,7.85,4.54,10.84,2.99,3.02,6.63,4.55,10.83,4.55s7.85-1.52,10.87-4.54c2.99-2.99,4.52-6.63,4.52-10.84,0-2.8-.71-5.39-2.11-7.69Z"
    }, void 0), jsx("path", {
      className: "tolk-cls-2",
      d: "M869.62,80.45v12.99c-1.63-3.02-4.05-5.76-7.26-8.29-3.21-2.52-6.97-4.52-11.3-6.05-4.33-1.5-8.78-2.28-13.42-2.28-16.29,0-30.09,5.59-41.46,16.73-11.37,11.14-17.05,25.15-17.06,42.03,0,16.88,5.65,31.02,17.01,42.39,11.36,11.37,25.15,17.05,41.44,17.06,6.82,0,13.21-1.61,19.16-4.82,5.92-3.2,10.22-7.13,12.84-11.76v12.67l26.53,.02,.06-110.68-26.53-.02Zm-9.11,79.59c-6.05,6.04-13.46,9.05-22.3,9.05s-16.04-3.28-22.17-9.82c-6.13-6.51-9.3-14.42-9.48-23.67,.19-9.03,3.37-16.81,9.51-23.35,6.14-6.51,13.52-9.8,22.18-9.8s16.25,3.03,22.29,9.08c6.04,6.01,9.05,14.14,9.05,24.27s-3.03,18.25-9.08,24.25Z"
    }, void 0), jsx("path", {
      className: "tolk-cls-2",
      d: "M943.47,35.58c-3.02-3.02-6.63-4.52-10.87-4.52-4.24,.18-7.79,1.77-10.72,4.67-2.9,2.93-4.36,6.48-4.37,10.68s1.49,7.82,4.51,10.72c3.02,2.93,6.6,4.39,10.71,4.4s7.69-1.46,10.72-4.38c2.99-2.89,4.52-6.48,4.52-10.71s-1.52-7.82-4.51-10.84Zm2.22,44.91h-25.94c-.25-.02-.44,.2-.44,.45l-.06,109.75c0,.25,.19,.47,.44,.47h25.94c.25,.02,.47-.2,.47-.45l.06-109.75c0-.25-.22-.47-.47-.47Z"
    }, void 0)]
  }, void 0), jsx("path", {
    className: "tolk-cls-1",
    d: "M283.41,43.59l-.08,138.33c-.01,23.97-19.48,43.33-43.45,43.31l-60.45-.03,.05-84.68c15.65-1.92,31.07-6.25,45.72-13.16,9.09-4.27,12.99-15.11,8.72-24.2-4.3-9.09-15.14-12.99-24.23-8.72-30.75,14.51-66.07,14.52-96.83,0-9.12-4.28-19.93-.4-24.21,8.69-4.31,9.12-.4,19.96,8.69,24.24,14.67,6.9,30.11,11.25,45.77,13.16l-.05,84.65-59.7-.03c-23.97-.01-43.41-19.39-43.4-43.36l.08-131.41c0-1.84-.77-3.65-2.02-4.9L2.11,11.55C-2.31,7.3,.69,0,6.75,0L240.01,.13c23.97,.01,43.42,19.36,43.4,43.45Z"
  }, void 0)]
}), void 0);

const component$a = () => ({
  logo,
  className
}) => {
  switch (logo) {
    case 'bot':
      return jsx(Component$q, {
        className: className
      }, void 0);

    case 'tolk':
      return jsx(Component$p, {
        className: className
      }, void 0);

    case 'analytics':
      return jsx(Component$r, {
        className: className
      }, void 0);

    case 'agent':
      return jsx(Component$s, {
        className: className
      }, void 0);

    case 'christmas-tolk':
      return jsx(TolkChristmas, {
        className: className
      }, void 0);

    default:
      return jsx(Component$p, {
        className: className
      }, void 0);
  }
};

var index$z = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$a
});

var styles$v = {"menu":"index-module_menu__s0EhM","menu__button":"index-module_menu__button__c2CFs","menu__icon-nav":"index-module_menu__icon-nav__y2Zli","menu__icon-nav--link":"index-module_menu__icon-nav--link__m4Rzj","menu__label":"index-module_menu__label__7v9FQ","menu__button--active":"index-module_menu__button--active__iOZp4"};

const Menu$1 = ({
  isActive,
  path,
  icon: _icon = 'CogIcon',
  label,
  onClick,
  url
}) => {
  const clickHandler = () => {
    if (onClick !== undefined && path !== undefined) {
      return onClick(path);
    } else if (onClick !== undefined && path === undefined) {
      return onClick();
    }
  };

  const Tag = typeof url === 'undefined' ? 'button' : 'a';
  return jsx("li", Object.assign({
    className: styles$v.menu
  }, {
    children: jsxs(Tag, Object.assign({
      className: classNames(styles$v.menu__button, {
        [styles$v['menu__button--active']]: isActive === true
      }),
      href: typeof url === 'undefined' ? undefined : url.linkTo,
      onClick: clickHandler(),
      rel: typeof url === 'undefined' ? undefined : 'noreferrer',
      target: typeof url === 'undefined' ? undefined : url.target,
      title: label,
      type: typeof url === 'undefined' ? undefined : 'button'
    }, {
      children: [typeof _icon === 'string' && jsx(Component$I, {
        className: styles$v['menu__icon-nav'],
        icon: _icon
      }, void 0), jsx("h1", Object.assign({
        className: classNames('text-medium-base-gray-700', // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        styles$v.menu__label)
      }, {
        children: label
      }), void 0), typeof url !== 'undefined' && jsx(Component$I, {
        className: classNames(styles$v['menu__icon-nav'], styles$v['menu__icon-nav--link']),
        icon: "ExternalLinkIcon"
      }, void 0)]
    }), void 0)
  }), void 0);
};

const handleSectionOpening = (isOpen, setIsOpen) => () => {
  setIsOpen(!isOpen);
};

var styles$u = {"menu-accordion":"index-module_menu-accordion__b3AUK","menu-accordion__button":"index-module_menu-accordion__button__pbZKr","menu-accordion__icon-nav":"index-module_menu-accordion__icon-nav__0bGDW","menu-accordion__icon-nav--open":"index-module_menu-accordion__icon-nav--open__z4k2D","menu-accordion__label":"index-module_menu-accordion__label__03dAQ","menu-accordion__label--open":"index-module_menu-accordion__label--open__kg36h","menu-accordion__icon-chevron-down":"index-module_menu-accordion__icon-chevron-down__P3vLN","menu-accordion__icon-chevron-down--open":"index-module_menu-accordion__icon-chevron-down--open__isCCK","menu-accordion__list":"index-module_menu-accordion__list__9u7YJ"};

const MenuAccordion$1 = ({
  children,
  icon,
  isSectionOpen,
  label
}) => {
  const [isOpen, setIsOpen] = React.useState(typeof isSectionOpen === 'undefined' ? false : isSectionOpen);
  const handleOnClick = handleSectionOpening(isOpen, setIsOpen);
  return jsxs("li", Object.assign({
    className: styles$u['menu-accordion']
  }, {
    children: [jsxs("button", Object.assign({
      className: styles$u['menu-accordion__button'],
      onClick: handleOnClick,
      type: "button"
    }, {
      children: [typeof icon === 'string' && jsx(Component$I, {
        className: classNames(styles$u['menu-accordion__icon-nav'], {
          [styles$u['menu-accordion__icon-nav--open']]: isOpen
        }),
        icon: icon
      }, void 0), typeof icon !== 'string' && icon, jsx("h1", Object.assign({
        className: classNames('text-medium-base-gray-700', styles$u['menu-accordion__label'], {
          [styles$u['menu-accordion__label--open']]: isOpen
        })
      }, {
        children: label
      }), void 0), jsx(Component$I, {
        className: classNames(styles$u['menu-accordion__icon-chevron-down'], {
          [styles$u['menu-accordion__icon-chevron-down--open']]: isOpen
        }),
        icon: "ChevronDownIcon"
      }, void 0)]
    }), void 0), isOpen && jsx("ul", Object.assign({
      className: styles$u['menu-accordion__list']
    }, {
      children: children
    }), void 0)]
  }), void 0);
};

var styles$t = {"li-element":"index-module_li-element__pG48W","li-element__button":"index-module_li-element__button__V5v5p","li-element__label":"index-module_li-element__label__UMBuT","li-element__button--active":"index-module_li-element__button--active__3p2U-"};

const MenuItemButton$1 = ({
  children,
  isActive,
  path,
  onClick
}) => {
  const clickHandler = () => {
    if (onClick !== undefined && path !== undefined) {
      return onClick(path);
    } else if (onClick !== undefined && path === undefined) {
      return onClick();
    }
  };

  return jsx("li", Object.assign({
    className: styles$t['li-element']
  }, {
    children: jsx("button", Object.assign({
      className: classNames(styles$t['li-element__button'], {
        [styles$t['li-element__button--active']]: isActive === true
      }),
      onClick: clickHandler(),
      type: "button"
    }, {
      children: jsx("span", Object.assign({
        className: classNames('text-regular-base-gray-600', styles$t['li-element__label'])
      }, {
        children: children
      }), void 0)
    }), void 0)
  }), void 0);
};

var styles$s = {"li-element":"index-module_li-element__jMas6","li-element__anchor":"index-module_li-element__anchor__e2LDE","li-element__label":"index-module_li-element__label__br89H"};

const MenuItemLink$1 = ({
  children,
  url
}) => jsx("li", Object.assign({
  className: styles$s['li-element']
}, {
  children: jsx("a", Object.assign({
    className: styles$s['li-element__anchor'],
    href: url.linkTo,
    rel: "noreferrer",
    target: url.target
  }, {
    children: jsx("span", Object.assign({
      className: classNames('text-regular-base-gray-600', styles$s['li-element__label'])
    }, {
      children: children
    }), void 0)
  }), void 0)
}), void 0);

var styles$r = {"navbar":"index-module_navbar__rWKFy","navbar__list":"index-module_navbar__list__WKXvM","navbar__footer":"index-module_navbar__footer__cfI-y"};

const Nav$1 = ({
  children,
  footerContent
}) => jsxs("nav", Object.assign({
  className: classNames(styles$r.navbar)
}, {
  children: [jsx("ul", Object.assign({
    className: styles$r.navbar__list
  }, {
    children: children
  }), void 0), typeof footerContent !== 'undefined' && jsx("div", Object.assign({
    className: styles$r.navbar__footer
  }, {
    children: footerContent
  }), void 0)]
}), void 0);

var navbar = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Menu: Menu$1,
  MenuAccordion: MenuAccordion$1,
  MenuItemButton: MenuItemButton$1,
  MenuItemLink: MenuItemLink$1,
  Nav: Nav$1
});

var styles$q = {"page-content-description":"index-module_page-content-description__urtEA"};

const Component$o = ({
  children
}) => jsx("p", Object.assign({
  className: styles$q['page-content-description']
}, {
  children: children
}), void 0);

var index$y = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$o
});

var styles$p = {"page-content-description":"index-module_page-content-description__tix3u"};

const Component$n = ({
  children
}) => jsx("p", Object.assign({
  className: styles$p['page-content-description']
}, {
  children: children
}), void 0);

var index$x = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$n
});

var styles$o = {"error":"index-module_error__qEe-4","error__message-container":"index-module_error__message-container__z5blE","error__message":"index-module_error__message__MWtE6","error__icon-container":"index-module_error__icon-container__Xfkdc","error__icon-color":"index-module_error__icon-color__lMaVC"};

const component$9 = (Button, Icon) => ({
  className,
  message,
  onButtonClick,
  buttonText
}) => jsxs("div", Object.assign({
  className: classNames(styles$o.error, className)
}, {
  children: [jsxs("div", Object.assign({
    className: styles$o['error__message-container']
  }, {
    children: [jsx("div", Object.assign({
      className: styles$o['error__icon-container']
    }, {
      children: jsx(Icon, {
        className: styles$o['error__icon-color'],
        icon: "ExclamationCircleIcon"
      }, void 0)
    }), void 0), jsx("p", Object.assign({
      className: classNames(styles$o.error__message, 'text-regular-base-dark')
    }, {
      children: message
    }), void 0)]
  }), void 0), jsx(Button, Object.assign({
    isOutlined: true,
    onClick: onButtonClick
  }, {
    children: buttonText
  }), void 0)]
}), void 0);

var index$w = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$9
});

var styles$n = {"loading":"index-module_loading__NpWcW","loading__container":"index-module_loading__container__4PGLa","loading__icon":"index-module_loading__icon__QNtaJ"};

const Component$m = ({
  className
}) => jsx("div", Object.assign({
  className: classNames(styles$n.loading, className)
}, {
  children: jsxs("div", Object.assign({
    className: styles$n.loading__container
  }, {
    children: [jsx(Component$I, {
      className: styles$n.loading__icon,
      icon: "spinner"
    }, void 0), jsx("span", Object.assign({
      className: "sr-only"
    }, {
      children: "Loading"
    }), void 0)]
  }), void 0)
}), void 0);

var index$v = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$m
});

var styles$m = {"page-content-title":"index-module_page-content-title__8X2Uz"};

const Component$l = ({
  children,
  className
}) => jsx("h2", Object.assign({
  className: classNames(styles$m['page-content-title'], className)
}, {
  children: children
}), void 0);

var index$u = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$l
});

var styles$l = {"page-content":"index-module_page-content__-tQXh"};

const Component$k = ({
  children,
  className
}) => jsx("div", Object.assign({
  className: classNames(styles$l['page-content'], className)
}, {
  children: children
}), void 0);

var index$t = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$k,
  describe: index$y,
  empty: index$x,
  error: index$w,
  loading: index$v,
  title: index$u
});

var styles$k = {"error":"index-module_error__6glT6","error__icon":"index-module_error__icon__yURkG","error__message-container":"index-module_error__message-container__IFw2W","error__message":"index-module_error__message__Jv5DJ","error__icon-container":"index-module_error__icon-container__USAPc","error__icon-color":"index-module_error__icon-color__uCSMT"};

const component$8 = (Button, Icon) => ({
  message,
  onButtonClick,
  buttonText
}) => jsxs("div", Object.assign({
  className: styles$k.error
}, {
  children: [jsxs("div", Object.assign({
    className: styles$k['error__message-container']
  }, {
    children: [jsx("div", Object.assign({
      className: styles$k['error__icon-container']
    }, {
      children: jsx(Icon, {
        className: styles$k.error__icon,
        icon: "ExclamationCircleIcon"
      }, void 0)
    }), void 0), jsx("p", Object.assign({
      className: classNames(styles$k.error__message, 'text-regular-base-dark')
    }, {
      children: message
    }), void 0)]
  }), void 0), jsx(Button, Object.assign({
    isOutlined: true,
    onClick: onButtonClick
  }, {
    children: buttonText
  }), void 0)]
}), void 0);

var index$s = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$8
});

var styles$j = {"loading":"index-module_loading__Aw4lv","loading__icon":"index-module_loading__icon__8SHl2"};

const Component$j = () => jsxs("div", Object.assign({
  className: styles$j.loading
}, {
  children: [jsx(Component$I, {
    className: styles$j.loading__icon,
    icon: "spinner"
  }, void 0), jsx("span", Object.assign({
    className: "sr-only"
  }, {
    children: "Loading"
  }), void 0)]
}), void 0);

var index$r = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$j
});

var zeplin$5 = {"label":"zeplin-module_label__ihViI"};

var custom$8 = {"label":"custom-module_label__RlhnD"};

const Component$i = ({
  children,
  className
}) => jsx("h1", Object.assign({
  className: classNames(zeplin$5.label, custom$8.label, className)
}, {
  children: children
}), void 0);

var index$q = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$i
});

var styles$i = {"page-layout":"index-module_page-layout__95c87"};

const Component$h = ({
  children,
  className
}) => jsx("div", Object.assign({
  className: classNames(styles$i['page-layout'], className)
}, {
  children: children
}), void 0);

var index$p = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$h,
  content: index$t,
  error: index$s,
  loading: index$r,
  title: index$q
});

var styles$h = {"radio":"index-module_radio__iJG3X","radio__default-input":"index-module_radio__default-input__GPHgj","radio__input":"index-module_radio__input__7FHYG","radio__control":"index-module_radio__control__KVQYo"};

const component$7 = () => ({
  children,
  isChecked,
  onChange,
  value
}) => {
  const htmlFor = genericUtils.generateUniqueId();
  return jsxs("label", Object.assign({
    className: styles$h.radio,
    htmlFor: htmlFor
  }, {
    children: [jsx("span", {
      children: jsxs("span", Object.assign({
        className: classNames(styles$h.radio__input)
      }, {
        children: [jsx("input", {
          checked: isChecked,
          className: styles$h['radio__default-input'],
          id: htmlFor,
          onChange: onChange(),
          type: "radio",
          value: value
        }, void 0), jsx("span", {
          className: classNames(styles$h.radio__control)
        }, void 0)]
      }), void 0)
    }, void 0), jsx("span", Object.assign({
      className: "text-regular-base-dark"
    }, {
      children: children
    }), void 0)]
  }), void 0);
};

var index$o = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$7
});

var styles$g = {"body-cell":"index-module_body-cell__TnsgW","body-cell__container":"index-module_body-cell__container__931gM","body-cell__container--description":"index-module_body-cell__container--description__swauw","body-cell__children":"index-module_body-cell__children__lhxD3","body-cell__children--description":"index-module_body-cell__children--description__rSbWQ","body-cell__description":"index-module_body-cell__description__lZnhT","body-cell__children--centered":"index-module_body-cell__children--centered__o1KlG"};

const Component$g = ({
  children,
  className,
  description,
  isChildrenCentered: _isChildrenCentered = false
}) => {
  return jsx("td", Object.assign({
    className: classNames(styles$g['body-cell'], className)
  }, {
    children: jsxs("div", Object.assign({
      className: classNames(styles$g['body-cell__container'], {
        [styles$g['body-cell__container--description']]: typeof description === 'string'
      })
    }, {
      children: [jsx("span", Object.assign({
        className: classNames(styles$g['body-cell__children'], styles$g['body-cell__children--description'], {
          [styles$g['body-cell__children--centered']]: _isChildrenCentered
        })
      }, {
        children: children
      }), void 0), typeof description === 'string' && jsx("span", Object.assign({
        className: styles$g['body-cell__description']
      }, {
        children: description
      }), void 0)]
    }), void 0)
  }), void 0);
};

var index$n = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$g
});

const Component$f = ({
  children
}) => jsx("tbody", {
  children: children
}, void 0);

var index$m = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cell: index$n,
  Component: Component$f
});

var zeplin$4 = {"table-title":"zeplin-module_table-title__As-nH","background":"zeplin-module_background__16fGk","title":"zeplin-module_title__6XPJJ"};

var custom$7 = {"table-title":"custom-module_table-title__AA7D3","background":"custom-module_background__qX8Jv","title":"custom-module_title__YriB5"};

const Component$e = ({
  children,
  description
}) => jsx("th", Object.assign({
  abbr: description,
  className: classNames(zeplin$4['table-title'], custom$7['table-title'])
}, {
  children: jsx("span", Object.assign({
    className: classNames(zeplin$4.background, custom$7.background)
  }, {
    children: jsx("span", Object.assign({
      className: classNames(zeplin$4.title, custom$7.title)
    }, {
      children: children
    }), void 0)
  }), void 0)
}), void 0);

var index$l = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$e
});

const Component$d = ({
  children
}) => jsx("thead", {
  children: children
}, void 0);

var index$k = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cell: index$l,
  Component: Component$d
});

var custom$6 = {"table-row":"custom-module_table-row__Azw-J"};

const Component$c = ({
  children
}) => jsx("tr", Object.assign({
  className: custom$6['table-row']
}, {
  children: children
}), void 0);

var index$j = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$c
});

var custom$5 = {"table":"custom-module_table__0NR38"};

const Component$b = ({
  children,
  className
}) => jsx("table", Object.assign({
  className: classNames(custom$5.table, className)
}, {
  children: children
}), void 0);

var index$i = /*#__PURE__*/Object.freeze({
  __proto__: null,
  body: index$m,
  Component: Component$b,
  header: index$k,
  row: index$j
});

var styles$f = {"body-cell":"index-module_body-cell__iCi9X","body-cell__container":"index-module_body-cell__container__Yk9QV","body-cell__container--description":"index-module_body-cell__container--description__-4MQ3","body-cell__children":"index-module_body-cell__children__nlSJp","body-cell__children--description":"index-module_body-cell__children--description__SeiJL","body-cell__description":"index-module_body-cell__description__zzVdT","body-cell__children--centered":"index-module_body-cell__children--centered__PPSnh"};

const CellButton = ({
  children,
  className,
  description,
  isChildrenCentered: _isChildrenCentered = false,
  name,
  value,
  onClick
}) => {
  return jsx("td", Object.assign({
    className: classNames(styles$f['body-cell'], className)
  }, {
    children: jsxs("button", Object.assign({
      className: classNames(styles$f['body-cell__container'], {
        [styles$f['body-cell__container--description']]: typeof description === 'string'
      }),
      name: name,
      onClick: onClick,
      type: "button",
      value: value
    }, {
      children: [jsx("span", Object.assign({
        className: classNames(styles$f['body-cell__children'], styles$f['body-cell__children--description'], {
          [styles$f['body-cell__children--centered']]: _isChildrenCentered
        })
      }, {
        children: children
      }), void 0), typeof description === 'string' && jsx("span", Object.assign({
        className: styles$f['body-cell__description']
      }, {
        children: description
      }), void 0)]
    }), void 0)
  }), void 0);
};

var styles$e = {"text-area":"index-module_text-area__Fkndz","text-area__label":"index-module_text-area__label__su0f8","text-area__label-text":"index-module_text-area__label-text__aoQw0","text-area__text-area":"index-module_text-area__text-area__1E3QP","text-area__text-area--not-resizable":"index-module_text-area__text-area--not-resizable__H03EH","text-area__text-area--error":"index-module_text-area__text-area--error__towlb","text-area__text-area--success":"index-module_text-area__text-area--success__0cRTL","text-area__error-container":"index-module_text-area__error-container__uNPDf","text-area__error":"index-module_text-area__error__WPhXX","text-area__error--visible":"index-module_text-area__error--visible__nVc6m"};

const component$6 = () => ({
  label,
  name,
  labelClassName,
  onTextAreaBlur,
  onTextAreaChange,
  onTextAreaFocus,
  placeholder,
  textAreaClassName,
  readOnly: _readOnly = false,
  value,
  isDisabled,
  isResizable: _isResizable = true,
  state: _state = {
    type: 'default'
  }
}) => {
  const identifier = genericUtils.generateRandomString();
  return jsx("div", Object.assign({
    className: styles$e['text-area']
  }, {
    children: jsxs("label", Object.assign({
      className: classNames(labelClassName, styles$e['text-area__label']),
      htmlFor: identifier
    }, {
      children: [jsx("span", Object.assign({
        className: styles$e['text-area__label-text']
      }, {
        children: label
      }), void 0), jsx("textarea", {
        className: classNames(textAreaClassName, styles$e['text-area__text-area'], {
          [styles$e['text-area__text-area--not-resizable']]: !_isResizable
        }, {
          [styles$e['text-area__text-area--error']]: _state.type === 'error'
        }, {
          [styles$e['text-area__text-area--success']]: _state.type === 'success'
        }),
        disabled: isDisabled,
        id: identifier,
        name: name,
        onBlur: onTextAreaBlur,
        onChange: onTextAreaChange,
        onFocus: onTextAreaFocus,
        placeholder: placeholder,
        readOnly: _readOnly,
        value: value
      }, void 0), jsx("span", Object.assign({
        className: styles$e['text-area__error-container']
      }, {
        children: jsx("strong", Object.assign({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          className: classNames(styles$e['text-area__error'], {
            [styles$e['text-area__error--visible']]: _state.type === 'error' && typeof _state.message === 'string'
          })
        }, {
          children: _state.type === 'error' && typeof _state.message === 'string' ? _state.message : 'Visibility hidden'
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
};

var index$h = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$6
});

var styles$d = {"logo-container":"index-module_logo-container__WxxRb","logo-container__analytics":"index-module_logo-container__analytics__PynUV"};

const component$5 = Logo => () => jsx("div", Object.assign({
  className: styles$d['logo-container']
}, {
  children: jsx(Logo, {
    className: styles$d['logo-container__analytics'],
    logo: "analytics"
  }, void 0)
}), void 0);

var index$g = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$5
});

var styles$c = {"logo-container":"index-module_logo-container__iZ3oz","logo-container__bot":"index-module_logo-container__bot__BIlNF"};

const component$4 = Logo => () => jsx("div", Object.assign({
  className: styles$c['logo-container']
}, {
  children: jsx(Logo, {
    className: styles$c['logo-container__bot'],
    logo: "bot"
  }, void 0)
}), void 0);

var index$f = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$4
});

var styles$b = {"logo-container":"index-module_logo-container__mIYa3","logo-container__tolk":"index-module_logo-container__tolk__-ai1N"};

const component$3 = Logo => () => jsx("div", Object.assign({
  className: styles$b['logo-container']
}, {
  children: jsx(Logo, {
    className: styles$b['logo-container__tolk'],
    logo: "tolk"
  }, void 0)
}), void 0);

var index$e = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$3
});

var styles$a = {"topbar":"index-module_topbar__Kfatu","topbar__containers":"index-module_topbar__containers__MIXa3","topbar__right-container":"index-module_topbar__right-container__Etgff","topbar__left-container":"index-module_topbar__left-container__mXbf5","topbar__dropdown-brand-menu":"index-module_topbar__dropdown-brand-menu__sPVM1","topbar__left-container-jsx-element":"index-module_topbar__left-container-jsx-element__-CbMx","topbar__right-container-jsx-element":"index-module_topbar__right-container-jsx-element__sP7s2"};

const component$2 = () => ({
  className,
  logo,
  leftContainerClassName,
  leftContent,
  rightContainerClassName,
  rightContent,
  tolkMenu,
  menu
}) => jsx("header", Object.assign({
  className: classNames(styles$a.topbar, className)
}, {
  children: jsxs("div", Object.assign({
    className: styles$a.topbar__containers
  }, {
    children: [jsxs("div", Object.assign({
      className: styles$a['topbar__left-container']
    }, {
      children: [logo, typeof leftContent !== 'undefined' && jsx("div", Object.assign({
        className: classNames(styles$a['topbar__left-container-jsx-element'], leftContainerClassName)
      }, {
        children: leftContent
      }), void 0)]
    }), void 0), jsxs("div", Object.assign({
      className: styles$a['topbar__right-container']
    }, {
      children: [typeof rightContent !== 'undefined' && jsx("div", Object.assign({
        className: classNames(styles$a['topbar__right-container-jsx-element'], rightContainerClassName)
      }, {
        children: rightContent
      }), void 0), jsx("div", Object.assign({
        className: styles$a['topbar__dropdown-brand-menu']
      }, {
        children: tolkMenu
      }), void 0), jsx("div", {
        children: menu
      }, void 0)]
    }), void 0)]
  }), void 0)
}), void 0);

var index$d = /*#__PURE__*/Object.freeze({
  __proto__: null,
  analytics: index$g,
  bot: index$f,
  component: component$2,
  tolk: index$e
});

const NUMBER$1 = {
  KILOBYTES: 1024,
  TO_MEGABYTES: 2
};

const onChange$1 = (limit, setState, onChange) => event => {
  const fileList = event.target.files;

  if (fileList === null || fileList !== null && fileList.length > genericUtils.ARRAY.ONE_ITEM_LENGTH) {
    return;
  }

  const file = fileList[genericUtils.ARRAY.FIRST_INDEX];

  if (typeof limit === 'number' && file.size > limit) {
    setState({
      name: 'File size is exceeded',
      size: undefined,
      url: ''
    });
    return;
  }

  if (typeof onChange !== 'undefined') {
    onChange(event);
  }

  setState({
    name: file.name,
    size: (file.size / NUMBER$1.KILOBYTES ** NUMBER$1.TO_MEGABYTES).toFixed(genericUtils.NUMBER.TWO_DIGITS),
    url: URL.createObjectURL(file)
  });
};

var styles$9 = {"upload":"index-module_upload__-xXsE","upload__label":"index-module_upload__label__RnIKG","upload__icon":"index-module_upload__icon__avCHb","upload__input":"index-module_upload__input__4W-A4","upload__preview":"index-module_upload__preview__rqwUi","upload__name":"index-module_upload__name__-oT2q","upload__name--filled":"index-module_upload__name--filled__7zE-o","upload__name--size-exceeded":"index-module_upload__name--size-exceeded__SnsIj","upload__size":"index-module_upload__size__ZRwkz","upload__image":"index-module_upload__image__JLBS8","upload__image--visible":"index-module_upload__image--visible__bT39A"};

const Upload = ({
  accept: _accept = 'accept="image/*',
  children,
  htmlFor,
  name,
  className,
  sizeLimit,
  onChange,
  value,
  url
}) => {
  const [state, setState] = React__default.useState({
    name: typeof value === 'undefined' ? '' : value,
    url: typeof url === 'undefined' ? '' : url
  });
  return jsxs("div", Object.assign({
    className: classNames(styles$9.upload, className)
  }, {
    children: [jsxs("label", Object.assign({
      className: styles$9.upload__label,
      htmlFor: htmlFor
    }, {
      children: [jsx(Icon, {
        className: styles$9.upload__icon,
        icon: "PhotographIcon"
      }, void 0), jsx("span", {
        children: children
      }, void 0)]
    }), void 0), jsx("input", {
      accept: _accept,
      className: styles$9.upload__input,
      id: htmlFor,
      name: name,
      onChange: onChange$1(sizeLimit, setState, typeof onChange === 'undefined' ? undefined : onChange),
      type: "file"
    }, void 0), jsxs("div", Object.assign({
      className: styles$9.upload__preview
    }, {
      children: [jsxs("span", Object.assign({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        className: classNames(styles$9.upload__name, {
          [styles$9['upload__name--filled']]: !genericUtils.isEmpty(state.name),
          [styles$9['upload__name--size-exceeded']]: typeof value === 'undefined' && !genericUtils.isEmpty(state.name) && typeof state.size === 'undefined'
        })
      }, {
        children: [genericUtils.isEmpty(state.name) ? 'No selected file' : state.name, ' ', !genericUtils.isEmpty(state.name) && typeof state.size === 'string' && jsxs("span", Object.assign({
          className: styles$9.upload__size
        }, {
          children: ["(", state.size, " Mo)"]
        }), void 0)]
      }), void 0), jsx("img", {
        alt: genericUtils.isEmpty(state.name) ? '' : state.name,
        className: classNames(styles$9.upload__image, {
          [styles$9['upload__image--visible']]: !genericUtils.isEmpty(state.url)
        }),
        src: state.url
      }, void 0)]
    }), void 0)]
  }), void 0);
};

var styles$8 = {"dropdown-button":"index-module_dropdown-button__i6YD-","dropdown-button__label":"index-module_dropdown-button__label__3x4JX","dropdown-button__icon-chevron-down":"index-module_dropdown-button__icon-chevron-down__v-fkr","dropdown__icon-chevron-down--open":"index-module_dropdown__icon-chevron-down--open__3AtrK","dropdown-button__icon":"index-module_dropdown-button__icon__ACc67","dropdown-button__label--icon":"index-module_dropdown-button__label--icon__nNJwT","dropdown-button--icon-only":"index-module_dropdown-button--icon-only__rNAAh","dropdown-button__icon--icon-only":"index-module_dropdown-button__icon--icon-only__q32Jk"};

const Component$a = ({
  defaultText,
  icon,
  isOpen,
  onClick,
  dropdownReference,
  value
}) => jsxs("button", Object.assign({
  className: classNames(styles$8['dropdown-button'], {
    [styles$8['dropdown-button--icon-only']]: genericUtils.isObject(icon) && icon.type === 'icon-only'
  }),
  onClick: onClick,
  ref: dropdownReference,
  title: defaultText,
  type: "button",
  value: value
}, {
  children: [genericUtils.isObject(icon) && icon.type === 'icon' && jsx(Component$I, {
    className: classNames(styles$8['dropdown-button__icon'], icon.className),
    icon: icon.name
  }, void 0), genericUtils.isObject(icon) && icon.type === 'icon-only' && jsxs(Fragment, {
    children: [jsx(Component$I, {
      className: classNames(styles$8['dropdown-button__icon--icon-only'], icon.className),
      icon: icon.name
    }, void 0), jsx("span", Object.assign({
      className: classNames(styles$8['dropdown-button__label'], 'sr-only')
    }, {
      children: defaultText
    }), void 0)]
  }, void 0), (genericUtils.isObject(icon) && icon.type !== 'icon-only' || !genericUtils.isObject(icon)) && jsx("span", Object.assign({
    className: classNames(styles$8['dropdown-button__label'], 'text-regular-base-gray-700', {
      [styles$8['dropdown-button__label--icon']]: genericUtils.isObject(icon)
    })
  }, {
    children: defaultText
  }), void 0), (genericUtils.isObject(icon) && icon.type !== 'icon-only' || !genericUtils.isObject(icon)) && jsx(Component$I, {
    className: classNames(styles$8['dropdown-button__icon-chevron-down'], {
      [styles$8['dropdown__icon-chevron-down--open']]: isOpen
    }),
    icon: "ChevronDownIcon"
  }, void 0)]
}), void 0);

const handleDropdownOpening = (isOpen, setIsOpen, onClosing, onOpening) => () => {
  if (isOpen === true) {
    setIsOpen(false);

    if (typeof onClosing !== 'undefined') {
      onClosing();
    }
  }

  if (isOpen === false) {
    setIsOpen(true);

    if (typeof onOpening !== 'undefined') {
      onOpening();
    }
  }
};

const clickListener = (dropdownReference, setIsOpen) => event => {
  if (dropdownReference.current && !dropdownReference.current.contains(event.target)) {
    setIsOpen(false);
  }
};

const escapeListener = setIsOpen => event => {
  if (event.code === 'Escape') {
    setIsOpen(false);
  }
};

const Container$4 = ({
  defaultText,
  icon,
  isOpen,
  value,
  onClosing,
  onOpening,
  setIsOpen
}) => {
  const dropdownReference = React.useRef(null);
  const handleClickListener = React.useCallback(event => {
    clickListener(dropdownReference, setIsOpen)(event);
  }, []);
  const handleKeyboardListener = React.useCallback(event => {
    escapeListener(setIsOpen)(event);
  }, []);
  React.useLayoutEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleClickListener);
      document.addEventListener('keyup', handleKeyboardListener);
    } else {
      document.removeEventListener('click', handleClickListener);
      document.removeEventListener('keyup', handleKeyboardListener);
    }
  }, [isOpen]);
  return jsx(Component$a, {
    defaultText: defaultText,
    dropdownReference: dropdownReference,
    icon: icon,
    isOpen: isOpen,
    onClick: handleDropdownOpening(isOpen, setIsOpen, onClosing, onOpening),
    value: value
  }, void 0);
};

var styles$7 = {"dropdown":"index-module_dropdown__CAOjU","dropdown__list":"index-module_dropdown__list__yXn8O","dropdown__list--icon-only":"index-module_dropdown__list--icon-only__MZdzd"};

const Component$9 = ({
  children,
  className,
  defaultText,
  icon,
  isOpen,
  listElementClassName,
  onOpening,
  onClosing,
  setIsOpen,
  value
}) => jsxs("section", Object.assign({
  className: classNames(styles$7.dropdown, className)
}, {
  children: [jsx(Container$4, {
    defaultText: defaultText,
    icon: icon,
    isOpen: isOpen,
    onClosing: onClosing,
    onOpening: onOpening,
    setIsOpen: setIsOpen,
    value: value
  }, void 0), isOpen && jsx("ul", Object.assign({
    className: classNames(styles$7.dropdown__list, listElementClassName, {
      [styles$7['dropdown__list--icon-only']]: genericUtils.isObject(icon) && icon.type === 'icon-only'
    })
  }, {
    children: children
  }), void 0)]
}), void 0);

var styles$6 = {"dropdown-element":"index-module_dropdown-element__Ble9z","dropdown-element__button":"index-module_dropdown-element__button__5VlGf","dropdown-element__icon":"index-module_dropdown-element__icon__r5FbU","dropdown-element__icon--brand":"index-module_dropdown-element__icon--brand__Fll5o"};

const Component$8 = ({
  children,
  className,
  icon,
  onClick,
  path,
  value
}) => {
  const clickHandler = () => {
    if (onClick !== undefined && path !== undefined) {
      return onClick(path);
    } else if (onClick !== undefined && path === undefined) {
      return onClick(value);
    }
  };

  return jsx("li", Object.assign({
    className: classNames(styles$6['dropdown-element'], className)
  }, {
    children: jsxs("button", Object.assign({
      className: styles$6['dropdown-element__button'],
      onClick: clickHandler(),
      title: children,
      type: "button"
    }, {
      children: [genericUtils.isObject(icon) && jsx(Component$I, {
        className: classNames(styles$6['dropdown-element__icon'], {
          [styles$6['dropdown-element__icon--brand']]: icon.name === 'logo:bot' || icon.name === 'logo:agent' || icon.name === 'logo:analytics'
        }, icon.className),
        icon: icon.name
      }, void 0), jsx("span", Object.assign({
        className: "text-regular-base-gray-700"
      }, {
        children: children
      }), void 0)]
    }), void 0)
  }), void 0);
};

var styles$5 = {"dropdown-element":"index-module_dropdown-element__rNAEe","dropdown-element__anchor":"index-module_dropdown-element__anchor__1uUsl","dropdown-element__icon":"index-module_dropdown-element__icon__4qlSd","dropdown-element__icon--brand":"index-module_dropdown-element__icon--brand__uu6q4"};

const Component$7 = ({
  children,
  className,
  icon,
  url
}) => jsx("li", Object.assign({
  className: classNames(styles$5['dropdown-element'], className)
}, {
  children: jsxs("a", Object.assign({
    className: styles$5['dropdown-element__anchor'],
    href: url.linkTo,
    rel: "noreferrer",
    target: url.target
  }, {
    children: [genericUtils.isObject(icon) && jsx(Component$I, {
      className: classNames(styles$5['dropdown-element__icon'], {
        [styles$5['dropdown-element__icon--brand']]: icon.name === 'logo:bot' || icon.name === 'logo:agent' || icon.name === 'logo:analytics'
      }, icon.className),
      icon: icon.name
    }, void 0), jsx("span", Object.assign({
      className: "text-regular-base-gray-700"
    }, {
      children: children
    }), void 0)]
  }), void 0)
}), void 0);

const Container$3 = ({
  children,
  className,
  icon,
  onClick,
  path,
  value,
  url
}) => {
  if (typeof url !== 'undefined') {
    return jsx(Component$7, Object.assign({
      className: className,
      icon: icon,
      url: url
    }, {
      children: children
    }), void 0);
  }

  return jsx(Component$8, Object.assign({
    className: className,
    icon: icon,
    onClick: onClick,
    path: path,
    value: typeof value === 'string' ? value : children
  }, {
    children: children
  }), void 0);
};

var index$c = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Container: Container$3
});

var styles$4 = {"dropdown-footer":"index-module_dropdown-footer__0EwaI","dropdown-footer__button":"index-module_dropdown-footer__button__6-QAX","dropdown-footer__icon":"index-module_dropdown-footer__icon__rZZpt"};

const Component$6 = ({
  children,
  className,
  icon,
  onClick
}) => jsx("li", Object.assign({
  className: classNames(styles$4['dropdown-footer'], className)
}, {
  children: jsxs("button", Object.assign({
    className: styles$4['dropdown-footer__button'],
    onClick: onClick,
    type: "button"
  }, {
    children: [genericUtils.isObject(icon) && jsx(Component$I, {
      className: styles$4['dropdown-footer__icon'],
      icon: icon.name
    }, void 0), jsx("span", Object.assign({
      className: "text-regular-base-danger-500"
    }, {
      children: children
    }), void 0)]
  }), void 0)
}), void 0);

var index$b = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$6
});

var styles$3 = {"dropdown-section":"index-module_dropdown-section__w-Ri9","dropdown-section__list":"index-module_dropdown-section__list__28CgF","dropdown-section__label":"index-module_dropdown-section__label__t9-R9"};

const Component$5 = ({
  children,
  label
}) => jsxs("li", Object.assign({
  className: styles$3['dropdown-section']
}, {
  children: [jsx("span", Object.assign({
    className: classNames(styles$3['dropdown-section__label'], 'label-regular-sm-gray-500')
  }, {
    children: label
  }), void 0), jsx("ul", Object.assign({
    className: styles$3['dropdown-section__list']
  }, {
    children: children
  }), void 0)]
}), void 0);

var index$a = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$5
});

const Container$2 = ({
  children,
  className,
  defaultText,
  icon,
  listElementClassName,
  onClosing,
  onOpening,
  value
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return jsx(Component$9, Object.assign({
    className: className,
    defaultText: defaultText,
    icon: icon,
    isOpen: isOpen,
    listElementClassName: listElementClassName,
    onClosing: onClosing,
    onOpening: onOpening,
    setIsOpen: setIsOpen,
    value: value
  }, {
    children: children
  }), void 0);
};

var index$9 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Container: Container$2,
  element: index$c,
  footerButton: index$b,
  section: index$a
});

var zeplin$3 = {"input-label":"zeplin-module_input-label__sLGvm","background":"zeplin-module_background__yIYOJ","label":"zeplin-module_label__SEKGg","input":"zeplin-module_input__iLwTi","input-side-infos":"zeplin-module_input-side-infos__7EX9J","danger":"zeplin-module_danger__dMzjO"};

var custom$4 = {"input-label":"custom-module_input-label__THAww","input":"custom-module_input__AIUF6","inputError":"custom-module_inputError__jFNcp","background":"custom-module_background__hLMIN","label":"custom-module_label__jdarY","danger":"custom-module_danger__-sXCh","success":"custom-module_success__qP-vr","password":"custom-module_password__nSUM4","icon":"custom-module_icon__tDL-4","icon-success":"custom-module_icon-success__7kAFi","icon-danger":"custom-module_icon-danger__gLVc-","button-icon-password":"custom-module_button-icon-password__czN1c","is-visible":"custom-module_is-visible__aPW-L","input-container":"custom-module_input-container__VWpm2","input-container--error":"custom-module_input-container--error__T8GAM","input-container--block":"custom-module_input-container--block__QiUpB","input-side-infos":"custom-module_input-side-infos__-8FDT"};

const Component$4 = ({
  className,
  identifier,
  state,
  label,
  name,
  type,
  onClickTogglePassword,
  onInputBlur,
  onInputChange,
  onInputFocus,
  placeholder,
  sideInfos,
  showPassword,
  value
}) => jsxs("label", Object.assign({
  className: classNames(zeplin$3['input-label'], custom$4['input-label'], className),
  htmlFor: identifier
}, {
  children: [jsx("div", Object.assign({
    className: classNames(zeplin$3.background, custom$4.background)
  }, {
    children: jsx("span", Object.assign({
      className: classNames(zeplin$3.label, custom$4.label)
    }, {
      children: label
    }), void 0)
  }), void 0), jsxs("div", Object.assign({
    className: classNames(custom$4['input-container'], {
      [custom$4['input-container--error']]: typeof sideInfos === 'string' && (state === null || state === void 0 ? void 0 : state.type) === 'error'
    }, {
      [custom$4['input-container--block']]: typeof sideInfos === 'undefined'
    })
  }, {
    children: [jsxs("span", Object.assign({
      className: classNames(zeplin$3.input, custom$4.input, {
        [custom$4.inputError]: (state === null || state === void 0 ? void 0 : state.type) === 'error'
      }, {
        [zeplin$3.danger]: (state === null || state === void 0 ? void 0 : state.type) === 'error'
      }, {
        [custom$4.danger]: (state === null || state === void 0 ? void 0 : state.type) === 'error'
      }, {
        [custom$4.success]: (state === null || state === void 0 ? void 0 : state.type) === 'success'
      }, {
        [custom$4.password]: showPassword === false && type === 'password' || showPassword === true && type === 'text'
      })
    }, {
      children: [jsx("input", {
        className: classNames(zeplin$3.label, zeplin$3.background, custom$4.label, custom$4.background),
        defaultValue: typeof onInputChange === 'undefined' ? value : undefined,
        id: identifier,
        name: name,
        onBlur: onInputBlur,
        onChange: onInputChange,
        onFocus: onInputFocus,
        placeholder: placeholder,
        type: type,
        value: typeof onInputChange === 'undefined' ? undefined : value
      }, void 0), (state === null || state === void 0 ? void 0 : state.type) === 'success' && jsx(Component$I, {
        className: classNames(custom$4.icon, custom$4['icon-success']),
        icon: "CheckIcon"
      }, void 0), (state === null || state === void 0 ? void 0 : state.type) === 'error' && jsx(Component$I, {
        className: classNames(custom$4.icon, custom$4['icon-danger']),
        icon: "ExclamationCircleIcon"
      }, void 0), jsx("button", Object.assign({
        className: classNames(custom$4['button-icon-password'], {
          [custom$4['is-visible']]: showPassword === false && type === 'password'
        }),
        onClick: onClickTogglePassword,
        type: "button"
      }, {
        children: jsx(Component$I, {
          className: custom$4.icon,
          icon: "EyeIcon"
        }, void 0)
      }), void 0), jsx("button", Object.assign({
        className: classNames(custom$4['button-icon-password'], {
          [custom$4['is-visible']]: showPassword === true && type === 'text'
        }),
        onClick: onClickTogglePassword,
        type: "button"
      }, {
        children: jsx(Component$I, {
          className: custom$4.icon,
          icon: "EyeOffIcon"
        }, void 0)
      }), void 0)]
    }), void 0), typeof sideInfos === 'string' && jsx("p", Object.assign({
      className: classNames(zeplin$3['input-side-infos'], custom$4['input-side-infos'])
    }, {
      children: sideInfos
    }), void 0)]
  }), void 0)]
}), void 0);

var index$8 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$4
});

var zeplin$2 = {"input-error":"zeplin-module_input-error__AASCp","background":"zeplin-module_background__S8994","label":"zeplin-module_label__rD6ir"};

var custom$3 = {"input-error":"custom-module_input-error__UW7Ej","background":"custom-module_background__rwpAw","label":"custom-module_label__lPSTy","group-label":"custom-module_group-label__D2A4N"};

const Component$3 = ({
  children
}) => jsxs("span", Object.assign({
  className: classNames(zeplin$2['input-error'], custom$3['input-error'])
}, {
  children: [typeof children === 'string' && jsx("strong", Object.assign({
    className: classNames(zeplin$2.background, zeplin$2.label, custom$3.background, custom$3.label)
  }, {
    children: children
  }), void 0), typeof children === 'object' && children.map(message => jsx("strong", Object.assign({
    className: classNames(zeplin$2.background, zeplin$2.label, custom$3.background, custom$3.label, custom$3['group-label'])
  }, {
    children: message
  }), message))]
}), void 0);

var index$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component$3
});

const togglePassword = (setInputType, setShowPassword, showPassword, type) => event => {
  event.preventDefault();

  if (type === 'text') {
    setInputType('password');
  } else if (type === 'password') {
    setInputType('text');
  }

  setShowPassword(!showPassword);
};

const Container$1 = ({
  className,
  label,
  name,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  sideInfos,
  state,
  type,
  value
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [inputType, setInputType] = React.useState(type !== null && type !== void 0 ? type : 'text');
  return jsxs(Fragment, {
    children: [jsx(Component$4, {
      className: className,
      identifier: genericUtils.generateUniqueId(),
      label: label,
      name: name,
      onClickTogglePassword: togglePassword(setInputType, setShowPassword, showPassword, inputType),
      onInputBlur: onBlur,
      onInputChange: onChange,
      onInputFocus: onFocus,
      placeholder: placeholder,
      showPassword: showPassword,
      sideInfos: sideInfos,
      state: state,
      type: inputType,
      value: value
    }, void 0), (state === null || state === void 0 ? void 0 : state.type) === 'error' && !genericUtils.isEmpty(state.message) && jsx(Component$3, {
      children: state.message
    }, void 0)]
  }, void 0);
};

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Container: Container$1,
  input: index$8,
  inputErrorMessage: index$7
});

var styles$2 = {"anchor":"index-module_anchor__hN7u4"};

const Component$2 = ({
  label,
  className,
  href,
  onClick
}) => jsx("a", Object.assign({
  className: classNames(className, styles$2.anchor),
  href: href,
  onClick: onClick
}, {
  children: label
}), void 0);

const onClick = (history, path) => event => {
  event.preventDefault();
  history.push(path);
};

const container$2 = reactRouter => ({
  children,
  className,
  path
}) => {
  const history = reactRouter.useHistory();
  return jsx(Component$2, {
    className: className,
    href: path,
    label: children,
    onClick: onClick(history, path)
  }, void 0);
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container$2
});

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

const MuiPickersAdapterContext = /*#__PURE__*/React.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  MuiPickersAdapterContext.displayName = 'MuiPickersAdapterContext';
}

/**
 * @ignore - do not document.
 */
function LocalizationProvider(props) {
  const {
    children,
    dateAdapter: Utils,
    dateFormats,
    dateLibInstance,
    locale
  } = props;
  const utils = React.useMemo(() => new Utils({
    locale,
    formats: dateFormats,
    instance: dateLibInstance
  }), [Utils, locale, dateFormats, dateLibInstance]);
  const defaultDates = React.useMemo(() => {
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  const contextValue = React.useMemo(() => {
    return {
      utils,
      defaultDates
    };
  }, [defaultDates, utils]);
  return /*#__PURE__*/jsx(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,

  /**
   * DateIO adapter class function
   */
  dateAdapter: PropTypes.func.isRequired,

  /**
   * Formats that are used for any child pickers
   */
  dateFormats: PropTypes.shape({
    dayOfMonth: PropTypes.string,
    fullDate: PropTypes.string,
    fullDateTime: PropTypes.string,
    fullDateTime12h: PropTypes.string,
    fullDateTime24h: PropTypes.string,
    fullDateWithWeekday: PropTypes.string,
    fullTime: PropTypes.string,
    fullTime12h: PropTypes.string,
    fullTime24h: PropTypes.string,
    hours12h: PropTypes.string,
    hours24h: PropTypes.string,
    keyboardDate: PropTypes.string,
    keyboardDateTime: PropTypes.string,
    keyboardDateTime12h: PropTypes.string,
    keyboardDateTime24h: PropTypes.string,
    minutes: PropTypes.string,
    month: PropTypes.string,
    monthAndDate: PropTypes.string,
    monthAndYear: PropTypes.string,
    monthShort: PropTypes.string,
    normalDate: PropTypes.string,
    normalDateWithWeekday: PropTypes.string,
    seconds: PropTypes.string,
    shortDate: PropTypes.string,
    weekday: PropTypes.string,
    weekdayShort: PropTypes.string,
    year: PropTypes.string
  }),

  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: PropTypes.any,

  /**
   * Locale for the date library you are using
   */
  locale: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
} : void 0;

var defaultFormats = {
    normalDateWithWeekday: "ddd, MMM D",
    normalDate: "D MMMM",
    shortDate: "MMM D",
    monthAndDate: "MMMM D",
    dayOfMonth: "D",
    year: "YYYY",
    month: "MMMM",
    monthShort: "MMM",
    monthAndYear: "MMMM YYYY",
    weekday: "dddd",
    weekdayShort: "ddd",
    minutes: "mm",
    hours12h: "hh",
    hours24h: "HH",
    seconds: "ss",
    fullTime: "LT",
    fullTime12h: "hh:mm A",
    fullTime24h: "HH:mm",
    fullDate: "ll",
    fullDateWithWeekday: "dddd, LL",
    fullDateTime: "lll",
    fullDateTime12h: "ll hh:mm A",
    fullDateTime24h: "ll HH:mm",
    keyboardDate: "L",
    keyboardDateTime: "L LT",
    keyboardDateTime12h: "L hh:mm A",
    keyboardDateTime24h: "L HH:mm",
};
var MomentUtils = /** @class */ (function () {
    function MomentUtils(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, locale = _b.locale, formats = _b.formats, instance = _b.instance;
        this.lib = "moment";
        this.is12HourCycleInCurrentLocale = function () {
            return /A|a/.test(_this.moment().localeData().longDateFormat("LT"));
        };
        this.getFormatHelperText = function (format) {
            // @see https://github.com/moment/moment/blob/develop/src/lib/format/format.js#L6
            var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})|./g;
            return format
                .match(localFormattingTokens)
                .map(function (token) {
                var firstCharacter = token[0];
                if (firstCharacter === "L" || firstCharacter === ";") {
                    return _this.moment.localeData().longDateFormat(token);
                }
                return token;
            })
                .join("")
                .replace(/a/gi, "(a|p)m")
                .toLocaleLowerCase();
        };
        this.getCurrentLocaleCode = function () {
            return _this.locale || _this.moment.locale();
        };
        this.parseISO = function (isoString) {
            return _this.moment(isoString, true);
        };
        this.toISO = function (value) {
            return value.toISOString();
        };
        this.parse = function (value, format) {
            if (value === "") {
                return null;
            }
            if (_this.locale) {
                return _this.moment(value, format, _this.locale, true);
            }
            return _this.moment(value, format, true);
        };
        this.date = function (value) {
            if (value === null) {
                return null;
            }
            var moment = _this.moment(value);
            moment.locale(_this.locale);
            return moment;
        };
        this.toJsDate = function (value) {
            return value.toDate();
        };
        this.isValid = function (value) {
            return _this.moment(value).isValid();
        };
        this.isNull = function (date) {
            return date === null;
        };
        this.getDiff = function (date, comparing, unit) {
            return date.diff(comparing, unit);
        };
        this.isAfter = function (date, value) {
            return date.isAfter(value);
        };
        this.isBefore = function (date, value) {
            return date.isBefore(value);
        };
        this.isAfterDay = function (date, value) {
            return date.isAfter(value, "day");
        };
        this.isBeforeDay = function (date, value) {
            return date.isBefore(value, "day");
        };
        this.isBeforeYear = function (date, value) {
            return date.isBefore(value, "year");
        };
        this.isAfterYear = function (date, value) {
            return date.isAfter(value, "year");
        };
        this.startOfDay = function (date) {
            return date.clone().startOf("day");
        };
        this.endOfDay = function (date) {
            return date.clone().endOf("day");
        };
        this.format = function (date, formatKey) {
            return _this.formatByString(date, _this.formats[formatKey]);
        };
        this.formatByString = function (date, formatString) {
            var clonedDate = date.clone();
            clonedDate.locale(_this.locale);
            return clonedDate.format(formatString);
        };
        this.formatNumber = function (numberToFormat) {
            return numberToFormat;
        };
        this.getHours = function (date) {
            return date.get("hours");
        };
        this.addSeconds = function (date, count) {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "seconds")
                : date.clone().add(count, "seconds");
        };
        this.addMinutes = function (date, count) {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "minutes")
                : date.clone().add(count, "minutes");
        };
        this.addHours = function (date, count) {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "hours")
                : date.clone().add(count, "hours");
        };
        this.addDays = function (date, count) {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "days")
                : date.clone().add(count, "days");
        };
        this.addWeeks = function (date, count) {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "weeks")
                : date.clone().add(count, "weeks");
        };
        this.addMonths = function (date, count) {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "months")
                : date.clone().add(count, "months");
        };
        this.setHours = function (date, count) {
            return date.clone().hours(count);
        };
        this.getMinutes = function (date) {
            return date.get("minutes");
        };
        this.setMinutes = function (date, count) {
            return date.clone().minutes(count);
        };
        this.getSeconds = function (date) {
            return date.get("seconds");
        };
        this.setSeconds = function (date, count) {
            return date.clone().seconds(count);
        };
        this.getMonth = function (date) {
            return date.get("month");
        };
        this.getDaysInMonth = function (date) {
            return date.daysInMonth();
        };
        this.isSameDay = function (date, comparing) {
            return date.isSame(comparing, "day");
        };
        this.isSameMonth = function (date, comparing) {
            return date.isSame(comparing, "month");
        };
        this.isSameYear = function (date, comparing) {
            return date.isSame(comparing, "year");
        };
        this.isSameHour = function (date, comparing) {
            return date.isSame(comparing, "hour");
        };
        this.setMonth = function (date, count) {
            return date.clone().month(count);
        };
        this.getMeridiemText = function (ampm) {
            if (_this.is12HourCycleInCurrentLocale()) {
                // AM/PM translation only possible in those who have 12 hour cycle in locale.
                return _this.moment.localeData().meridiem(ampm === "am" ? 0 : 13, 0, false);
            }
            return ampm === "am" ? "AM" : "PM"; // fallback for de, ru, ...etc
        };
        this.startOfMonth = function (date) {
            return date.clone().startOf("month");
        };
        this.endOfMonth = function (date) {
            return date.clone().endOf("month");
        };
        this.startOfWeek = function (date) {
            return date.clone().startOf("week");
        };
        this.endOfWeek = function (date) {
            return date.clone().endOf("week");
        };
        this.getNextMonth = function (date) {
            return date.clone().add(1, "month");
        };
        this.getPreviousMonth = function (date) {
            return date.clone().subtract(1, "month");
        };
        this.getMonthArray = function (date) {
            var firstMonth = date.clone().startOf("year");
            var monthArray = [firstMonth];
            while (monthArray.length < 12) {
                var prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(_this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.getYear = function (date) {
            return date.get("year");
        };
        this.setYear = function (date, year) {
            return date.clone().set("year", year);
        };
        this.mergeDateAndTime = function (date, time) {
            return date.hour(time.hour()).minute(time.minute()).second(time.second());
        };
        this.getWeekdays = function () {
            return _this.moment.weekdaysShort(true);
        };
        this.isEqual = function (value, comparing) {
            if (value === null && comparing === null) {
                return true;
            }
            return _this.moment(value).isSame(comparing);
        };
        this.getWeekArray = function (date) {
            var start = date.clone().startOf("month").startOf("week");
            var end = date.clone().endOf("month").endOf("week");
            var count = 0;
            var current = start;
            var nestedWeeks = [];
            while (current.isBefore(end)) {
                var weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = current.clone().add(1, "day");
                count += 1;
            }
            return nestedWeeks;
        };
        this.getYearRange = function (start, end) {
            var startDate = _this.moment(start).startOf("year");
            var endDate = _this.moment(end).endOf("year");
            var years = [];
            var current = startDate;
            while (current.isBefore(endDate)) {
                years.push(current);
                current = current.clone().add(1, "year");
            }
            return years;
        };
        this.isWithinRange = function (date, _a) {
            var start = _a[0], end = _a[1];
            return date.isBetween(start, end, null, "[]");
        };
        this.moment = instance || moment;
        this.locale = locale;
        this.formats = Object.assign({}, defaultFormats, formats);
    }
    return MomentUtils;
}());

var custom$2 = {"date-range__container":"custom-module_date-range__container__QNRWv","date-range__start":"custom-module_date-range__start__YXXap","date-range__icon":"custom-module_date-range__icon__KcEXU"};

const Component$1 = ({
  startProperties,
  endProperties
}) => {
  return jsxs("div", Object.assign({
    className: custom$2['date-range__container']
  }, {
    children: [jsx("input", Object.assign({
      className: custom$2['date-range__start'],
      ref: startProperties.inputRef
    }, startProperties.inputProps), void 0), jsx(Component$I, {
      className: custom$2['date-range__icon'],
      icon: "ArrowRightIcon"
    }, void 0), jsx("input", Object.assign({
      ref: endProperties.inputRef
    }, endProperties.inputProps), void 0)]
  }), void 0);
};

const container$1 = materialUiLicense => ({
  setValue,
  value
}) => {
  LicenseInfo.setLicenseKey(materialUiLicense);
  return jsx(LocalizationProvider, Object.assign({
    dateAdapter: MomentUtils,
    locale: moment.locale('fr')
  }, {
    children: jsx(DateRangePicker, {
      onChange: newValue => {
        const startDate = moment(newValue[genericUtils.ARRAY.FIRST_INDEX]).utc(true).toDate();
        const endDate = moment(newValue[genericUtils.ARRAY.SECOND_INDEX]).utc(true).toDate();
        setValue([startDate, endDate]);
      },
      renderInput: (startProperties, endProperties) => {
        return jsx(Component$1, {
          endProperties: endProperties,
          startProperties: startProperties
        }, void 0);
      },
      value: value
    }, void 0)
  }), void 0);
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container$1
});

const Option = ({
  value,
  children,
  isDisabled: _isDisabled = false
}) => {
  return jsx("option", Object.assign({
    disabled: _isDisabled,
    value: value
  }, {
    children: children
  }), value);
};

var zeplin$1 = {"input-error":"zeplin-module_input-error__5PjOP","background":"zeplin-module_background__RVAqQ","label":"zeplin-module_label__4yGM8"};

var custom$1 = {"input-error":"custom-module_input-error__dqip1","background":"custom-module_background__zsQEb","label":"custom-module_label__0RBBZ"};

const SelectErrorMessage = ({
  identifier,
  children
}) => {
  return jsx("p", Object.assign({
    className: classNames(zeplin$1['input-error'], custom$1['input-error']),
    id: identifier
  }, {
    children: jsx("strong", Object.assign({
      className: classNames(zeplin$1.background, zeplin$1.label, custom$1.background, custom$1.label)
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var zeplin = {"input-label":"zeplin-module_input-label__iB1o8","background":"zeplin-module_background__K15HE","label":"zeplin-module_label__W0pd8","input-select-button":"zeplin-module_input-select-button__hiDEL","danger":"zeplin-module_danger__HXyAH"};

var custom = {"input-label":"custom-module_input-label__mS1Or","background":"custom-module_background__wWzff","label":"custom-module_label__IjQG1","input-select-button":"custom-module_input-select-button__-aeq3","icon-container":"custom-module_icon-container__KUIUJ","icon":"custom-module_icon__--O0P","error-icon":"custom-module_error-icon__aGt4G","success-icon":"custom-module_success-icon__XJwm5","danger":"custom-module_danger__TNPcg"};

const SelectLayout = ({
  inputIdentifier,
  errorMessageIdentifier,
  label,
  defaultText,
  onChange,
  children,
  value,
  state
}) => {
  return jsxs(Fragment, {
    children: [jsx("div", Object.assign({
      className: classNames(zeplin['input-label'], custom['input-label'])
    }, {
      children: jsx("label", Object.assign({
        className: classNames(zeplin.background, custom.background),
        htmlFor: inputIdentifier
      }, {
        children: jsx("span", Object.assign({
          className: classNames(zeplin.label, custom.label)
        }, {
          children: label
        }), void 0)
      }), void 0)
    }), void 0), jsxs("div", Object.assign({
      className: classNames(zeplin['input-select-button'], custom['input-select-button'], {
        [zeplin.danger]: (state === null || state === void 0 ? void 0 : state.type) === 'error',
        [custom.danger]: (state === null || state === void 0 ? void 0 : state.type) === 'error'
      })
    }, {
      children: [jsxs("select", Object.assign({
        "aria-describedby": (state === null || state === void 0 ? void 0 : state.type) === 'error' ? errorMessageIdentifier : undefined,
        "aria-errormessage": (state === null || state === void 0 ? void 0 : state.type) === 'error' ? errorMessageIdentifier : undefined,
        "aria-invalid": (state === null || state === void 0 ? void 0 : state.type) === 'error' ? true : undefined,
        className: classNames(zeplin.background, custom.background, custom.label),
        id: inputIdentifier,
        onChange: onChange,
        value: value
      }, {
        children: [typeof defaultText !== 'undefined' && jsx("option", Object.assign({
          value: ""
        }, {
          children: defaultText
        }), void 0), children]
      }), void 0), jsxs("div", Object.assign({
        className: custom['icon-container']
      }, {
        children: [(state === null || state === void 0 ? void 0 : state.type) === 'error' && jsx(Component$I, {
          className: classNames(custom.icon, custom['error-icon']),
          icon: "ExclamationCircleIcon"
        }, void 0), (state === null || state === void 0 ? void 0 : state.type) === 'success' && jsx(Component$I, {
          className: classNames(custom.icon, custom['success-icon']),
          icon: "CheckIcon"
        }, void 0), jsx(Component$I, {
          className: classNames(custom.icon),
          icon: "ChevronDownIcon"
        }, void 0)]
      }), void 0)]
    }), void 0), (state === null || state === void 0 ? void 0 : state.type) === 'error' && jsx(SelectErrorMessage, Object.assign({
      identifier: errorMessageIdentifier
    }, {
      children: state.message
    }), void 0)]
  }, void 0);
};

const configureState = (label, defaultText, value, state) => {
  switch (state === null || state === void 0 ? void 0 : state.type) {
    case 'success':
      return {
        defaultText,
        isOpened: false,
        label,
        type: 'success',
        value: value !== null && value !== void 0 ? value : ''
      };

    case 'error':
      return {
        defaultText,
        isOpened: false,
        label,
        message: state.message,
        type: 'error',
        value: value !== null && value !== void 0 ? value : ''
      };

    default:
      return {
        defaultText,
        isOpened: false,
        label,
        type: 'default',
        value: value !== null && value !== void 0 ? value : ''
      };
  }
};

const onInit$1 = setState => (label, defaultText, value, state) => {
  setState(configureState(label, defaultText, value, state));
};

const onChange = (state, setState, onChange) => event => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  onChange(event.target.value);
  setState(Object.assign(Object.assign({}, state), {
    value: event.target.value
  }));
};

const configureLayoutState = state => {
  switch (state.type) {
    case 'success':
      return {
        type: 'success'
      };

    case 'error':
      return {
        message: state.message,
        type: 'error'
      };
  }
};

const container = () => ({
  children,
  label,
  defaultText,
  state,
  value,
  onChange: onChange$1
}) => {
  const [internalState, setInternalState] = React.useState(configureState(label, defaultText, value, state));
  const inputIdentifier = genericUtils.generateUniqueId();
  const errorMessageIdentifier = genericUtils.generateUniqueId();
  React.useEffect(() => {
    onInit$1(setInternalState)(label, defaultText, value, state);
  }, [label, defaultText, value, state]);
  return jsx(SelectLayout, Object.assign({
    defaultText: internalState.defaultText,
    errorMessageIdentifier: errorMessageIdentifier,
    inputIdentifier: inputIdentifier,
    label: internalState.label,
    onChange: onChange(internalState, setInternalState, onChange$1),
    state: configureLayoutState(internalState),
    value: internalState.value
  }, {
    children: children
  }), void 0);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container
});

var styles$1 = {"toast":"index-module_toast__CNn0d","toast--fixed":"index-module_toast--fixed__JhaWa","toast--bottom-left":"index-module_toast--bottom-left__wQZry","toast--bottom-right":"index-module_toast--bottom-right__G-U59","toast--bottom-center":"index-module_toast--bottom-center__2uCND","toast--top-left":"index-module_toast--top-left__k13hy","toast--top-right":"index-module_toast--top-right__YbRPk","toast--top-center":"index-module_toast--top-center__iws2Q","toast--with-right-content":"index-module_toast--with-right-content__JgUDA","toast--visible-bottom-left":"index-module_toast--visible-bottom-left__A4buB","toast--visible-bottom-right":"index-module_toast--visible-bottom-right__6SlXY","toast--visible-bottom-center":"index-module_toast--visible-bottom-center__tso2t","toast--visible-top-left":"index-module_toast--visible-top-left__NzZDU","toast--visible-top-right":"index-module_toast--visible-top-right__r8t2B","toast--visible-top-center":"index-module_toast--visible-top-center__e28nh","toast__label":"index-module_toast__label__t3-hJ","toast__icon":"index-module_toast__icon__wzK-d","toast__icon--success":"index-module_toast__icon--success__fHYkm","toast__icon--danger":"index-module_toast__icon--danger__H-RkH","toast__icon--warning":"index-module_toast__icon--warning__kGZoG","toast__icon--info":"index-module_toast__icon--info__BjfDC","toast__icon-success":"index-module_toast__icon-success__eymsl","toast__icon-danger":"index-module_toast__icon-danger__AEQGr","toast__icon-warning":"index-module_toast__icon-warning__LIcWO","toast__icon-info":"index-module_toast__icon-info__4q7RT","toast__label--with-content":"index-module_toast__label--with-content__-oNOL"};

const Component = ({
  children,
  isVisible,
  position: _position = {
    location: 'top-center'
  },
  rightContent,
  type
}) => jsxs("div", Object.assign({
  className: classNames(styles$1.toast, styles$1[`toast--${_position.location}`], {
    [styles$1['toast--fixed']]: genericUtils.isString(_position.location),
    [styles$1[`toast--visible-${_position.location}`]]: isVisible,
    [styles$1['toast--with-right-content']]: typeof rightContent !== 'undefined'
  })
}, {
  children: [jsxs("div", Object.assign({
    className: classNames(styles$1.toast__icon, styles$1[`toast__icon--${type}`])
  }, {
    children: [type === 'success' && jsx(Component$I, {
      className: styles$1['toast__icon-success'],
      icon: "CheckIcon"
    }, void 0), type === 'danger' && jsx(Component$I, {
      className: styles$1['toast__icon-danger'],
      icon: "ExclamationCircleIcon"
    }, void 0), type === 'warning' && jsx(Component$I, {
      className: styles$1['toast__icon-warning'],
      icon: "ExclamationIcon"
    }, void 0), type === 'info' && jsx(Component$I, {
      className: styles$1['toast__icon-info'],
      icon: "InformationCircleIcon"
    }, void 0)]
  }), void 0), jsx("p", Object.assign({
    className: classNames(styles$1.toast__label, {
      [styles$1['toast__label--with-content']]: typeof rightContent !== 'undefined'
    })
  }, {
    children: children
  }), void 0), jsx("div", {
    children: rightContent
  }, void 0)]
}), void 0);

const NUMBER = {
  AUTOHIDE_DELAY: 5000
};

const autoHideDelay = async autoHide => {
  return new Promise(resolve => {
    var _a;

    setTimeout(() => {
      resolve();
    }, (_a = autoHide.delay) !== null && _a !== void 0 ? _a : NUMBER.AUTOHIDE_DELAY);
  });
};

const onInit = (setIsVisible, isMounted, autoHide) => async () => {
  if ((autoHide === null || autoHide === void 0 ? void 0 : autoHide.isActive) === true) {
    await autoHideDelay(autoHide);

    if (isMounted) {
      setIsVisible(true);
    }

    if (typeof autoHide.onHide !== 'undefined') {
      autoHide.onHide();
    }
  }
};

const Container = ({
  autoHide,
  children,
  position,
  rightContent,
  type
}) => {
  const [isVisible, setIsVisible] = React.useState(true);
  React.useEffect(() => {
    let isMounted = true;
    void onInit(setIsVisible, isMounted, autoHide)();
    return () => {
      isMounted = false;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(Component, Object.assign({
    isVisible: isVisible,
    position: position,
    rightContent: rightContent,
    type: type !== null && type !== void 0 ? type : 'info'
  }, {
    children: children
  }), void 0);
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Container: Container
});

var styles = {"toggle":"index-module_toggle__OSA9e","toggle__input-container":"index-module_toggle__input-container__wqOgt","toggle--disabled":"index-module_toggle--disabled__XGH-Z","toggle--checked":"index-module_toggle--checked__MX-IO","toggle--checked-disabled":"index-module_toggle--checked-disabled__14Euk","toggle__switch":"index-module_toggle__switch__wXaw2","toggle__label":"index-module_toggle__label__9cAui"};

const component$1 = () => ({
  children,
  hideLabel,
  identifier,
  isChecked,
  isDisabled,
  onChange,
  value
}) => jsxs("label", Object.assign({
  className: classNames(styles.toggle, {
    [styles['toggle--checked']]: isChecked,
    [styles['toggle--checked-disabled']]: isChecked && isDisabled,
    [styles['toggle--disabled']]: isDisabled
  }),
  htmlFor: identifier
}, {
  children: [jsxs("span", Object.assign({
    className: classNames(styles['toggle__input-container'])
  }, {
    children: [jsx("input", {
      checked: isChecked,
      disabled: isDisabled,
      id: identifier,
      onChange: onChange,
      type: "checkbox",
      value: value
    }, void 0), jsx("span", {
      className: styles.toggle__switch
    }, void 0)]
  }), void 0), jsx("span", Object.assign({
    className: classNames({
      [styles.toggle__label]: !hideLabel,
      'sr-only': hideLabel
    })
  }, {
    children: children
  }), void 0)]
}), void 0);

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component$1
});

const component = ToggleLayout => ({
  children,
  hideLabel: _hideLabel = false,
  isChecked,
  isDisabled: _isDisabled = false,
  onChange,
  value
}) => jsx(ToggleLayout, Object.assign({
  hideLabel: _hideLabel,
  identifier: genericUtils.generateUniqueId(),
  isChecked: isChecked,
  isDisabled: _isDisabled,
  onChange: onChange,
  value: value
}, {
  children: children
}), void 0);

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  component: component,
  toggleLayout: index$1
});

const bannerComponent = (externalLink, internalLink) => component$F(externalLink, internalLink);

const dividerComponent = internalLink => component$k(internalLink);

const externalLinkComponent = () => component$g();

const iconRoundedContainerComponent = () => component$c();

const imageComponent = () => component$b();

const logoComponent = () => component$a();

const pageLayoutComponent = () => Component$h;

const pageLayoutTitleComponent = () => Component$i;

const pageLayoutLoadingComponent = () => Component$j;

const pageLayoutErrorComponent = (button, icon) => component$8(button, icon);

const pageLayoutContentComponent = () => Component$k;

const pageLayoutContentTitleComponent = () => Component$l;

const pageLayoutContentDescribeComponent = () => Component$o;

const pageLayoutContentErrorComponent = (button, icon) => component$9(button, icon);

const pageLayoutContentLoadingComponent = () => Component$m;

const pageLayoutContentEmptyComponent = () => Component$n;

const radioComponent = () => component$7();

const dropdownComponent = () => Container$2;

const dropdownSectionComponent = () => Component$5;

const dropdownElementComponent = () => Container$3;

const dropdownFooterButtonComponent = () => Component$6;

const buttonComponent = () => component$E();

const iconComponent = () => Component$I;

const toggleLayoutComponent = () => component$1();

const toggleComponent = toggleLayout => component(toggleLayout);

const topbarComponent = () => component$2();

const topbarBotComponent = logo => component$4(logo);

const topbarTolkComponent = logo => component$3(logo);

const topbarAnalyticsComponent = logo => component$5(logo);

const tableComponent = () => Component$b;

const tableHeaderComponent = () => Component$d;

const tableHeaderCellComponent = () => Component$e;

const tableRowComponent = () => Component$c;

const tableBodyComponent = () => Component$f;

const tableBodyCellComponent = () => Component$g;

const internalLinkContainer = reactRouter => container$2(reactRouter);

const inputComponent = () => Container$1;

const selectComponent = () => container();

const fieldSetComponent = () => component$d();

const fieldSetLabelComponent = () => component$e();

const fieldSetInputComponent = () => Component$F;

const fieldSetInputSelectComponent = () => component$f();

const fieldSetInputSelectOptionComponent = () => Component$D;

const fieldSetErrorMessageComponent = () => Component$H;

const toastComponent = () => Container;

const textAreaComponent = () => component$6();

const buttonGroupComponent = () => component$C();

const buttonGroupButtonComponent = () => component$D();

const dragAndDropComponent = () => component$h();

const dragAndDropListItemLayoutComponent = icon => component$j(icon);

const dragAndDropListItemComponent = dragAndDropListItemLayout => component$i(dragAndDropListItemLayout);

const listComponent = () => Component$t;

const listItemWithIconComponent = () => Component$x;

const listItemWithNoMarginComponent = () => Component$w;

const listItemWithEmptyBulletComponent = () => Component$v;

const accordionComponent = icon => component$G(icon);

const dataGridHeaderComponent = () => component$o();

const dataGridHeaderCellComponent = () => component$p();

const dataGridBodyComponent = () => component$q();

const dataGridBodyContentRowComponent = () => component$t();

const dataGridBodyContentRowCellComponent = () => component$v();

const dataGridBodyContentRowCellCollapseComponent = () => component$u();

const dataGridSubDataGridComponent = (header, headerCell, body, row, cell) => component$n(header, headerCell, body, row, cell);

const dataGridBodyContentComponent = (row, cell, cellCollapse, subDataGrid) => component$s(row, cell, cellCollapse, subDataGrid);

const dataGridBodyEmptyContentComponent = () => component$r();

const dataGridLayoutComponent = (header, headerCell, body, bodyContent, bodyEmptyContent) => component$m(header, headerCell, body, bodyContent, bodyEmptyContent);

const dataGridComponent = layout => component$l(layout);

/* eslint-disable import/max-dependencies */
const InternalLink = internalLinkContainer(reactRouter);
const ExternalLink = externalLinkComponent();
const Banner = bannerComponent(ExternalLink, InternalLink);
const Button = buttonComponent();
const Divider = dividerComponent(InternalLink);
const Icon = iconComponent();
const IconRoundedContainer = iconRoundedContainerComponent();
const Logo = logoComponent();
const {
  Nav
} = navbar;
const {
  Menu
} = navbar;
const {
  MenuAccordion
} = navbar;
const {
  MenuItemButton
} = navbar;
const {
  MenuItemLink
} = navbar;
const PageLayout = pageLayoutComponent();
const PageLayoutError = pageLayoutErrorComponent(Button, Icon);
const PageLayoutLoading = pageLayoutLoadingComponent();
const PageLayoutContent = pageLayoutContentComponent();
const PageLayoutTitle = pageLayoutTitleComponent();
const PageLayoutContentTitle = pageLayoutContentTitleComponent();
const PageLayoutContentError = pageLayoutContentErrorComponent(Button, Icon);
const PageLayoutContentLoading = pageLayoutContentLoadingComponent();
const PageLayoutContentDescribe = pageLayoutContentDescribeComponent();
const PageLayoutContentEmpty = pageLayoutContentEmptyComponent();
const Radio = radioComponent();
const ToggleLayout = toggleLayoutComponent();
const Toggle = toggleComponent(ToggleLayout);
const Topbar = topbarComponent();
const TopbarBot = topbarBotComponent(Logo);
const TopbarTolk = topbarTolkComponent(Logo);
const TopbarAnalytics = topbarAnalyticsComponent(Logo);
const Dropdown = dropdownComponent();
const DropdownSection = dropdownSectionComponent();
const DropdownElement = dropdownElementComponent();
const DropdownFooterButton = dropdownFooterButtonComponent();
const Table = tableComponent();
const TableHeader = tableHeaderComponent();
const TableHeaderCell = tableHeaderCellComponent();
const TableRow = tableRowComponent();
const TableBody = tableBodyComponent();
const TableBodyCell = tableBodyCellComponent();
const Image = imageComponent();
const Input = inputComponent();
const Select = selectComponent();
const FieldSet = fieldSetComponent();
const FieldSetLabel = fieldSetLabelComponent();
const FieldSetErrorMessage = fieldSetErrorMessageComponent();
const FieldSetInput = fieldSetInputComponent();
const FieldSetInputSelect = fieldSetInputSelectComponent();
const FieldSetInputSelectOption = fieldSetInputSelectOptionComponent();
const TextArea = textAreaComponent();
const Toast = toastComponent();
const ButtonGroup = buttonGroupComponent();
const ButtonGroupButton = buttonGroupButtonComponent();
const DragAndDrop = dragAndDropComponent();
const DragAndDropListItemLayout = dragAndDropListItemLayoutComponent(Icon);
const DragAndDropListItem = dragAndDropListItemComponent(DragAndDropListItemLayout);
const List = listComponent();
const ListItemWithIcon = listItemWithIconComponent();
const ListItemWithNoMargin = listItemWithNoMarginComponent();
const ListItemWithEmptyBullet = listItemWithEmptyBulletComponent();
const Accordion = accordionComponent(Icon);
const DataGridHeader = dataGridHeaderComponent();
const DataGridHeaderCell = dataGridHeaderCellComponent();
const DataGridBody = dataGridBodyComponent();
const DataGridBodyContentRow = dataGridBodyContentRowComponent();
const DataGridBodyContentRowCell = dataGridBodyContentRowCellComponent();
const DataGridBodyContentRowCellCollapse = dataGridBodyContentRowCellCollapseComponent();
const DataGridSubDataGrid = dataGridSubDataGridComponent(DataGridHeader, DataGridHeaderCell, DataGridBody, DataGridBodyContentRow, DataGridBodyContentRowCell);
const DataGridBodyContent = dataGridBodyContentComponent(DataGridBodyContentRow, DataGridBodyContentRowCell, DataGridBodyContentRowCellCollapse, DataGridSubDataGrid);
const DataGridBodyEmptyContent = dataGridBodyEmptyContentComponent();
const DataGridLayout = dataGridLayoutComponent(DataGridHeader, DataGridHeaderCell, DataGridBody, DataGridBodyContent, DataGridBodyEmptyContent);
const DataGrid = dataGridComponent(DataGridLayout);

export { Accordion, Banner, Button, ButtonGroup, ButtonGroupButton, CellButton, DataGrid, Divider, DragAndDrop, DragAndDropListItem, DragAndDropListItemLayout, Dropdown, DropdownElement, DropdownFooterButton, DropdownSection, ErrorMessage, ExternalLink, FieldSet, FieldSetErrorMessage, FieldSetInput, FieldSetInputSelect, FieldSetInputSelectOption, FieldSetLabel, Icon, IconRoundedContainer, Image, Input, InternalLink, Label, List, ListItemWithEmptyBullet, ListItemWithIcon, ListItemWithNoMargin, Logo, Menu, MenuAccordion, MenuItemButton, MenuItemLink, Nav, Option, PageLayout, PageLayoutContent, PageLayoutContentDescribe, PageLayoutContentEmpty, PageLayoutContentError, PageLayoutContentLoading, PageLayoutContentTitle, PageLayoutError, PageLayoutLoading, PageLayoutTitle, Radio, Select, Table, TableBody, TableBodyCell, TableHeader, TableHeaderCell, TableRow, TextArea, Toast, Toggle, Topbar, TopbarAnalytics, TopbarBot, TopbarTolk, Upload, index$1g as accordion, index$1f as banner, index$1d as button, index$1b as buttonGroup, index$15 as chart, index$W as dataGrid, index$4 as dateRangePicker, index$V as divider, index$S as dragAndDrop, index$9 as dropdown, index$Q as externalLink, index$J as fieldSet, index$I as highcharts, index$1e as icon, index$H as iconRoundedContainer, index$G as image, index$6 as input, index$5 as internalLink, index$A as list, index$z as logo, navbar, index$p as pageLayout, index$o as radio, index$3 as select, index$i as table, index$h as textArea, index$2 as toast, index as toggle, index$d as topbar };
